window.PUNK_BUNNY_STORE_LOCATIONS = [
  {
    "id": "pb-0001",
    "chain": "Save Mart",
    "name": "Save Mart #39",
    "store_number": "39",
    "address": "4725 Quail Lakes Dr",
    "city": "Stockton",
    "state": "CA",
    "zip": "95207",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 8,
    "lat": 37.9864797,
    "lng": -121.3416239,
    "formatted_address": "4725 Quail Lakes Dr, Stockton, CA 952075243, USA",
    "place_id": "ChIJfUY2FzIMkIAR6_0qDW7EJWY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0002",
    "chain": "Save Mart",
    "name": "Save Mart #91",
    "store_number": "91",
    "address": "7506 Pacific Ave",
    "city": "Stockton",
    "state": "CA",
    "zip": "95207",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 9,
    "lat": 38.0176813,
    "lng": -121.3214793,
    "formatted_address": "7506 Pacific Ave, Stockton, CA 95207, USA",
    "place_id": "ChIJE1zCPHAMkIARS3-qgBurEro",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0003",
    "chain": "Save Mart",
    "name": "Save Mart #334",
    "store_number": "334",
    "address": "3215 Pacific Ave",
    "city": "Stockton",
    "state": "CA",
    "zip": "95204",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 10,
    "lat": 37.9774505,
    "lng": -121.3052366,
    "formatted_address": "3215 Pacific Ave, Stockton, CA 95204, USA",
    "place_id": "ChIJzx3XtQsNkIARGZOKUqe8zb0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0004",
    "chain": "Save Mart",
    "name": "Save Mart #655",
    "store_number": "655",
    "address": "530 W Lodi Ave",
    "city": "Lodi",
    "state": "CA",
    "zip": "95240",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 11,
    "lat": 38.1292277,
    "lng": -121.2810549,
    "formatted_address": "530 W Lodi Ave, Lodi, CA 95240, USA",
    "place_id": "ChIJC8s19ROgmoAR1m0SGq7k_EQ",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0005",
    "chain": "Save Mart",
    "name": "Save Mart #552",
    "store_number": "552",
    "address": "3620 N Carson St",
    "city": "Carson City",
    "state": "NV",
    "zip": "89706",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 12,
    "lat": 39.1913881,
    "lng": -119.7742933,
    "formatted_address": "3620 N Carson St, Carson City, NV 89706, USA",
    "place_id": "ChIJn68J09sKmYARW7Ni4SwCAc8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0006",
    "chain": "Save Mart",
    "name": "Save Mart #1",
    "store_number": "1",
    "address": "3401 Oakdale Rd",
    "city": "Modesto",
    "state": "CA",
    "zip": "95355",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 13,
    "lat": 37.685687,
    "lng": -120.9584179,
    "formatted_address": "3401 Oakdale Rd, Modesto, CA 95355, USA",
    "place_id": "ChIJ6UVMTpFWkIARhiVVR-XVbAE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0007",
    "chain": "Save Mart",
    "name": "Save Mart #8",
    "store_number": "8",
    "address": "130 W Stockton St",
    "city": "Sonora",
    "state": "CA",
    "zip": "95370",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 14,
    "lat": 37.9833627,
    "lng": -120.3842133,
    "formatted_address": "130 W Stockton Rd, Sonora, CA 95370, USA",
    "place_id": "ChIJiV3QKNLFkIARTbJho__mBdo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0008",
    "chain": "Save Mart",
    "name": "Save Mart #12",
    "store_number": "12",
    "address": "1431 W Yosemite Ave",
    "city": "Manteca",
    "state": "CA",
    "zip": "95337",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 15,
    "lat": 37.79783279999999,
    "lng": -121.240817,
    "formatted_address": "1431 W Yosemite Ave, Manteca, CA 95337, USA",
    "place_id": "ChIJm-_nZ2pAkIARZSmmSKjsGpQ",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0009",
    "chain": "Save Mart",
    "name": "Save Mart #19",
    "store_number": "19",
    "address": "4041 E Ashlan Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93726",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 16,
    "lat": 36.7953334,
    "lng": -119.7568547,
    "formatted_address": "4041 E Ashlan Ave, Fresno, CA 93726, USA",
    "place_id": "ChIJW1O6IaVdlIARGS6sOVMbvZk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0010",
    "chain": "Save Mart",
    "name": "Save Mart #27",
    "store_number": "27",
    "address": "1580 E Manning Ave",
    "city": "Reedley",
    "state": "CA",
    "zip": "93654",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 17,
    "lat": 36.6057601,
    "lng": -119.4320729,
    "formatted_address": "1580 Manning Ave, Reedley, CA 93654, USA",
    "place_id": "ChIJvxN1jLrilIARALkwZmjnxx4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0011",
    "chain": "Save Mart",
    "name": "Save Mart #36",
    "store_number": "36",
    "address": "715 W Grangeville Blvd",
    "city": "Hanford",
    "state": "CA",
    "zip": "93230",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 18,
    "lat": 36.3409734,
    "lng": -119.6554149,
    "formatted_address": "715 W Grangeville Blvd, Hanford, CA 93230, USA",
    "place_id": "ChIJ1VdXgaHDlIARlYxW9SKdfMA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0012",
    "chain": "Save Mart",
    "name": "Save Mart #40",
    "store_number": "40",
    "address": "1121 W Visalia Rd",
    "city": "Exeter",
    "state": "CA",
    "zip": "93221",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 19,
    "lat": 36.2983985,
    "lng": -119.1552368,
    "formatted_address": "1121 W Visalia Rd, Exeter, CA 93221, USA",
    "place_id": "ChIJH8kFP1kxlYAR7vkqPncpeuk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0013",
    "chain": "Save Mart",
    "name": "Save Mart #42",
    "store_number": "42",
    "address": "260 N Highway 65",
    "city": "Lindsay",
    "state": "CA",
    "zip": "93247",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 20,
    "lat": 36.20216,
    "lng": -119.1029194,
    "formatted_address": "260 CA-65, Lindsay, CA 93247, USA",
    "place_id": "ChIJL3AjYRrL6oARsNmj-tMDPsA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0014",
    "chain": "Save Mart",
    "name": "Save Mart #45",
    "store_number": "45",
    "address": "900 W Henderson Ave",
    "city": "Porterville",
    "state": "CA",
    "zip": "93257",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 21,
    "lat": 36.0818545,
    "lng": -119.0372931,
    "formatted_address": "900 W Henderson Ave, Porterville, CA 93257, USA",
    "place_id": "ChIJXW1cfQS46oARb4838Lryq38",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0015",
    "chain": "Save Mart",
    "name": "Save Mart #46",
    "store_number": "46",
    "address": "260 S Main St",
    "city": "Angels Camp",
    "state": "CA",
    "zip": "95222",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 22,
    "lat": 38.0785228,
    "lng": -120.5557025,
    "formatted_address": "260 S Main St, Angels Camp, CA 95222, USA",
    "place_id": "ChIJLxnBxMCVkIAR-pCHOs6imLE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0016",
    "chain": "Save Mart",
    "name": "Save Mart #48",
    "store_number": "48",
    "address": "1449 E F St",
    "city": "Oakdale",
    "state": "CA",
    "zip": "95361",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 23,
    "lat": 37.7708368,
    "lng": -120.8322113,
    "formatted_address": "1449 E F St, Oakdale, CA 95361, USA",
    "place_id": "ChIJI7vIVsH5kIARA0oWgh8G-Rc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0017",
    "chain": "Save Mart",
    "name": "Save Mart #49",
    "store_number": "49",
    "address": "2100 Standiford Ave",
    "city": "Modesto",
    "state": "CA",
    "zip": "95350",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 24,
    "lat": 37.6890461,
    "lng": -121.0331517,
    "formatted_address": "2100 Standiford Ave, Modesto, CA 95350, USA",
    "place_id": "ChIJa6KHAQBRkIARuG0jVj_Isjk",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0018",
    "chain": "Save Mart",
    "name": "Save Mart #52",
    "store_number": "52",
    "address": "2179 Shaw Ave",
    "city": "Clovis",
    "state": "CA",
    "zip": "93611",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 25,
    "lat": 36.8100898,
    "lng": -119.673637,
    "formatted_address": "2179 Shaw Ave, Clovis, CA 93611, USA",
    "place_id": "ChIJHR28mpVblIARLD712-vJ-o0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0019",
    "chain": "Save Mart",
    "name": "Save Mart #53",
    "store_number": "53",
    "address": "150 W Olive Ave",
    "city": "Merced",
    "state": "CA",
    "zip": "95348",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 26,
    "lat": 37.3177526,
    "lng": -120.4714684,
    "formatted_address": "150 W Olive Ave, Merced, CA 95348, USA",
    "place_id": "ChIJf15m4a9DkYARSxNf9uvyrbM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0020",
    "chain": "Save Mart",
    "name": "Save Mart #64",
    "store_number": "64",
    "address": "841 Tucker Rd",
    "city": "Tehacapi",
    "state": "CA",
    "zip": "93561",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 27,
    "lat": 35.1227574,
    "lng": -118.4689232,
    "formatted_address": "841 Tucker Rd, Tehachapi, CA 93561, USA",
    "place_id": "ChIJ9Zo7Le_3wYARoMQbXDWtC50",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0021",
    "chain": "Save Mart",
    "name": "Save Mart #65",
    "store_number": "65",
    "address": "7075 N Marks Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93711",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 28,
    "lat": 36.8378281,
    "lng": -119.8492455,
    "formatted_address": "7075 N Marks Ave, Fresno, CA 93711, USA",
    "place_id": "ChIJ9UVtLO1olIARK1jTdFrbo8M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0022",
    "chain": "Save Mart",
    "name": "Save Mart #66",
    "store_number": "66",
    "address": "1631 Lander Ave",
    "city": "Turlock",
    "state": "CA",
    "zip": "95380",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 29,
    "lat": 37.4772226,
    "lng": -120.8507916,
    "formatted_address": "1631 Lander Ave, Turlock, CA 95380, USA",
    "place_id": "ChIJpYvdRtMHkYAR5GLuevlqYWE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0023",
    "chain": "Save Mart",
    "name": "Save Mart #67",
    "store_number": "67",
    "address": "1591 E Noble Ave",
    "city": "Visalia",
    "state": "CA",
    "zip": "93292",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 30,
    "lat": 36.3244432,
    "lng": -119.2748571,
    "formatted_address": "1591 E Noble Ave, Visalia, CA 93292, USA",
    "place_id": "ChIJYVncGp8vlYARVJrSWWE8OR8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0024",
    "chain": "Save Mart",
    "name": "Save Mart #71",
    "store_number": "71",
    "address": "659 E Nees Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93720",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 31,
    "lat": 36.8508176,
    "lng": -119.773162,
    "formatted_address": "659 E Nees Ave, Fresno, CA 93720, USA",
    "place_id": "ChIJg3-ESbpClIARcVawQvv_OvQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0025",
    "chain": "Save Mart",
    "name": "Save Mart #72",
    "store_number": "72",
    "address": "1059 C St",
    "city": "Galt",
    "state": "CA",
    "zip": "95632",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 32,
    "lat": 38.2543493,
    "lng": -121.2978613,
    "formatted_address": "1059 C St, Galt, CA 95632, USA",
    "place_id": "ChIJ37eYF9CimoARPF2vUbqiKC4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0026",
    "chain": "Save Mart",
    "name": "Save Mart #73",
    "store_number": "73",
    "address": "105 W Hanford Armona Rd",
    "city": "Lemoore",
    "state": "CA",
    "zip": "93245",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 33,
    "lat": 36.3115515,
    "lng": -119.7817838,
    "formatted_address": "105 W Hanford Armona Rd, Lemoore, CA 93245, USA",
    "place_id": "ChIJcxOgn5vAlIARQwjkON9bNQI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0027",
    "chain": "Save Mart",
    "name": "Save Mart #76",
    "store_number": "76",
    "address": "1045 Mono Way",
    "city": "Sonora",
    "state": "CA",
    "zip": "95370",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 34,
    "lat": 37.9746454,
    "lng": -120.3665198,
    "formatted_address": "1045 Mono Way, Sonora, CA 95370, USA",
    "place_id": "ChIJd_vheZXFkIARkVE8ktq325E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0028",
    "chain": "Save Mart",
    "name": "Save Mart #77",
    "store_number": "77",
    "address": "1504 Howard Rd",
    "city": "Madera",
    "state": "CA",
    "zip": "93637",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 35,
    "lat": 36.9512218,
    "lng": -120.0757311,
    "formatted_address": "1504 Howard Rd, Madera, CA 93637, USA",
    "place_id": "ChIJ9SnLeXgLlIARzV7EaoLc2AU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0029",
    "chain": "Save Mart",
    "name": "Save Mart #78",
    "store_number": "78",
    "address": "1107 E Champlain Dr",
    "city": "Fresno",
    "state": "CA",
    "zip": "93720",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 36,
    "lat": 36.8704652,
    "lng": -119.765133,
    "formatted_address": "1107 E Champlain Dr, Fresno, CA 93720, USA",
    "place_id": "ChIJS3SBV-1ClIARF05DWVYAXfA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0030",
    "chain": "Save Mart",
    "name": "Save Mart #82",
    "store_number": "82",
    "address": "1035 Sperry Ave",
    "city": "Patterson",
    "state": "CA",
    "zip": "95363",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 37,
    "lat": 37.4653227,
    "lng": -121.1422304,
    "formatted_address": "1035 Sperry Ave, Patterson, CA 95363, USA",
    "place_id": "ChIJxdOAytizkYARGXkzWqntMt4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0031",
    "chain": "Save Mart",
    "name": "Save Mart #83",
    "store_number": "83",
    "address": "5203 W Walnut Ave",
    "city": "Visalia",
    "state": "CA",
    "zip": "93277",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 38,
    "lat": 36.3118736,
    "lng": -119.3479017,
    "formatted_address": "5203 W Walnut Ave, Visalia, CA 93277, USA",
    "place_id": "ChIJy-ubUb0olYARvoJLJT_Cj-4",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0032",
    "chain": "Save Mart",
    "name": "Save Mart #86",
    "store_number": "86",
    "address": "801 Oakdale Rd",
    "city": "Modesto",
    "state": "CA",
    "zip": "95355",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 39,
    "lat": 37.6552488,
    "lng": -120.957788,
    "formatted_address": "801 Oakdale Rd, Modesto, CA 95355, USA",
    "place_id": "ChIJP7t5wzhUkIAR985VSbgeXn8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0033",
    "chain": "Save Mart",
    "name": "Save Mart #87",
    "store_number": "87",
    "address": "1157 N Willow Ave",
    "city": "Clovis",
    "state": "CA",
    "zip": "93611",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 40,
    "lat": 36.8508219,
    "lng": -119.727973,
    "formatted_address": "1157 N Willow Ave, Clovis, CA 93611, USA",
    "place_id": "ChIJXa6H1sxclIARWgrGcCK5h4A",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0034",
    "chain": "Save Mart",
    "name": "Save Mart #88",
    "store_number": "88",
    "address": "275 W Forest Ave",
    "city": "Coalinga",
    "state": "CA",
    "zip": "93210",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 41,
    "lat": 36.1349528,
    "lng": -120.3607097,
    "formatted_address": "275 W Forest Ave, Coalinga, CA 93210, USA",
    "place_id": "ChIJPc2JqURDk4ARRrTh1RJLj1M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0035",
    "chain": "Save Mart",
    "name": "Save Mart #89",
    "store_number": "89",
    "address": "5201 W Goshen Ave",
    "city": "Visalia",
    "state": "CA",
    "zip": "93291",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 42,
    "lat": 36.3399777,
    "lng": -119.348809,
    "formatted_address": "5201 W Goshen Ave, Visalia, CA 93291, USA",
    "place_id": "ChIJ0TJG0j8mlYARkelW1S3t9NA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0036",
    "chain": "Save Mart",
    "name": "Save Mart #92",
    "store_number": "92",
    "address": "4120 N West Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93705",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 43,
    "lat": 36.7921594,
    "lng": -119.8248815,
    "formatted_address": "4120 N West Ave, Fresno, CA 93705, USA",
    "place_id": "ChIJdxHGca9nlIARVox4f9hLzHY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0037",
    "chain": "Save Mart",
    "name": "Save Mart #93",
    "store_number": "93",
    "address": "6797 N Milburn Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93722",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 44,
    "lat": 36.8362025,
    "lng": -119.8810781,
    "formatted_address": "6797 N Milburn Ave, Fresno, CA 93722, USA",
    "place_id": "ChIJfeTgKc1olIARV70WPSVZ7vk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0038",
    "chain": "Save Mart",
    "name": "Save Mart #94",
    "store_number": "94",
    "address": "15240 S Harlan Rd",
    "city": "Lathrop",
    "state": "CA",
    "zip": "95330",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 45,
    "lat": 37.8228944,
    "lng": -121.2889556,
    "formatted_address": "15240 S Harlan Rd, Lathrop, CA 95330, USA",
    "place_id": "ChIJ_8FIqGsVkIAR5uVPqPqfmbk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0039",
    "chain": "Save Mart",
    "name": "Save Mart #95",
    "store_number": "95",
    "address": "3601 Pelandale Ave",
    "city": "Modesto",
    "state": "CA",
    "zip": "95356",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 46,
    "lat": 37.7011484,
    "lng": -121.0628914,
    "formatted_address": "3601 Pelandale Ave, Modesto, CA 95356, USA",
    "place_id": "ChIJt-kJdxZQkIARywVTIO6Pxmg",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0040",
    "chain": "Save Mart",
    "name": "Save Mart #96",
    "store_number": "96",
    "address": "9600 Hageman Rd",
    "city": "Bakersfield",
    "state": "CA",
    "zip": "93312",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 47,
    "lat": 35.3998272,
    "lng": -119.1084405,
    "formatted_address": "9600 Hageman Rd, Bakersfield, CA 93312, USA",
    "place_id": "ChIJE4MzvhFD6oARZOJzTJJGMzA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0041",
    "chain": "Save Mart",
    "name": "Save Mart #98",
    "store_number": "98",
    "address": "1835 Herndon Ave",
    "city": "Clovis",
    "state": "CA",
    "zip": "93611",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 48,
    "lat": 36.8383296,
    "lng": -119.6821466,
    "formatted_address": "1835 E Herndon Ave, Clovis, CA 93611, USA",
    "place_id": "ChIJ237FOm9blIARKufTZ-yAYvc",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0042",
    "chain": "Save Mart",
    "name": "Save Mart #100",
    "store_number": "100",
    "address": "1453 Goodwin Dr",
    "city": "Ripon",
    "state": "CA",
    "zip": "95366",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 49,
    "lat": 37.7525699,
    "lng": -121.135433,
    "formatted_address": "1453 Goodwin Dr, Ripon, CA 95366, USA",
    "place_id": "ChIJ9bNzKV1EkIARnHYEFpd1ov0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0043",
    "chain": "Save Mart",
    "name": "Save Mart #102",
    "store_number": "102",
    "address": "1701 Bellevue Rd",
    "city": "Atwater",
    "state": "CA",
    "zip": "95301",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 50,
    "lat": 37.3620035,
    "lng": -120.6124457,
    "formatted_address": "1701 Bellevue Rd, City of Atwater, CA 95301, USA",
    "place_id": "ChIJAQ7_62ZrkYARcXmn3yU2kdM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0044",
    "chain": "Save Mart",
    "name": "Save Mart #103",
    "store_number": "103",
    "address": "1225 E Robertson Blvd",
    "city": "Chowchilla",
    "state": "CA",
    "zip": "93610",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 51,
    "lat": 37.125554,
    "lng": -120.2473514,
    "formatted_address": "1225 E Robertson Blvd, Chowchilla, CA 93610, USA",
    "place_id": "ChIJS6gwWZz-k4AR292cmjxtMGE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0045",
    "chain": "Save Mart",
    "name": "Save Mart #105",
    "store_number": "105",
    "address": "2237 Claribel Rd",
    "city": "Riverbank",
    "state": "CA",
    "zip": "95367",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 52,
    "lat": 37.7134458,
    "lng": -120.9569774,
    "formatted_address": "2237 Claribel Rd, Riverbank, CA 95367, USA",
    "place_id": "ChIJ9cF4TRxXkIARFVsZ6VcL3dw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0046",
    "chain": "Save Mart",
    "name": "Save Mart #371",
    "store_number": "371",
    "address": "2595 Geer Rd",
    "city": "Turlock",
    "state": "CA",
    "zip": "95382",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 53,
    "lat": 37.516051,
    "lng": -120.8505225,
    "formatted_address": "2595 Geer Rd, Turlock, CA 95382, USA",
    "place_id": "ChIJr05rDQIHkYAR1FaMsysB9RE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0047",
    "chain": "Save Mart",
    "name": "Save Mart #386",
    "store_number": "386",
    "address": "1172 N Main St",
    "city": "Manteca",
    "state": "CA",
    "zip": "95336",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 54,
    "lat": 37.8132458,
    "lng": -121.215153,
    "formatted_address": "1172 N Main St, Manteca, CA 95336, USA",
    "place_id": "ChIJGyYdnsxBkIARA71lmEyPZtk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0048",
    "chain": "Save Mart",
    "name": "Save Mart #554",
    "store_number": "554",
    "address": "4995 Kietzke Ln",
    "city": "Reno",
    "state": "NV",
    "zip": "89509",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 56,
    "lat": 39.4774538,
    "lng": -119.7963198,
    "formatted_address": "4995 Kietzke Ln, Reno, NV 89509, USA",
    "place_id": "ChIJs6dLonNAmYAR8fQr1SFFFMA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0049",
    "chain": "Save Mart",
    "name": "Save Mart #555",
    "store_number": "555",
    "address": "10500 N Mccarran Blvd",
    "city": "Reno",
    "state": "NV",
    "zip": "89503",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 57,
    "lat": 39.534272,
    "lng": -119.8626943,
    "formatted_address": "10500 N McCarran Blvd, Reno, NV 89503, USA",
    "place_id": "ChIJC1gBSpRGmYARAh1ba9i8SDw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0050",
    "chain": "Save Mart",
    "name": "Save Mart #556",
    "store_number": "556",
    "address": "195 W Plumb Ln",
    "city": "Reno",
    "state": "NV",
    "zip": "89509",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 58,
    "lat": 39.5071485,
    "lng": -119.80661,
    "formatted_address": "195 W Plumb Ln, Reno, NV 89509, USA",
    "place_id": "ChIJc392K5RAmYARM4s-art_uNc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0051",
    "chain": "Save Mart",
    "name": "Save Mart #559",
    "store_number": "559",
    "address": "9750 Pyramid Way",
    "city": "Sparks",
    "state": "NV",
    "zip": "89441",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 59,
    "lat": 39.6380867,
    "lng": -119.7096634,
    "formatted_address": "9750 Pyramid Way, Sparks, NV 89436, USA",
    "place_id": "ChIJrXHrW1o3mYARFanZEUnX1XI",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0052",
    "chain": "Save Mart",
    "name": "Save Mart #600",
    "store_number": "600",
    "address": "386 Elm Ave",
    "city": "Auburn",
    "state": "CA",
    "zip": "95603",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 60,
    "lat": 38.9053246,
    "lng": -121.0740867,
    "formatted_address": "386 Elm Ave, Auburn, CA 95603, USA",
    "place_id": "ChIJLcbmJSwFm4ARqgrJnUr8CNI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0053",
    "chain": "Save Mart",
    "name": "Save Mart #602",
    "store_number": "602",
    "address": "146 W East Ave",
    "city": "Chico",
    "state": "CA",
    "zip": "95926",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 61,
    "lat": 39.7567116,
    "lng": -121.8641775,
    "formatted_address": "146 W East Ave, Chico, CA 95926, USA",
    "place_id": "ChIJF4_ErYXYgoARmyK8F_Op98s",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0054",
    "chain": "Save Mart",
    "name": "Save Mart #604",
    "store_number": "604",
    "address": "1900 Anderson Rd",
    "city": "Davis",
    "state": "CA",
    "zip": "95616",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 62,
    "lat": 38.5596947,
    "lng": -121.7577469,
    "formatted_address": "1900 Anderson Rd, Davis, CA 95616, USA",
    "place_id": "ChIJv7MN8rYphYARtdQvV0iqMFQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0055",
    "chain": "Save Mart",
    "name": "Save Mart #605",
    "store_number": "605",
    "address": "9160 Elk Grove Florin Rd",
    "city": "Elk Grove",
    "state": "CA",
    "zip": "95624",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 63,
    "lat": 38.4241856,
    "lng": -121.3722955,
    "formatted_address": "9160 Elk Grove Florin Rd, Elk Grove, CA 95624, USA",
    "place_id": "ChIJJbuUnSPHmoARvp-XuotRDa8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0056",
    "chain": "Save Mart",
    "name": "Save Mart #608",
    "store_number": "608",
    "address": "2054 Nevada City Hwy",
    "city": "Grass Valley",
    "state": "CA",
    "zip": "95945",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 64,
    "lat": 39.2392895,
    "lng": -121.037631,
    "formatted_address": "2054 Nevada City Hwy, Grass Valley, CA 95945, USA",
    "place_id": "ChIJl9IdOGNwm4AR6rJkJ_X2VPs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0057",
    "chain": "Save Mart",
    "name": "Save Mart #609",
    "store_number": "609",
    "address": "11980 State Highway 88",
    "city": "Jackson",
    "state": "CA",
    "zip": "95642",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 65,
    "lat": 38.3623862,
    "lng": -120.8013445,
    "formatted_address": "11980 CA-88, Jackson, CA 95642, USA",
    "place_id": "ChIJySHkrId7moARM0HwiCTKYoQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0058",
    "chain": "Save Mart",
    "name": "Save Mart #610",
    "store_number": "610",
    "address": "828 J St",
    "city": "Marysville",
    "state": "CA",
    "zip": "95901",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 66,
    "lat": 39.143203,
    "lng": -121.5995895,
    "formatted_address": "828 J St, Marysville, CA 95901, USA",
    "place_id": "ChIJp7BQrG5Tm4AROmL6_98rL4w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0059",
    "chain": "Save Mart",
    "name": "Save Mart #613",
    "store_number": "613",
    "address": "6636 Clark Rd",
    "city": "Paradise",
    "state": "CA",
    "zip": "95969",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 67,
    "lat": 39.7765774,
    "lng": -121.5895301,
    "formatted_address": "6636 Clark Rd, Paradise, CA 95969, USA",
    "place_id": "ChIJE7mZuYzUnIARYsF3aBQOfHM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0060",
    "chain": "Save Mart",
    "name": "Save Mart #612",
    "store_number": "612",
    "address": "4631 Churn Creek Rd",
    "city": "Redding",
    "state": "CA",
    "zip": "96002",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 68,
    "lat": 40.5412838,
    "lng": -122.3509079,
    "formatted_address": "4631 Churn Crk Rd, Redding, CA 96002, USA",
    "place_id": "ChIJX0W8zwzr0lQRsNYKWEZtVWA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0061",
    "chain": "Save Mart",
    "name": "Save Mart #614",
    "store_number": "614",
    "address": "1270 Broadway",
    "city": "Placerville",
    "state": "CA",
    "zip": "95667",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 69,
    "lat": 38.7305987,
    "lng": -120.7842755,
    "formatted_address": "1270 Broadway, Placerville, CA 95667, USA",
    "place_id": "ChIJRQhJT7xQmoARnewRZVgQKug",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0062",
    "chain": "Save Mart",
    "name": "Save Mart #615",
    "store_number": "615",
    "address": "3966 Missouri Flat Rd Ste A",
    "city": "Placerville",
    "state": "CA",
    "zip": "95667",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 70,
    "lat": 38.71078,
    "lng": -120.8437018,
    "formatted_address": "3966 Missouri Flat Rd A, Placerville, CA 95667, USA",
    "place_id": "ChIJ_ftfrnBXmoARANB5PxddskI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0063",
    "chain": "Save Mart",
    "name": "Save Mart #616",
    "store_number": "616",
    "address": "3021 Stanford Ranch Rd",
    "city": "Rocklin",
    "state": "CA",
    "zip": "95765",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 71,
    "lat": 38.81604069999999,
    "lng": -121.2585393,
    "formatted_address": "3021 Stanford Ranch Rd, Rocklin, CA 95765, USA",
    "place_id": "ChIJW4FTIKYYm4ARHpOsmi9g4RY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0064",
    "chain": "Save Mart",
    "name": "Save Mart #617",
    "store_number": "617",
    "address": "5060 Foothills Blvd",
    "city": "Roseville",
    "state": "CA",
    "zip": "95747",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 72,
    "lat": 38.76022570000001,
    "lng": -121.3123323,
    "formatted_address": "5060 Foothills Blvd, Roseville, CA 95747, USA",
    "place_id": "ChIJzzZbXQYhm4ARLYOL-ohGKbg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0065",
    "chain": "Save Mart",
    "name": "Save Mart #619",
    "store_number": "619",
    "address": "7960 Gerber Rd",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95828",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 73,
    "lat": 38.48052330000001,
    "lng": -121.4101699,
    "formatted_address": "7960 Gerber Rd, Sacramento, CA 95828, USA",
    "place_id": "ChIJPwkVarfFmoARVctqlaGIfeE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0066",
    "chain": "Save Mart",
    "name": "Save Mart #622",
    "store_number": "622",
    "address": "5600 Folsom Blvd",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95819",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 74,
    "lat": 38.5576103,
    "lng": -121.4387434,
    "formatted_address": "Save Mart, 5600 Folsom Blvd, Sacramento, CA 95819, USA",
    "place_id": "ChIJQ-DwFITamoARWV9xQrkVKWo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0067",
    "chain": "Save Mart",
    "name": "Save Mart #623",
    "store_number": "623",
    "address": "9137 Kiefer Blvd",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95826",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 75,
    "lat": 38.5485157,
    "lng": -121.3601492,
    "formatted_address": "9137 Kiefer Blvd, Sacramento, CA 95826, USA",
    "place_id": "ChIJSXBeqazEmoAR9e9na6tbkKE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0068",
    "chain": "Save Mart",
    "name": "Save Mart #625",
    "store_number": "625",
    "address": "2501 Fair Oaks Blvd",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95825",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 76,
    "lat": 38.57501389999999,
    "lng": -121.4038101,
    "formatted_address": "2501 Fair Oaks Blvd, Sacramento, CA 95825, USA",
    "place_id": "ChIJibkIllXamoAR5Ymlh2OuM1U",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0069",
    "chain": "Save Mart",
    "name": "Save Mart #627",
    "store_number": "627",
    "address": "11399 Deerfield Dr",
    "city": "Truckee",
    "state": "CA",
    "zip": "96161",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 77,
    "lat": 39.3195989,
    "lng": -120.2085097,
    "formatted_address": "11399 Deerfield Dr, Truckee, CA 96161, USA",
    "place_id": "ChIJDRYke0rem4ARoILq89FbLYo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0070",
    "chain": "Save Mart",
    "name": "Save Mart #631",
    "store_number": "631",
    "address": "1401 Mercey Springs Road",
    "city": "Los Banos",
    "state": "CA",
    "zip": "93635",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 78,
    "lat": 37.0569722,
    "lng": -120.8354354,
    "formatted_address": "1401 Mercey Springs Rd, Los Banos, CA 93635, USA",
    "place_id": "EjAxNDAxIE1lcmNleSBTcHJpbmdzIFJkLCBMb3MgQmFub3MsIENBIDkzNjM1LCBVU0EiMRIvChQKEglJr2uz8X6RgBEytJqSQmvcExD5CioUChIJ9Zjyp0R-kYAREFErpiMD56I",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0071",
    "chain": "Save Mart",
    "name": "Save Mart #635",
    "store_number": "635",
    "address": "2920 E Whitmore Ave",
    "city": "Ceres",
    "state": "CA",
    "zip": "95307",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 79,
    "lat": 37.5932166,
    "lng": -120.9398065,
    "formatted_address": "2920 E Whitmore Ave, Ceres, CA 95307, USA",
    "place_id": "ChIJ0aQoTNaqkYARlLdCZViZCdw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0072",
    "chain": "Save Mart",
    "name": "Save Mart #650",
    "store_number": "650",
    "address": "4043 W Clinton Ave",
    "city": "Fresno",
    "state": "CA",
    "zip": "93722",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 80,
    "lat": 36.7705613,
    "lng": -119.863381,
    "formatted_address": "4043 W Clinton Ave, Fresno, CA 93722, USA",
    "place_id": "ChIJHRmU74tmlIARZgnZCISWCGk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0073",
    "chain": "Save Mart",
    "name": "Save Mart #651",
    "store_number": "651",
    "address": "5750 N 1St St",
    "city": "Fresno",
    "state": "CA",
    "zip": "93710",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 81,
    "lat": 36.8222697,
    "lng": -119.7702871,
    "formatted_address": "5750 N First St, Fresno, CA 93710, USA",
    "place_id": "ChIJL4Udn0FdlIARqCwjv-Jm4ts",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0074",
    "chain": "Save Mart",
    "name": "Save Mart #654",
    "store_number": "654",
    "address": "909 Sierra St",
    "city": "Kingsburg",
    "state": "CA",
    "zip": "93631",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 82,
    "lat": 36.5190977,
    "lng": -119.5588017,
    "formatted_address": "909 Sierra St, Kingsburg, CA 93631, USA",
    "place_id": "ChIJf-UqasvllIARfYAUpnKSFFY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0075",
    "chain": "Save Mart",
    "name": "Save Mart #657",
    "store_number": "657",
    "address": "3615 W Noble Ave",
    "city": "Visalia",
    "state": "CA",
    "zip": "93277",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 83,
    "lat": 36.3254308,
    "lng": -119.3305703,
    "formatted_address": "3615 W Noble Ave, Visalia, CA 93277, USA",
    "place_id": "ChIJA1mLKKoolYAR4ZjtIYIF3yk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0076",
    "chain": "Save Mart",
    "name": "Save Mart #781",
    "store_number": "781",
    "address": "875 S Tracy Blvd",
    "city": "Tracy",
    "state": "CA",
    "zip": "95376",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 84,
    "lat": 37.72414740000001,
    "lng": -121.4368257,
    "formatted_address": "875 S Tracy Blvd, Tracy, CA 95376, USA",
    "place_id": "ChIJ16NA2Nc8kIARBQP-XUkC-2g",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0077",
    "chain": "Lucky",
    "name": "Lucky #212",
    "store_number": "212",
    "address": "3190 Contra Loma Blvd",
    "city": "Antioch",
    "state": "CA",
    "zip": "94509",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 87,
    "lat": 37.9906025,
    "lng": -121.8239665,
    "formatted_address": "3190 Contra Loma Blvd, Antioch, CA 94509, USA",
    "place_id": "ChIJJWlazzJYhYARPUtO0ProX8Q",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0078",
    "chain": "Lucky",
    "name": "Lucky #233",
    "store_number": "233",
    "address": "3457 Mckee Rd",
    "city": "San Jose",
    "state": "CA",
    "zip": "95127",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 88,
    "lat": 37.3809577,
    "lng": -121.8293336,
    "formatted_address": "3457 McKee Rd, San Jose, CA 95127, USA",
    "place_id": "ChIJGwFAyJ7Nj4ARbdGErlgiO50",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0079",
    "chain": "Lucky",
    "name": "Lucky #628",
    "store_number": "628",
    "address": "504 E Perkins St",
    "city": "Ukiah",
    "state": "CA",
    "zip": "95482",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 89,
    "lat": 39.1522637,
    "lng": -123.2001536,
    "formatted_address": "504 E Perkins St, Ukiah, CA 95482, USA",
    "place_id": "ChIJJ0ZalfBkgYARITK_A1emDrE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0080",
    "chain": "Lucky",
    "name": "Lucky #700",
    "store_number": "700",
    "address": "815 Marina Village Pkwy",
    "city": "Alameda",
    "state": "CA",
    "zip": "94501",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 90,
    "lat": 37.7834842,
    "lng": -122.2743347,
    "formatted_address": "815 Marina Village Pkwy, Alameda, CA 94501, USA",
    "place_id": "ChIJ_ePn09CAj4ARJWymrJyjGl8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0081",
    "chain": "Lucky",
    "name": "Lucky #703",
    "store_number": "703",
    "address": "555 Carmel Rancho Blvd",
    "city": "Carmel",
    "state": "CA",
    "zip": "93923",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 91,
    "lat": 36.54260379999999,
    "lng": -121.9059149,
    "formatted_address": "555 Carmel Rancho Blvd, Carmel, CA 93923, USA",
    "place_id": "ChIJdeKIvwHmjYARw7xzuEu0ffA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0082",
    "chain": "Lucky",
    "name": "Lucky #704",
    "store_number": "704",
    "address": "3443 Castro Valley Blvd",
    "city": "Castro Valley",
    "state": "CA",
    "zip": "94546",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 92,
    "lat": 37.69461,
    "lng": -122.0760214,
    "formatted_address": "3443 Castro Valley Blvd, Castro Valley, CA 94546, USA",
    "place_id": "ChIJOzrZoC-Sj4ARI99-pptvK-w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0083",
    "chain": "Lucky",
    "name": "Lucky #705",
    "store_number": "705",
    "address": "5190 Clayton Rd",
    "city": "Concord",
    "state": "CA",
    "zip": "94521",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 93,
    "lat": 37.9537641,
    "lng": -121.9659429,
    "formatted_address": "5190 Clayton Rd, Concord, CA 94521, USA",
    "place_id": "ChIJz11tZ0lehYARnBjcOJNXqIc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0084",
    "chain": "Lucky",
    "name": "Lucky #707",
    "store_number": "707",
    "address": "6843 Mission St",
    "city": "Daly City",
    "state": "CA",
    "zip": "94014",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 94,
    "lat": 37.6976352,
    "lng": -122.4624696,
    "formatted_address": "6843 Mission St, Daly City, CA 94014, USA",
    "place_id": "ChIJGQUpoxZ8j4ARG0Npv2bQlzs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0085",
    "chain": "Lucky",
    "name": "Lucky #708",
    "store_number": "708",
    "address": "660 San Ramon Valley Blvd",
    "city": "Danville",
    "state": "CA",
    "zip": "94526",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 95,
    "lat": 37.81298450000001,
    "lng": -121.994483,
    "formatted_address": "660 San Ramon Valley Blvd, Danville, CA 94526, USA",
    "place_id": "ChIJ8yWjGbOMj4ARTR6VpF_VaaI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0086",
    "chain": "Lucky",
    "name": "Lucky #709",
    "store_number": "709",
    "address": "1000 El Cerrito Plz",
    "city": "El Cerrito",
    "state": "CA",
    "zip": "94530",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 96,
    "lat": 37.9005527,
    "lng": -122.2981725,
    "formatted_address": "1000 El Cerrito Plaza, El Cerrito, CA 94530, USA",
    "place_id": "ChIJd__5vDx5hYARwZMNMcZkyD4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0087",
    "chain": "Lucky",
    "name": "Lucky #712",
    "store_number": "712",
    "address": "34101 Fremont Blvd",
    "city": "Fremont",
    "state": "CA",
    "zip": "94555",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 98,
    "lat": 37.5760604,
    "lng": -122.0445018,
    "formatted_address": "34101 Fremont Blvd, Fremont, CA 94555, USA",
    "place_id": "ChIJs0PtUim-j4AR4vf5jgJn7_k",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0088",
    "chain": "Lucky",
    "name": "Lucky #713",
    "store_number": "713",
    "address": "35820 Fremont Blvd",
    "city": "Fremont",
    "state": "CA",
    "zip": "94536",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 99,
    "lat": 37.5674366,
    "lng": -122.0224882,
    "formatted_address": "35820 Fremont Blvd, Fremont, CA 94536, USA",
    "place_id": "ChIJy0eqvbi_j4ARla7LX0ZbvUM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0089",
    "chain": "Lucky",
    "name": "Lucky #714",
    "store_number": "714",
    "address": "5000 Mowry Ave",
    "city": "Fremont",
    "state": "CA",
    "zip": "94538",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 100,
    "lat": 37.5351199,
    "lng": -121.9976052,
    "formatted_address": "5000 Mowry Ave, Fremont, CA 94538, USA",
    "place_id": "ChIJK6ZuYl6_j4ARmSa4dog_sAI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0090",
    "chain": "Lucky",
    "name": "Lucky #715",
    "store_number": "715",
    "address": "22555 Mission Blvd",
    "city": "Hayward",
    "state": "CA",
    "zip": "94541",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 101,
    "lat": 37.6719791,
    "lng": -122.0858146,
    "formatted_address": "22555 Mission Blvd, Hayward, CA 94541, USA",
    "place_id": "ChIJ-V5M72KRj4ARqvTORWLlvkc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0091",
    "chain": "Lucky",
    "name": "Lucky #718",
    "store_number": "718",
    "address": "1590 Sycamore Ave",
    "city": "Hercules",
    "state": "CA",
    "zip": "94547",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 102,
    "lat": 38.0084257,
    "lng": -122.2707057,
    "formatted_address": "1590 Sycamore Ave, Hercules, CA 94547, USA",
    "place_id": "ChIJVRGl-NV2hYARzrqr8IGJR2o",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0092",
    "chain": "Lucky",
    "name": "Lucky #719",
    "store_number": "719",
    "address": "291 Mccray St",
    "city": "Hollister",
    "state": "CA",
    "zip": "95023",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 103,
    "lat": 36.8531907,
    "lng": -121.397729,
    "formatted_address": "291 McCray St, Hollister, CA 95023, USA",
    "place_id": "ChIJs5WE8iz2kYARdP61ewymrkg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0093",
    "chain": "Lucky",
    "name": "Lucky #721",
    "store_number": "721",
    "address": "2000 Portola Ave",
    "city": "Livermore",
    "state": "CA",
    "zip": "94551",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 104,
    "lat": 37.6925653,
    "lng": -121.7747597,
    "formatted_address": "2000 Portola Ave, Livermore, CA 94550, USA",
    "place_id": "ChIJpQUzt6_nj4ARTW_CRdT28ig",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0094",
    "chain": "Lucky",
    "name": "Lucky #722",
    "store_number": "722",
    "address": "1951 Holmes St",
    "city": "Livermore",
    "state": "CA",
    "zip": "94550",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 105,
    "lat": 37.6612449,
    "lng": -121.7814893,
    "formatted_address": "1951 Holmes St, Livermore, CA 94550, USA",
    "place_id": "ChIJVfF9konnj4AR4ed-OLHX27k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0095",
    "chain": "Lucky",
    "name": "Lucky #723",
    "store_number": "723",
    "address": "2175 Grant Rd",
    "city": "Los Altos",
    "state": "CA",
    "zip": "94024",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 106,
    "lat": 37.3423192,
    "lng": -122.0715826,
    "formatted_address": "2175 Grant Rd, Los Altos, CA 94024, USA",
    "place_id": "ChIJsV3bWB20j4AROGnZUOMjmcE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0096",
    "chain": "Lucky",
    "name": "Lucky #724",
    "store_number": "724",
    "address": "270 Reservation Rd",
    "city": "Marina",
    "state": "CA",
    "zip": "93933",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 107,
    "lat": 36.6840115,
    "lng": -121.7962018,
    "formatted_address": "270 Reservation Rd, Marina, CA 93933, USA",
    "place_id": "ChIJrdFDstv8jYAR5rGY2vUNEqA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0097",
    "chain": "Lucky",
    "name": "Lucky #725",
    "store_number": "725",
    "address": "1145 Arnold Dr",
    "city": "Martinez",
    "state": "CA",
    "zip": "94553",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 108,
    "lat": 37.9945718,
    "lng": -122.1018517,
    "formatted_address": "1145 Arnold Dr, Martinez, CA 94553, USA",
    "place_id": "ChIJizmgacZlhYARPEyI0jl_FOM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0098",
    "chain": "Lucky",
    "name": "Lucky #730",
    "store_number": "730",
    "address": "2355 California Blvd",
    "city": "Napa",
    "state": "CA",
    "zip": "94559",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 109,
    "lat": 38.3058705,
    "lng": -122.3033806,
    "formatted_address": "2355 California Blvd, Napa, CA 94558, USA",
    "place_id": "ChIJ50oYZvkGhYARbYYHc_UL45Y",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0099",
    "chain": "Lucky",
    "name": "Lucky #731",
    "store_number": "731",
    "address": "1312 Trancas St",
    "city": "Napa",
    "state": "CA",
    "zip": "94558",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 110,
    "lat": 38.3226615,
    "lng": -122.3012131,
    "formatted_address": "1312 Trancas St, Napa, CA 94558, USA",
    "place_id": "EiQxMzEyIFRyYW5jYXMgU3QsIE5hcGEsIENBIDk0NTU4LCBVU0EiMRIvChQKEgnTS_4U3QaFgBFhXIg1K3cvBRCgCioUChIJvXceEuoGhYAR7URUlvLMu3U",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0100",
    "chain": "Lucky",
    "name": "Lucky #732",
    "store_number": "732",
    "address": "1761 Grant Ave",
    "city": "Novato",
    "state": "CA",
    "zip": "94945",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 111,
    "lat": 38.108428,
    "lng": -122.579339,
    "formatted_address": "1761 Grant Ave, Novato, CA 94945, USA",
    "place_id": "ChIJOTKmJ3m7hYARpHYetLgSM8I",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0101",
    "chain": "Lucky",
    "name": "Lucky #734",
    "store_number": "734",
    "address": "1963 Mountain Blvd",
    "city": "Oakland",
    "state": "CA",
    "zip": "94611",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 112,
    "lat": 37.8276103,
    "lng": -122.2112292,
    "formatted_address": "1963 Mountain Blvd, Oakland, CA 94611, USA",
    "place_id": "ChIJwfz7IYWHj4ARz1DSMWJionM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0102",
    "chain": "Lucky",
    "name": "Lucky #736",
    "store_number": "736",
    "address": "247 E 18Th St",
    "city": "Oakland",
    "state": "CA",
    "zip": "94606",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 113,
    "lat": 37.79943,
    "lng": -122.2532473,
    "formatted_address": "247 E 18th St, Oakland, CA 94606, USA",
    "place_id": "ChIJmQl09zmHj4ARS4l18CUAEiQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0103",
    "chain": "Lucky",
    "name": "Lucky #737",
    "store_number": "737",
    "address": "2545 Main St",
    "city": "Oakley",
    "state": "CA",
    "zip": "94561",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 114,
    "lat": 37.9965055,
    "lng": -121.7313905,
    "formatted_address": "2545 Main St, Oakley, CA 94561, USA",
    "place_id": "ChIJo0gRDRJWhYARtb8JJlpiop8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0104",
    "chain": "Lucky",
    "name": "Lucky #738",
    "store_number": "738",
    "address": "200 Country Club Gate Ctr",
    "city": "Pacific Grove",
    "state": "CA",
    "zip": "93950",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 115,
    "lat": 36.6074719,
    "lng": -121.9259211,
    "formatted_address": "200 Country Club Gate Center, Pacific Grove, CA 93950, USA",
    "place_id": "ChIJ2RKV7MnmjYARLfygZt1Iqus",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0105",
    "chain": "Lucky",
    "name": "Lucky #740",
    "store_number": "740",
    "address": "939 Lakeville St",
    "city": "Petaluma",
    "state": "CA",
    "zip": "94952",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 116,
    "lat": 38.2363554,
    "lng": -122.6241375,
    "formatted_address": "939 Lakeville St, Petaluma, CA 94952, USA",
    "place_id": "ChIJtYJXaVSxhYARPZ-_lZMDy4E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0106",
    "chain": "Lucky",
    "name": "Lucky #741",
    "store_number": "741",
    "address": "1000 Petaluma Blvd N",
    "city": "Petaluma",
    "state": "CA",
    "zip": "94952",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 117,
    "lat": 38.2453932,
    "lng": -122.6432244,
    "formatted_address": "1000 Petaluma Blvd N, Petaluma, CA 94952, USA",
    "place_id": "ChIJ78iz6RC0hYAR_R4-ZEVjcR0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0107",
    "chain": "Lucky",
    "name": "Lucky #742",
    "store_number": "742",
    "address": "1530 Fitzgerald Dr",
    "city": "Pinole",
    "state": "CA",
    "zip": "94564",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 118,
    "lat": 37.9905513,
    "lng": -122.3025023,
    "formatted_address": "1530 Fitzgerald Dr, Pinole, CA 94564, USA",
    "place_id": "ChIJRzWpoQV3hYARFRg_gt8xgJo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0108",
    "chain": "Lucky",
    "name": "Lucky #744",
    "store_number": "744",
    "address": "6155 W Las Positas Blvd",
    "city": "Pleasanton",
    "state": "CA",
    "zip": "94588",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 119,
    "lat": 37.6816624,
    "lng": -121.9056521,
    "formatted_address": "6155 W Las Positas Blvd, Pleasanton, CA 94566, USA",
    "place_id": "ChIJT3_G7uDrj4ARA5h4VtcMcdw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0109",
    "chain": "Lucky",
    "name": "Lucky #745",
    "store_number": "745",
    "address": "200 Woodside Plz",
    "city": "Redwood City",
    "state": "CA",
    "zip": "94061",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 120,
    "lat": 37.4565486,
    "lng": -122.2296173,
    "formatted_address": "200 Woodside Plz, Redwood City, CA 94061, USA",
    "place_id": "ChIJy8RdOIWjj4ARFFrg0wJg0DI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0110",
    "chain": "Lucky",
    "name": "Lucky #747",
    "store_number": "747",
    "address": "1150 S Main St",
    "city": "Salinas",
    "state": "CA",
    "zip": "93901",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 121,
    "lat": 36.6591979,
    "lng": -121.6606644,
    "formatted_address": "1150 S Main St, Salinas, CA 93901, USA",
    "place_id": "ChIJXVjh6fD4jYARN4xEj9bRIzc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0111",
    "chain": "Lucky",
    "name": "Lucky #748",
    "store_number": "748",
    "address": "1322 El Camino Real",
    "city": "San Bruno",
    "state": "CA",
    "zip": "94066",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 122,
    "lat": 37.6401668,
    "lng": -122.421895,
    "formatted_address": "1322 El Camino Real, San Bruno, CA 94066, USA",
    "place_id": "ChIJp-K9sr95j4ARKSAB4p_NBrM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0112",
    "chain": "Lucky",
    "name": "Lucky #749",
    "store_number": "749",
    "address": "1133 Old County Rd",
    "city": "San Carlos",
    "state": "CA",
    "zip": "94070",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 123,
    "lat": 37.5005284,
    "lng": -122.2491659,
    "formatted_address": "1133 Old County Rd, San Carlos, CA 94070, USA",
    "place_id": "ChIJ6evpDhaij4ARBynPhiUDI18",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0113",
    "chain": "Lucky",
    "name": "Lucky #755",
    "store_number": "755",
    "address": "1515 Sloat Blvd",
    "city": "San Francisco",
    "state": "CA",
    "zip": "94132",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 124,
    "lat": 37.733913,
    "lng": -122.489317,
    "formatted_address": "Lucky, 1515 Sloat Blvd, San Francisco, CA 94132, USA",
    "place_id": "ChIJW3MtVZ59j4AR-HBqg-SivGQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0114",
    "chain": "Lucky",
    "name": "Lucky #756",
    "store_number": "756",
    "address": "1750 Fulton St",
    "city": "San Francisco",
    "state": "CA",
    "zip": "94117",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 125,
    "lat": 37.776313,
    "lng": -122.445826,
    "formatted_address": "1750 Fulton St, San Francisco, CA 94117, USA",
    "place_id": "ChIJexWHJLOAhYARekirOvtjF_Y",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0115",
    "chain": "Lucky",
    "name": "Lucky #757",
    "store_number": "757",
    "address": "2027 Camden Ave",
    "city": "San Jose",
    "state": "CA",
    "zip": "95124",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 126,
    "lat": 37.26274420000001,
    "lng": -121.932686,
    "formatted_address": "2027 Camden Ave, San Jose, CA 95124, USA",
    "place_id": "ChIJBW4htls0joAR54T2HLAYgiM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0116",
    "chain": "Lucky",
    "name": "Lucky #758",
    "store_number": "758",
    "address": "565 W Capital Exprwy",
    "city": "San Jose",
    "state": "CA",
    "zip": "95136",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 127,
    "lat": 37.2759944,
    "lng": -121.8538066,
    "formatted_address": "565 W Capitol Expy, San Jose, CA 95136, USA",
    "place_id": "ChIJsWTdBUsyjoARY-ICmG9UByE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0117",
    "chain": "Lucky",
    "name": "Lucky #759",
    "store_number": "759",
    "address": "129 Bernal Rd",
    "city": "San Jose",
    "state": "CA",
    "zip": "95119",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 128,
    "lat": 37.2329439,
    "lng": -121.7746615,
    "formatted_address": "129 Bernal Rd, San Jose, CA 95119, USA",
    "place_id": "ChIJ12Lxaa4vjoARQbrmi23P5vE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0118",
    "chain": "Lucky",
    "name": "Lucky #762",
    "store_number": "762",
    "address": "6109 Meridian Ave",
    "city": "San Jose",
    "state": "CA",
    "zip": "95120",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 129,
    "lat": 37.2293337,
    "lng": -121.8856744,
    "formatted_address": "6109 Meridian Ave, San Jose, CA 95120, USA",
    "place_id": "ChIJ64n2pEYxjoARMgeHu9YnKfs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0119",
    "chain": "Lucky",
    "name": "Lucky #766",
    "store_number": "766",
    "address": "3270 S White Rd",
    "city": "San Jose",
    "state": "CA",
    "zip": "95148",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 131,
    "lat": 37.3152114,
    "lng": -121.7904268,
    "formatted_address": "3270 S White Rd, San Jose, CA 95148, USA",
    "place_id": "ChIJzf-DjHQtjoAR929wo6cwemI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0120",
    "chain": "Lucky",
    "name": "Lucky #767",
    "store_number": "767",
    "address": "1300 Fairmont Dr",
    "city": "San Leandro",
    "state": "CA",
    "zip": "94578",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 132,
    "lat": 37.7036271,
    "lng": -122.12875,
    "formatted_address": "1300 Fairmont Dr, San Leandro, CA 94578, USA",
    "place_id": "ChIJbXx1qdSRj4ARMyUhVK0oW6E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0121",
    "chain": "Lucky",
    "name": "Lucky #768",
    "store_number": "768",
    "address": "15840 Hesperian Blvd",
    "city": "San Lorenzo",
    "state": "CA",
    "zip": "94580",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 133,
    "lat": 37.6820549,
    "lng": -122.126173,
    "formatted_address": "15840 Hesperian Blvd, San Lorenzo, CA 94580, USA",
    "place_id": "ChIJMcpMWLKRj4AR_rMBubHY4aQ",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0122",
    "chain": "Lucky",
    "name": "Lucky #770",
    "store_number": "770",
    "address": "21001 San Ramon Valley Blvd St",
    "city": "San Ramon",
    "state": "CA",
    "zip": "94583",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 134,
    "lat": 37.7238252,
    "lng": -121.9441113,
    "formatted_address": "21001 San Ramon Valley Blvd, San Ramon, CA 94583, USA",
    "place_id": "ChIJQ75E-lTsj4ARXkXJIlfvfe8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0123",
    "chain": "Lucky",
    "name": "Lucky #772",
    "store_number": "772",
    "address": "2000 California Ave",
    "city": "Sand City",
    "state": "CA",
    "zip": "93955",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 135,
    "lat": 36.6199091,
    "lng": -121.8436291,
    "formatted_address": "2000 California Ave, Sand City, CA 93955, USA",
    "place_id": "ChIJd2nVk5LkjYAR0UYF_2K3M3k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0124",
    "chain": "Lucky",
    "name": "Lucky #774",
    "store_number": "774",
    "address": "234 Saratoga Ave",
    "city": "Santa Clara",
    "state": "CA",
    "zip": "95050",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 136,
    "lat": 37.3291827,
    "lng": -121.9668204,
    "formatted_address": "234 Saratoga Ave, Santa Clara, CA 95050, USA",
    "place_id": "ChIJhVNeofPKj4AR4I5E18YunZg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0125",
    "chain": "Lucky",
    "name": "Lucky #775",
    "store_number": "775",
    "address": "150 Bicentennial Way",
    "city": "Santa Rosa",
    "state": "CA",
    "zip": "95403",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 137,
    "lat": 38.4702772,
    "lng": -122.7197511,
    "formatted_address": "150 Bicentennial Way, Santa Rosa, CA 95403, USA",
    "place_id": "ChIJy1R9Nn84hIARsW8GZxQ9_iA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0126",
    "chain": "Lucky",
    "name": "Lucky #776",
    "store_number": "776",
    "address": "915 Montgomery Village Court",
    "city": "Santa Rosa",
    "state": "CA",
    "zip": "95405",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 138,
    "lat": 38.4435257,
    "lng": -122.6860548,
    "formatted_address": "Village Ct, Santa Rosa, CA 95405, USA",
    "place_id": "ChIJ8UnUOndIhIAR6gY_pqn3Q-k",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0127",
    "chain": "Lucky",
    "name": "Lucky #777",
    "store_number": "777",
    "address": "776 Gravenstein Hwy N",
    "city": "Sebastopol",
    "state": "CA",
    "zip": "95472",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 139,
    "lat": 38.4072611,
    "lng": -122.8400927,
    "formatted_address": "776 Gravenstein Hwy N, Sebastopol, CA 95472, USA",
    "place_id": "ChIJHcedSHA6hIARgq1BeyDD8tQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0128",
    "chain": "Lucky",
    "name": "Lucky #778",
    "store_number": "778",
    "address": "19181 Highway 12",
    "city": "Sonoma",
    "state": "CA",
    "zip": "95476",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 140,
    "lat": 38.30022,
    "lng": -122.476879,
    "formatted_address": "19181 CA-12, Sonoma, CA 95476, USA",
    "place_id": "ChIJZWILYjmshYARFNjtlsaLIw8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0129",
    "chain": "Lucky",
    "name": "Lucky #780",
    "store_number": "780",
    "address": "484 N Mathilda Ave",
    "city": "Sunnyvale",
    "state": "CA",
    "zip": "94085",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 141,
    "lat": 37.388442,
    "lng": -122.0295023,
    "formatted_address": "484 N Mathilda Ave, Sunnyvale, CA 94085, USA",
    "place_id": "ChIJt-fggFG2j4ARJnLZFbUL9fY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0130",
    "chain": "Lucky",
    "name": "Lucky #782",
    "store_number": "782",
    "address": "32300 Dyer St",
    "city": "Union City",
    "state": "CA",
    "zip": "94587",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 142,
    "lat": 37.5984372,
    "lng": -122.0693042,
    "formatted_address": "32300 Dyer St, Union City, CA 94587, USA",
    "place_id": "ChIJq1lEXsSVj4ARU8A8JoETf9o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0131",
    "chain": "Lucky",
    "name": "Lucky #783",
    "store_number": "783",
    "address": "777 E Monte Vista Ave",
    "city": "Vacaville",
    "state": "CA",
    "zip": "95688",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 143,
    "lat": 38.3598271,
    "lng": -121.9825016,
    "formatted_address": "777 E Monte Vista Ave, Vacaville, CA 95688, USA",
    "place_id": "ChIJLcQ2jVI9hYARPiu3tbiM9aU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0132",
    "chain": "Lucky",
    "name": "Lucky #784",
    "store_number": "784",
    "address": "1979 Peabody Rd",
    "city": "Vacaville",
    "state": "CA",
    "zip": "95687",
    "source_sheet": "SaveMart & Lucky",
    "source_row": 144,
    "lat": 38.3363801,
    "lng": -121.9687289,
    "formatted_address": "Lucky, 1979 Peabody Rd, Vacaville, CA 95687, USA",
    "place_id": "ChIJIe9jFQ09hYARCqFpwJzeHn8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0133",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #5",
    "store_number": "5",
    "address": "2500 Santiam Hwy Se",
    "city": "Albany",
    "state": "OR",
    "zip": "97322",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 9,
    "lat": 44.6320694,
    "lng": -123.074843,
    "formatted_address": "2500 Santiam Hwy SE, Albany, OR 97322, USA",
    "place_id": "ChIJ8-w-zb5swFQRQd4SFZuG-EY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0134",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #13",
    "store_number": "13",
    "address": "18325 Aurora Ave",
    "city": "Shoreline",
    "state": "WA",
    "zip": "98133",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 11,
    "lat": 47.7620769,
    "lng": -122.3477322,
    "formatted_address": "18325 Aurora Ave N, Shoreline, WA 98133, USA",
    "place_id": "ChIJx_WQpfIQkFQRK5tuzaO3mM4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0135",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #17",
    "store_number": "17",
    "address": "43843 Sterling Hwy",
    "city": "Soldotna",
    "state": "AK",
    "zip": "99669",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 12,
    "lat": 60.48993729999999,
    "lng": -151.049924,
    "formatted_address": "43843 Sterling Hwy, Soldotna, AK 99669, USA",
    "place_id": "ChIJT3HAf11hxlYR92TI4mg3r_Y",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0136",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #19",
    "store_number": "19",
    "address": "801 Auburn Way N",
    "city": "Auburn",
    "state": "WA",
    "zip": "98002",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 14,
    "lat": 47.31567210000001,
    "lng": -122.2266363,
    "formatted_address": "801 Auburn Wy N, Auburn, WA 98002, USA",
    "place_id": "ChIJP87wN2FYkFQRZl3smGxt6co",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0137",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #21",
    "store_number": "21",
    "address": "61535 S Highway 97",
    "city": "Bend",
    "state": "OR",
    "zip": "97702",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 15,
    "lat": 44.03354,
    "lng": -121.3083345,
    "formatted_address": "61535 S Hwy 97, Bend, OR 97702, USA",
    "place_id": "ChIJjzFlk7PHuFQRJNC_YCljGx4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0138",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #23",
    "store_number": "23",
    "address": "2041 148Th Ave Ne",
    "city": "Bellevue",
    "state": "WA",
    "zip": "98007",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 16,
    "lat": 47.6288614,
    "lng": -122.1445578,
    "formatted_address": "2041 148th Ave NE, Bellevue, WA 98007, USA",
    "place_id": "ChIJVfPoIKhtkFQRuE6frtJTlEk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0139",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #24",
    "store_number": "24",
    "address": "9205 S Burlington Blvd",
    "city": "Burlington",
    "state": "WA",
    "zip": "98233",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 17,
    "lat": 48.4602079,
    "lng": -122.335697,
    "formatted_address": "S Burlington Blvd, Burlington, WA 98233, USA",
    "place_id": "ChIJMaF62slthVQR9Ya9Vc0Uwq0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0140",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #25",
    "store_number": "25",
    "address": "800 Lakeway Dr",
    "city": "Bellingham",
    "state": "WA",
    "zip": "98229",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 18,
    "lat": 48.7435651,
    "lng": -122.4640379,
    "formatted_address": "800 Lakeway Dr, Bellingham, WA 98229, USA",
    "place_id": "ChIJCfuz3sGjhVQRmr34bmN1fe4",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0141",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #28",
    "store_number": "28",
    "address": "14300 1St Ave S",
    "city": "Burien",
    "state": "WA",
    "zip": "98168",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 19,
    "lat": 47.4753406,
    "lng": -122.3323911,
    "formatted_address": "14300 1st Ave S, Burien, WA 98168, USA",
    "place_id": "ChIJFzyYuntDkFQRZWc1p3_wsy8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0142",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #30",
    "store_number": "30",
    "address": "325 5Th St",
    "city": "Brookings",
    "state": "OR",
    "zip": "97415",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 20,
    "lat": 42.0539248,
    "lng": -124.2898646,
    "formatted_address": "325 5th St, Brookings, OR 97415, USA",
    "place_id": "ChIJR8fPXOSh2lQRgni0omOxsQE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0143",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #35",
    "store_number": "35",
    "address": "11425 Sw Beaverton Hillsdale H",
    "city": "Beaverton",
    "state": "OR",
    "zip": "97005",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 21,
    "lat": 45.4876897,
    "lng": -122.7950622,
    "formatted_address": "11425 SW Beaverton Hillsdale Hwy H, Beaverton, OR 97005, USA",
    "place_id": "ChIJU-qfyB0MlVQRdxJ1du0P3lI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0144",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #40",
    "store_number": "40",
    "address": "7555 Sw Barbur Blvd",
    "city": "Portland",
    "state": "OR",
    "zip": "97219",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 22,
    "lat": 45.4705206,
    "lng": -122.6905387,
    "formatted_address": "7555 SW Barbur Blvd, Portland, OR 97219, USA",
    "place_id": "ChIJb16MyxoLlVQRACqy8RiBYfE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0145",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #41",
    "store_number": "41",
    "address": "20901 State Route 410 E",
    "city": "Bonney Lake",
    "state": "WA",
    "zip": "98391",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 23,
    "lat": 47.166565,
    "lng": -122.1506685,
    "formatted_address": "20901 WA-410, Bonney Lake, WA 98391, USA",
    "place_id": "ChIJLemNeMH6kFQRQJo1dhSdRPo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0146",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #49",
    "store_number": "49",
    "address": "560 W Kathleen Ave",
    "city": "Coeur D Alene",
    "state": "ID",
    "zip": "83815",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 24,
    "lat": 47.7124636,
    "lng": -116.7947789,
    "formatted_address": "560 W Kathleen Ave, Coeur d'Alene, ID 83815, USA",
    "place_id": "ChIJ0XgzPdPGYVMRylls7Csd0AE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0147",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #50",
    "store_number": "50",
    "address": "1020 1St St",
    "city": "Coos Bay",
    "state": "OR",
    "zip": "97420",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 25,
    "lat": 43.35691,
    "lng": -124.2105881,
    "formatted_address": "1020 S 1st St, Coos Bay, OR 97420, USA",
    "place_id": "ChIJfXl4RpCGw1QRyR30TLIro-0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0148",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #53",
    "store_number": "53",
    "address": "16735 Se 272Nd St",
    "city": "Covington",
    "state": "WA",
    "zip": "90842",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 26,
    "lat": 47.3561791,
    "lng": -122.1202345,
    "formatted_address": "16735 SE 272nd St, Kent, WA 98042, USA",
    "place_id": "ChIJOcqKZQpfkFQRVwB6II31rgg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0149",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #60",
    "store_number": "60",
    "address": "2200 Baseline St",
    "city": "Cornelius",
    "state": "OR",
    "zip": "97113",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 27,
    "lat": 45.5218333,
    "lng": -123.0446111,
    "formatted_address": "2200 E Baseline St, Cornelius, OR 97113, USA",
    "place_id": "ChIJcdtwsVsalVQRJkjgYWx-rpw",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0150",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #71",
    "store_number": "71",
    "address": "2000 W Dimond Blvd",
    "city": "Anchorage",
    "state": "AK",
    "zip": "99515",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 29,
    "lat": 61.13603000000001,
    "lng": -149.9190904,
    "formatted_address": "2000 W Dimond Blvd, Anchorage, AK 99515, USA",
    "place_id": "ChIJk_TqV0iYyFYRdrwMgXjgGzI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0151",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #75",
    "store_number": "75",
    "address": "14700 Se Division St",
    "city": "Portland",
    "state": "OR",
    "zip": "97236",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 30,
    "lat": 45.5029065,
    "lng": -122.5120924,
    "formatted_address": "14700 SE Division St, Portland, OR 97236, USA",
    "place_id": "ChIJAc_4CfuhlVQR4vO5BbVCsAI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0152",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #90",
    "store_number": "90",
    "address": "3740 Market St Ne",
    "city": "Salem",
    "state": "OR",
    "zip": "97301",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 31,
    "lat": 44.9498106,
    "lng": -122.9867363,
    "formatted_address": "3740 Market St NE, Salem, OR 97301, USA",
    "place_id": "ChIJIR2Vw-v-v1QRb1PcIFJCYz8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0153",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #93",
    "store_number": "93",
    "address": "16600 Se Mcgillivray Blvd",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98683",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 32,
    "lat": 45.6058208,
    "lng": -122.5017492,
    "formatted_address": "Parking lot, 16600 SE McGillivray Blvd, Vancouver, WA 98683, USA",
    "place_id": "ChIJX68wF8iklVQRMOhRTFd2xos",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0154",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #111",
    "store_number": "111",
    "address": "33702 21St Ave Sw",
    "city": "Federal Way",
    "state": "WA",
    "zip": "98023",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 33,
    "lat": 47.2984897,
    "lng": -122.3589862,
    "formatted_address": "33702 21st Ave SW, Federal Way, WA 98023, USA",
    "place_id": "ChIJP-UcOVZWkFQRaoMPrphaSuk",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0155",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #122",
    "store_number": "122",
    "address": "100 Nw 85Th St",
    "city": "Seattle",
    "state": "WA",
    "zip": "98117",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 34,
    "lat": 47.69191379999999,
    "lng": -122.3590676,
    "formatted_address": "100 NW 85th St, Seattle, WA 98117, USA",
    "place_id": "ChIJ8aL1XSAUkFQRh47gnhOW-Ts",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0156",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #125",
    "store_number": "125",
    "address": "6615 Ne Glisan St",
    "city": "Portland",
    "state": "OR",
    "zip": "97213",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 35,
    "lat": 45.527628,
    "lng": -122.5960856,
    "formatted_address": "6615 NE Glisan St, Portland, OR 97213, USA",
    "place_id": "ChIJG6F1oR6hlVQRO0SC9mIWPSY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0157",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #127",
    "store_number": "127",
    "address": "2497 Se Burnside Rd",
    "city": "Gresham",
    "state": "OR",
    "zip": "97080",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 36,
    "lat": 45.4958093,
    "lng": -122.4069023,
    "formatted_address": "2497 SE Burnside Rd, Gresham, OR 97080, USA",
    "place_id": "ChIJj_q43lCYlVQRAvH46tm8znk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0158",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #135",
    "store_number": "135",
    "address": "3805 Se Hawthorne Blvd",
    "city": "Portland",
    "state": "OR",
    "zip": "97214",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 38,
    "lat": 45.5126133,
    "lng": -122.623766,
    "formatted_address": "3805 SE Hawthorne Blvd, Portland, OR 97214, USA",
    "place_id": "ChIJCV7Yb42glVQRsGy8vRHFS6o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0159",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #140",
    "store_number": "140",
    "address": "7700 Ne Highway 99",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98665",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 39,
    "lat": 45.6754548,
    "lng": -122.6634389,
    "formatted_address": "7700 NE Hwy 99, Vancouver, WA 98665, USA",
    "place_id": "ChIJTxR2FPKulVQROGcScA30xbg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0160",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #143",
    "store_number": "143",
    "address": "23105 Sw Tualatin Valley Hwy",
    "city": "Hillsboro",
    "state": "OR",
    "zip": "97123",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 40,
    "lat": 45.5000493,
    "lng": -122.9147501,
    "formatted_address": "23105 SW Tualatin Valley Hwy, Hillsboro, OR 97123, USA",
    "place_id": "ChIJ____w9EPlVQRVIFBn4iVxs8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0161",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #150",
    "store_number": "150",
    "address": "7404 N Interstate Ave",
    "city": "Portland",
    "state": "OR",
    "zip": "97217",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 41,
    "lat": 45.5758482,
    "lng": -122.6809888,
    "formatted_address": "7404 N Interstate Ave, Portland, OR 97217, USA",
    "place_id": "ChIJ6_8bc6-nlVQR4yT_dcJURlo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0162",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #156",
    "store_number": "156",
    "address": "1555 Northgate Mile",
    "city": "Idaho Falls",
    "state": "ID",
    "zip": "83401",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 42,
    "lat": 43.5095931,
    "lng": -112.0195201,
    "formatted_address": "1555 Northgate Mile, Idaho Falls, ID 83401, USA",
    "place_id": "ChIJffrkYR5cVFMRB9PI7vX5Osc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0163",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #158",
    "store_number": "158",
    "address": "8181 Glacier Hwy,",
    "city": "Juneau",
    "state": "AK",
    "zip": "99801",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 43,
    "lat": 58.358846,
    "lng": -134.5592803,
    "formatted_address": "8181 Glacier Hwy, Juneau, AK 99801, USA",
    "place_id": "ChIJ078q9NfhAFQReJVuk4qdDQU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0164",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #163",
    "store_number": "163",
    "address": "2811 W 10Th Ave",
    "city": "Kennewick",
    "state": "WA",
    "zip": "99336",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 44,
    "lat": 46.19719509999999,
    "lng": -119.1614614,
    "formatted_address": "2811 W 10th Ave, Kennewick, WA 99336, USA",
    "place_id": "ChIJ3wHDE1Z4mFQRXDyOJm9kIFw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0165",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #165",
    "store_number": "165",
    "address": "2655 Shasta Way",
    "city": "Klamath Falls",
    "state": "OR",
    "zip": "97603",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 45,
    "lat": 42.21576170000001,
    "lng": -121.7563617,
    "formatted_address": "2655 Shasta Way, Klamath Falls, OR 97603, USA",
    "place_id": "ChIJtXxD3wXVyFQRqzSsJhAL5SU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0166",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #171",
    "store_number": "171",
    "address": "5050 State Highway 303 Ne",
    "city": "Bremerton",
    "state": "WA",
    "zip": "98311",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 46,
    "lat": 47.6109161,
    "lng": -122.6266545,
    "formatted_address": "5050 WA-303, Bremerton, WA 98311, USA",
    "place_id": "ChIJ62tJ_CA6kFQRARDvUY8fHfY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0167",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #180",
    "store_number": "180",
    "address": "4615A 196Th St Sw Ste 175",
    "city": "Lynnwood",
    "state": "WA",
    "zip": "98036",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 49,
    "lat": 47.82207229999999,
    "lng": -122.2955373,
    "formatted_address": "4615 196th St SW #175, Lynnwood, WA 98036, USA",
    "place_id": "ChIJtwSZZkAFkFQRA-78SIElzZs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0168",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #185",
    "store_number": "185",
    "address": "3184 Ocean Beach Hwy",
    "city": "Longview",
    "state": "WA",
    "zip": "98632",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 50,
    "lat": 46.1486508,
    "lng": -122.9637954,
    "formatted_address": "3184 Ocean Beach Hwy, Longview, WA 98632, USA",
    "place_id": "ChIJvYPvMVZslFQRjuS4pABoh-8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0169",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #186",
    "store_number": "186",
    "address": "700 Sleater Kinney Rd Se",
    "city": "Lacey",
    "state": "WA",
    "zip": "98503",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 51,
    "lat": 47.0395365,
    "lng": -122.8323105,
    "formatted_address": "700 Sleater Kinney Rd SE, Lacey, WA 98503, USA",
    "place_id": "ChIJoVPi2EkLkVQRpHoZt8o71ks",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0170",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #196",
    "store_number": "196",
    "address": "1301 Center Dr",
    "city": "Medford",
    "state": "OR",
    "zip": "97501",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 52,
    "lat": 42.3139049,
    "lng": -122.8565092,
    "formatted_address": "1301 Center Dr, Medford, OR 97501, USA",
    "place_id": "ChIJew9aWAV6z1QRKOkDhAOSL5s",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0171",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #198",
    "store_number": "198",
    "address": "1850 E Fairview Ave",
    "city": "Meridian",
    "state": "ID",
    "zip": "83642",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 53,
    "lat": 43.6199412,
    "lng": -116.3717392,
    "formatted_address": "1850 E Fairview Ave, Meridian, ID 83642, USA",
    "place_id": "ChIJv8LSxQxUrlQRNmGbasuqTJg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0172",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #208",
    "store_number": "208",
    "address": "11325 Se Mill Plain Blvd",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98684",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 54,
    "lat": 45.6195418,
    "lng": -122.5563169,
    "formatted_address": "11325 SE Mill Plain Blvd, Vancouver, WA 98684, USA",
    "place_id": "ChIJs3XoPRCllVQRrfJSL8dZbTU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0173",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #209",
    "store_number": "209",
    "address": "9925 Highway 99",
    "city": "Marysville",
    "state": "WA",
    "zip": "98270",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 55,
    "lat": 48.0563616,
    "lng": -122.1492224,
    "formatted_address": "Marysville, WA 98270, USA",
    "place_id": "ChIJh_Cc_G9ThVQRyC8yo_3DZ_k",
    "geocode_location_type": "APPROXIMATE"
  },
  {
    "id": "pb-0174",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #210",
    "store_number": "210",
    "address": "18805 Sr 2",
    "city": "Monroe",
    "state": "WA",
    "zip": "98272",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 56,
    "lat": 47.8634268,
    "lng": -121.9770066,
    "formatted_address": "18805 US-2, Monroe, WA 98272, USA",
    "place_id": "ChIJwxh4yVummlQRaZ818X-grL4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0175",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #214",
    "store_number": "214",
    "address": "12120 N Division St",
    "city": "Spokane",
    "state": "WA",
    "zip": "99218",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 57,
    "lat": 47.7673131,
    "lng": -117.40447,
    "formatted_address": "12120 N Division St, Spokane, WA 99218, USA",
    "place_id": "ChIJdaOL4lYcnlQRMAuuVu-NWqU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0176",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #215",
    "store_number": "215",
    "address": "25250 Pacific Hwy S",
    "city": "Kent",
    "state": "WA",
    "zip": "98032",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 58,
    "lat": 47.37500439999999,
    "lng": -122.2974884,
    "formatted_address": "25250 Pacific Hwy S, Kent, WA 98032, USA",
    "place_id": "ChIJO9LSaDJakFQRLEjVtghNt1Y",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0177",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #218",
    "store_number": "218",
    "address": "1451 Alt Hwy 101",
    "city": "Warrenton",
    "state": "OR",
    "zip": "97146",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 59,
    "lat": 46.1535846,
    "lng": -123.9124706,
    "formatted_address": "Alt Hwy 101, Warrenton, OR 97146, USA",
    "place_id": "ChIJUzHY7A1kk1QRQQ9NenztP-E",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0178",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #220",
    "store_number": "220",
    "address": "3300 E Portland Rd Ste 10",
    "city": "Newberg",
    "state": "OR",
    "zip": "97132",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 60,
    "lat": 45.3064332,
    "lng": -122.9439954,
    "formatted_address": "3300 E Portland Rd #10, Newberg, OR 97132, USA",
    "place_id": "Ei4zMzAwIEUgUG9ydGxhbmQgUmQgIzEwLCBOZXdiZXJnLCBPUiA5NzEzMiwgVVNBIh4aHAoWChQKEgmfFKTjZWqVVBEIeMwDhnIG5xICMTA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0179",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #224",
    "store_number": "224",
    "address": "930 Old Steese Hwy Ste A",
    "city": "Fairbanks",
    "state": "AK",
    "zip": "99701",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 61,
    "lat": 64.8544807,
    "lng": -147.690448,
    "formatted_address": "930 Old Steese Hwy ste a, Fairbanks, AK 99701, USA",
    "place_id": "ChIJxyRwoWlFMlERewkUOg3ucwE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0180",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #226",
    "store_number": "226",
    "address": "50 2Nd St S,",
    "city": "Nampa",
    "state": "ID",
    "zip": "83651",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 62,
    "lat": 43.5884926,
    "lng": -116.5744945,
    "formatted_address": "50 2nd St S, Nampa, ID 83651, USA",
    "place_id": "ChIJJ2fmEmJMrlQRBYbo0UB46gw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0181",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #227",
    "store_number": "227",
    "address": "150 Ne 20Th St",
    "city": "Newport",
    "state": "OR",
    "zip": "97365",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 63,
    "lat": 44.6511291,
    "lng": -124.0511828,
    "formatted_address": "150 NE 20th St, Newport, OR 97365, USA",
    "place_id": "ChIJ3WAJCybWwVQRb5WFYiGvq5k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0182",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #240",
    "store_number": "240",
    "address": "14700 Se Mcloughlin Blvd",
    "city": "Milwaukie",
    "state": "OR",
    "zip": "97267",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 65,
    "lat": 45.4167709,
    "lng": -122.6303982,
    "formatted_address": "14700 SE McLoughlin Blvd, Milwaukie, OR 97267, USA",
    "place_id": "ChIJ3Y8nDWh1lVQRCuddsWwjRqw",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0183",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #242",
    "store_number": "242",
    "address": "1839 Molalla Ave",
    "city": "Oregon City",
    "state": "OR",
    "zip": "97045",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 66,
    "lat": 45.3324259,
    "lng": -122.5831665,
    "formatted_address": "1839 Molalla Ave, Oregon City, OR 97045, USA",
    "place_id": "ChIJqZuv0c5wlVQRom2WuYK1DuU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0184",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #255",
    "store_number": "255",
    "address": "6850 N Lombard St",
    "city": "Portland",
    "state": "OR",
    "zip": "97203",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 67,
    "lat": 45.5848325,
    "lng": -122.7391607,
    "formatted_address": "6850 N Lombard St, Portland, OR 97203, USA",
    "place_id": "ChIJsVUnvvunlVQRhaBhtUqqdxE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0185",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #260",
    "store_number": "260",
    "address": "800 Yellowstone Ave",
    "city": "Pocatello",
    "state": "ID",
    "zip": "83201",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 68,
    "lat": 42.8898632,
    "lng": -112.4494395,
    "formatted_address": "800 Yellowstone Ave, Pocatello, ID 83201, USA",
    "place_id": "ChIJEbaSjllPVVMRUg8ZuPuIba8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0186",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #265",
    "store_number": "265",
    "address": "1100 N Meridian",
    "city": "Puyallup",
    "state": "WA",
    "zip": "98371",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 69,
    "lat": 47.1997471,
    "lng": -122.2963421,
    "formatted_address": "1100 N Meridian, Puyallup, WA 98371, USA",
    "place_id": "ChIJi9fgVE35kFQRi8i3vMAx1cs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0187",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #281",
    "store_number": "281",
    "address": "929 Nw Garden Valley Blvd",
    "city": "Roseburg",
    "state": "OR",
    "zip": "97471",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 70,
    "lat": 43.2266983,
    "lng": -123.3698611,
    "formatted_address": "929 NW Garden Valley Blvd, Roseburg, OR 97471, USA",
    "place_id": "ChIJ-0iNJ7YixFQRBrYBGHRDX0w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0188",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #285",
    "store_number": "285",
    "address": "7700 Sw Beaverton Hillsdale Hw",
    "city": "Portland",
    "state": "OR",
    "zip": "97225",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 71,
    "lat": 45.485292,
    "lng": -122.7560504,
    "formatted_address": "7700 SW Beaverton Hillsdale Hwy, Portland, OR 97225, USA",
    "place_id": "ChIJEwFH7PMLlVQRChgOpCgZv5Y",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0189",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #286",
    "store_number": "286",
    "address": "101 Wellsian Way",
    "city": "Richland",
    "state": "WA",
    "zip": "99352",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 72,
    "lat": 46.26073030000001,
    "lng": -119.2853019,
    "formatted_address": "101 D, 101 Wellsian Way, Richland, WA 99352, USA",
    "place_id": "ChIJn-ZnEoV6mFQR8OWExpkvHAE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0190",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #325",
    "store_number": "325",
    "address": "60 Division Ave",
    "city": "Eugene",
    "state": "OR",
    "zip": "97404",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 73,
    "lat": 44.0979586,
    "lng": -123.1241285,
    "formatted_address": "60 Division Ave, Eugene, OR 97404, USA",
    "place_id": "ChIJ3fuOl38dwVQRriHlWFMycno",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0191",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #328",
    "store_number": "328",
    "address": "650 Q St",
    "city": "Springfield",
    "state": "OR",
    "zip": "97477",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 74,
    "lat": 44.0634568,
    "lng": -123.0177884,
    "formatted_address": "650 Q St, Springfield, OR 97477, USA",
    "place_id": "ChIJ42DPaKThwFQRdlr_PF6CPi4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0192",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #351",
    "store_number": "351",
    "address": "15609 E Sprague Ave",
    "city": "Spokane Vly",
    "state": "WA",
    "zip": "99037",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 75,
    "lat": 47.6587863,
    "lng": -117.1926909,
    "formatted_address": "15609 E Sprague Ave, Spokane Valley, WA 99037, USA",
    "place_id": "ChIJWSO_N4PfYVMRf7dZhZcLIr0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0193",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #355",
    "store_number": "355",
    "address": "3450 Commercial St Se",
    "city": "Salem",
    "state": "OR",
    "zip": "97302",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 76,
    "lat": 44.9056642,
    "lng": -123.0409142,
    "formatted_address": "3450 Commercial St SE, Salem, OR 97302, USA",
    "place_id": "ChIJL7nWblMHwFQRV48JEofVaYs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0194",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #360",
    "store_number": "360",
    "address": "100 Nw 20Th Pl",
    "city": "Portland",
    "state": "OR",
    "zip": "97209",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 77,
    "lat": 45.5241023,
    "lng": -122.6928082,
    "formatted_address": "100 NW 20th Pl, Portland, OR 97209, USA",
    "place_id": "ChIJT544t_cJlVQRSCTkyyz609w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0195",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #372",
    "store_number": "372",
    "address": "1215 W 6Th St",
    "city": "The Dalles",
    "state": "OR",
    "zip": "97058",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 78,
    "lat": 45.6068976,
    "lng": -121.1994061,
    "formatted_address": "1215 W 6th St, The Dalles, OR 97058, USA",
    "place_id": "ChIJ5W4969UdllQR-dGbYhkuylg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0196",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #377",
    "store_number": "377",
    "address": "2500 Hwy 101 N",
    "city": "Tillamook",
    "state": "OR",
    "zip": "97141",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 79,
    "lat": 45.447247,
    "lng": -123.8417982,
    "formatted_address": "2500 U.S 101 N, Tillamook, OR 97141, USA",
    "place_id": "EigyNTAwIFUuUyAxMDEgTiwgVGlsbGFtb29rLCBPUiA5NzE0MSwgVVNBIjESLwoUChIJ67TsBrEr61QRctHEchxSrxoQxBMqFAoSCY9gTnqxK-tUET0ppaeO6s6R",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0197",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #383",
    "store_number": "383",
    "address": "705 Blue Lakes Blvd",
    "city": "Twin Falls",
    "state": "ID",
    "zip": "83301",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 80,
    "lat": 42.5568555,
    "lng": -114.4606808,
    "formatted_address": "705 Blue Lakes Blvd, Twin Falls, ID 83301, USA",
    "place_id": "ChIJUQqGVrujrFQRY9mUPgk7kJs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0198",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #390",
    "store_number": "390",
    "address": "4505 S 19Th St",
    "city": "Tacoma",
    "state": "WA",
    "zip": "98405",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 82,
    "lat": 47.2436626,
    "lng": -122.4977266,
    "formatted_address": "4505 S 19th St, Tacoma, WA 98405, USA",
    "place_id": "ChIJmVSWaDJVkFQR1Kossq86Pu0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0199",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #391",
    "store_number": "391",
    "address": "12221 120Th Ave Ne",
    "city": "Kirkland",
    "state": "WA",
    "zip": "98034",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 83,
    "lat": 47.7094411,
    "lng": -122.1845965,
    "formatted_address": "12221 120th Ave NE, Kirkland, WA 98034, USA",
    "place_id": "ChIJzyCDtYANkFQR6-HbJh0tpoc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0200",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #393",
    "store_number": "393",
    "address": "19200 Sw Martinazzi Ave",
    "city": "Tualatin",
    "state": "OR",
    "zip": "97062",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 84,
    "lat": 45.38138439999999,
    "lng": -122.757028,
    "formatted_address": "19200 SW Martinazzi Ave, Tualatin, OR 97062, USA",
    "place_id": "ChIJpznZNY9ylVQR_jaiIkloZ7A",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0201",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #417",
    "store_number": "417",
    "address": "3333 W 11Th Ave",
    "city": "Eugene",
    "state": "OR",
    "zip": "97402",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 85,
    "lat": 44.0494154,
    "lng": -123.1422906,
    "formatted_address": "3333 W 11th Ave, Eugene, OR 97402, USA",
    "place_id": "ChIJC_v4loIewVQRhyTeJIfcQro",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0202",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #424",
    "store_number": "424",
    "address": "17404 Meridian E",
    "city": "Puyallup",
    "state": "WA",
    "zip": "98375",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 86,
    "lat": 47.0986853,
    "lng": -122.2967551,
    "formatted_address": "17404 Meridian E, Puyallup, WA 98375, USA",
    "place_id": "ChIJx2-uWbLikFQRcPVP1s94OrU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0203",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #439",
    "store_number": "439",
    "address": "10751 W Overland Rd",
    "city": "Boise",
    "state": "ID",
    "zip": "83709",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 87,
    "lat": 43.5892982,
    "lng": -116.3164225,
    "formatted_address": "10751 W Overland Rd, Boise, ID 83709, USA",
    "place_id": "ChIJD2sKDelWrlQRj1tyM1SkYj0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0204",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #449",
    "store_number": "449",
    "address": "5425 W Chinden Blvd",
    "city": "Boise",
    "state": "ID",
    "zip": "83714",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 88,
    "lat": 43.6455353,
    "lng": -116.2763759,
    "formatted_address": "5425 W Chinden Blvd, Garden City, ID 83714, USA",
    "place_id": "ChIJ7Q3ANWf_rlQRrVt4RnRJgVU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0205",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #457",
    "store_number": "457",
    "address": "21045 Bothell Everett Hwy",
    "city": "Bothell",
    "state": "WA",
    "zip": "98021",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 89,
    "lat": 47.80744019999999,
    "lng": -122.2059515,
    "formatted_address": "21045 Bothell Everett Hwy, Bothell, WA 98021, USA",
    "place_id": "ChIJp7M2VWsPkFQR2W_U1GuYIG4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0206",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #458",
    "store_number": "458",
    "address": "12906 Bothell Everett Hwy",
    "city": "Everett",
    "state": "WA",
    "zip": "98208",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 90,
    "lat": 47.8796725,
    "lng": -122.2074108,
    "formatted_address": "12906 Bothell Everett Hwy, Everett, WA 98208, USA",
    "place_id": "ChIJ7XhLdfMGkFQRKR_Bx5Pz3oE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0207",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #459",
    "store_number": "459",
    "address": "365 Renton Center Way Sw",
    "city": "Renton",
    "state": "WA",
    "zip": "98057",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 91,
    "lat": 47.4768534,
    "lng": -122.2179674,
    "formatted_address": "365 Renton Center Way SW, Renton, WA 98057, USA",
    "place_id": "ChIJlW-TX7JCkFQRk7K6EFcA_3U",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0208",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #460",
    "store_number": "460",
    "address": "800 Ne Tenney Rd",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98685",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 92,
    "lat": 45.72058,
    "lng": -122.6625086,
    "formatted_address": "800 NE Tenney Rd, Vancouver, WA 98685, USA",
    "place_id": "ChIJx5afF-utlVQRcMHJ66u0ApE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0209",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #462",
    "store_number": "462",
    "address": "51501 Columbia River Hwy",
    "city": "Scappoose",
    "state": "OR",
    "zip": "97056",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 93,
    "lat": 45.741755,
    "lng": -122.8784466,
    "formatted_address": "51501 Columbia River Hwy, Scappoose, OR 97056, USA",
    "place_id": "ChIJz8yg4uFUlFQRbFdEBiko28k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0210",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #464",
    "store_number": "464",
    "address": "4701 Highway 101",
    "city": "Florence",
    "state": "OR",
    "zip": "97439",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 94,
    "lat": 44.0077928,
    "lng": -124.1026169,
    "formatted_address": "4701 US-101, Florence, OR 97439, USA",
    "place_id": "ChIJS_Ka1lyAwVQRGJroaHS3BMY",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0211",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #482",
    "store_number": "482",
    "address": "15995 Sw Walker Rd",
    "city": "Beaverton",
    "state": "OR",
    "zip": "97006",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 95,
    "lat": 45.5191531,
    "lng": -122.8400816,
    "formatted_address": "15995 SW Walker Rd, Beaverton, OR 97006, USA",
    "place_id": "ChIJb-Vd6CAPlVQRMkocM8YTsDE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0212",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #485",
    "store_number": "485",
    "address": "3755 Airport Way",
    "city": "Fairbanks",
    "state": "AK",
    "zip": "99709",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 96,
    "lat": 64.8353266,
    "lng": -147.8176039,
    "formatted_address": "3755 Airport Way, Fairbanks, AK 99709, USA",
    "place_id": "ChIJV5GATSFbMlERmJtkfbMiThM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0213",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #486",
    "store_number": "486",
    "address": "1206 N 40Th Ave",
    "city": "Yakima",
    "state": "WA",
    "zip": "98908",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 97,
    "lat": 46.619405,
    "lng": -120.562883,
    "formatted_address": "1206 N 40th Ave, Yakima, WA 98908, USA",
    "place_id": "ChIJV0hqVqBil1QR-MOyqDLA2SU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0214",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #516",
    "store_number": "516",
    "address": "30300 Sw Boones Ferry Rd",
    "city": "Wilsonville",
    "state": "OR",
    "zip": "97070",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 98,
    "lat": 45.3008391,
    "lng": -122.7707934,
    "formatted_address": "30300 SW Boones Ferry Rd, Wilsonville, OR 97070, USA",
    "place_id": "ChIJIzIJ4-5ulVQRoAc-Q8TZWSc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0215",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #600",
    "store_number": "600",
    "address": "3030 Ne Weidler St",
    "city": "Portland",
    "state": "OR",
    "zip": "97232",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 99,
    "lat": 45.5329779,
    "lng": -122.6351061,
    "formatted_address": "3030 NE Weidler St, Portland, OR 97232, USA",
    "place_id": "ChIJK7vcIc-glVQRTEMrsBIUdmA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0216",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #604",
    "store_number": "604",
    "address": "22303 Mountain Hwy E",
    "city": "Spanaway",
    "state": "WA",
    "zip": "98387",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 101,
    "lat": 47.0552925,
    "lng": -122.3971279,
    "formatted_address": "22303 Mountain Hwy E, Spanaway, WA 98387, USA",
    "place_id": "ChIJC6NW66QckVQRTCvIHi2o3Y0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0217",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #605",
    "store_number": "605",
    "address": "6901 S 19Th St",
    "city": "Tacoma",
    "state": "WA",
    "zip": "98466",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 102,
    "lat": 47.24425400000001,
    "lng": -122.5290996,
    "formatted_address": "6901 S 19th St, Tacoma, WA 98466, USA",
    "place_id": "ChIJw81Mk9iqkVQRM_MPrRdSVKI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0218",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #608",
    "store_number": "608",
    "address": "915 Nw 45Th St",
    "city": "Seattle",
    "state": "WA",
    "zip": "98107",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 103,
    "lat": 47.6598323,
    "lng": -122.3686721,
    "formatted_address": "915 NW 45th St, Seattle, WA 98107, USA",
    "place_id": "ChIJG4yrXrAVkFQRmpNyngCItCg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0219",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #613",
    "store_number": "613",
    "address": "3527 S Federal Way",
    "city": "Boise",
    "state": "ID",
    "zip": "83705",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 104,
    "lat": 43.5695333,
    "lng": -116.1869371,
    "formatted_address": "3527 S Federal Way, Boise, ID 83705, USA",
    "place_id": "ChIJBa23Gvb3rlQRpJ-xamsTloE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0220",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #615",
    "store_number": "615",
    "address": "6305 Bridgeport Way W",
    "city": "University Pl",
    "state": "WA",
    "zip": "98467",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 106,
    "lat": 47.2006689,
    "lng": -122.5288316,
    "formatted_address": "6305 Bridgeport Way W, University Place, WA 98467, USA",
    "place_id": "ChIJxb3ftYEAkVQRRec9Wro9jd4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0221",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #649",
    "store_number": "649",
    "address": "535 W Evergreen Ave",
    "city": "Palmer",
    "state": "AK",
    "zip": "99645",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 107,
    "lat": 61.5994141,
    "lng": -149.1140578,
    "formatted_address": "535 W Evergreen Ave, Palmer, AK 99645, USA",
    "place_id": "ChIJESn3leIdyVYRQzRzMk2GK1U",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0222",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #650",
    "store_number": "650",
    "address": "944 Sw 9Th St",
    "city": "Redmond",
    "state": "OR",
    "zip": "97756",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 108,
    "lat": 44.267529,
    "lng": -121.1765302,
    "formatted_address": "944 SW 9th St, Redmond, OR 97756, USA",
    "place_id": "ChIJUc-o4Ckrv1QRnQBwCLbdU0M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0223",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #651",
    "store_number": "651",
    "address": "1401 Se 1St Ave",
    "city": "Canby",
    "state": "OR",
    "zip": "97013",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 109,
    "lat": 45.2665686,
    "lng": -122.6767174,
    "formatted_address": "Fred Meyer Jewelers, 1401 SE 1st Ave, Canby, OR 97013, USA",
    "place_id": "ChIJ2anL6GVllVQRjiCRe_NkPTw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0224",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #652",
    "store_number": "652",
    "address": "201 S Water St",
    "city": "Ellensburg",
    "state": "WA",
    "zip": "98926",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 110,
    "lat": 46.991236,
    "lng": -120.5518302,
    "formatted_address": "201 S Water St, Ellensburg, WA 98926, USA",
    "place_id": "ChIJ6R3yetLzmVQRL9RoNvQrj8o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0225",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #653",
    "store_number": "653",
    "address": "1501 E Parks Hwy",
    "city": "Wasilla",
    "state": "AK",
    "zip": "99654",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 111,
    "lat": 61.5794697,
    "lng": -149.4092241,
    "formatted_address": "1501 E Parks Hwy, Wasilla, AK 99654, USA",
    "place_id": "ChIJgb_DUxjeyFYRWq53Aa6_tS0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0226",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #654",
    "store_number": "654",
    "address": "11 Grant Rd",
    "city": "Wenatchee",
    "state": "WA",
    "zip": "98802",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 112,
    "lat": 47.4072366,
    "lng": -120.2913743,
    "formatted_address": "11 Grant Rd, East Wenatchee, WA 98802, USA",
    "place_id": "ChIJjYwY0eHMm1QRa8R_cfONjAo",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0227",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #655",
    "store_number": "655",
    "address": "1900 Se Sedgwick Rd",
    "city": "Port Orchard",
    "state": "WA",
    "zip": "98366",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 113,
    "lat": 47.5031575,
    "lng": -122.6292031,
    "formatted_address": "1900 SE Sedgwick Rd, Port Orchard, WA 98366, USA",
    "place_id": "ChIJESh2CsZJkFQRXyLHLpUxd2g",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0228",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #656",
    "store_number": "656",
    "address": "2300 Abbott Rd",
    "city": "Anchorage",
    "state": "AK",
    "zip": "99507",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 114,
    "lat": 61.1371537,
    "lng": -149.8372407,
    "formatted_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
    "place_id": "ChIJ-Uw2J-eZyFYRgb0hdIRC5qQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0229",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #657",
    "store_number": "657",
    "address": "400 S Thor St",
    "city": "Spokane",
    "state": "WA",
    "zip": "99202",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 115,
    "lat": 47.652555,
    "lng": -117.3623672,
    "formatted_address": "400 S Thor St, Spokane, WA 99202, USA",
    "place_id": "ChIJE1dYSAginlQRI7z1D6BVc8Y",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0230",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #658",
    "store_number": "658",
    "address": "6100 E Lake Sammamish Pkwy Se",
    "city": "Issaquah",
    "state": "WA",
    "zip": "98029",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 116,
    "lat": 47.54872839999999,
    "lng": -122.0389226,
    "formatted_address": "6100 E Lake Sammamish Pkwy SE, Issaquah, WA 98029, USA",
    "place_id": "ChIJiUc4a5dvkFQR6sdK9PnpTqc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0231",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #659",
    "store_number": "659",
    "address": "555 Trosper Rd Sw",
    "city": "Tumwater",
    "state": "WA",
    "zip": "98512",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 117,
    "lat": 46.9980314,
    "lng": -122.9148876,
    "formatted_address": "555 Trosper Rd SW, Tumwater, WA 98512, USA",
    "place_id": "ChIJs_mDoQ50kVQR9xOyx1yEQvo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0232",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #660",
    "store_number": "660",
    "address": "22855 Ne Park Ln",
    "city": "Wood Village",
    "state": "OR",
    "zip": "97060",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 118,
    "lat": 45.5304095,
    "lng": -122.4283496,
    "formatted_address": "22855 NE Park Ln, Wood Village, OR 97060, USA",
    "place_id": "ChIJh6_G8JiilVQR6XXrthhC84s",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0233",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #661",
    "store_number": "661",
    "address": "22075 Ne Imbrie Dr",
    "city": "Hillsboro",
    "state": "OR",
    "zip": "97124",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 119,
    "lat": 45.5513308,
    "lng": -122.9031384,
    "formatted_address": "22075 NE Imbrie Dr, Hillsboro, OR 97124, USA",
    "place_id": "ChIJHXqURZAFlVQR2gigCEeGLY0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0234",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #663",
    "store_number": "663",
    "address": "16625 362Nd Ave",
    "city": "Sandy",
    "state": "OR",
    "zip": "97055",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 120,
    "lat": 45.4029848,
    "lng": -122.2927508,
    "formatted_address": "16625 362nd Ave, Sandy, OR 97055, USA",
    "place_id": "ChIJX0c1HtSalVQRDHWhcGEiyR8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0235",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #665",
    "store_number": "665",
    "address": "1201 Valley Ave E",
    "city": "Sumner",
    "state": "WA",
    "zip": "98390",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 121,
    "lat": 47.2036999,
    "lng": -122.2282226,
    "formatted_address": "1201 Valley Ave, Sumner, WA 98390, USA",
    "place_id": "ChIJVUFeT9P7kFQRpyJNPgRujxw",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0236",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #667",
    "store_number": "667",
    "address": "1225 W Bakerview Rd",
    "city": "Bellingham",
    "state": "WA",
    "zip": "98226",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 122,
    "lat": 48.7886584,
    "lng": -122.512171,
    "formatted_address": "1225 W Bakerview Rd, Bellingham, WA 98226, USA",
    "place_id": "ChIJS7JErkijhVQRmP7c3D3mcNU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0237",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #668",
    "store_number": "668",
    "address": "13401 Old Glenn Hwy",
    "city": "Eagle River",
    "state": "AK",
    "zip": "99577",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 123,
    "lat": 61.3415215,
    "lng": -149.5562595,
    "formatted_address": "13401 Old Glenn Hwy, Eagle River, AK 99577, USA",
    "place_id": "ChIJz4U-uJjryFYRTHTPqFYGltM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0238",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #681",
    "store_number": "681",
    "address": "2801 Bickford Ave",
    "city": "Snohomish",
    "state": "WA",
    "zip": "98290",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 124,
    "lat": 47.9444306,
    "lng": -122.1092373,
    "formatted_address": "2801 Bickford Ave, Snohomish, WA 98290, USA",
    "place_id": "ChIJj8KlBIGpmlQRQFUuTrkCKNk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0239",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #682",
    "store_number": "682",
    "address": "26520 Maple Valley Black Diamo",
    "city": "Maple Valley",
    "state": "WA",
    "zip": "98038",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 125,
    "lat": 47.3638798,
    "lng": -122.0188805,
    "formatted_address": "26520 Maple Valley Black Diamond Rd SE, Maple Valley, WA 98038, USA",
    "place_id": "ChIJtXK6xx9gkFQR6qI4OSnVBOI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0240",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #683",
    "store_number": "683",
    "address": "2500 Columbia House Blvd",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98661",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 126,
    "lat": 45.62004779999999,
    "lng": -122.6453116,
    "formatted_address": "2500 Columbia House Blvd, Vancouver, WA 98661, USA",
    "place_id": "ChIJxcbA61SllVQRC-kuuSgZ8jk",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0241",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #685",
    "store_number": "685",
    "address": "1400 W Chinden Blvd",
    "city": "Meridian",
    "state": "ID",
    "zip": "83646",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 127,
    "lat": 43.6633626,
    "lng": -116.4102176,
    "formatted_address": "1400 W Chinden Blvd, Meridian, ID 83646, USA",
    "place_id": "ChIJSQDhGK5UrlQR2uG2Gxg0nVE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0242",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #688",
    "store_number": "688",
    "address": "2902 164Th St Sw",
    "city": "Lynnwood",
    "state": "WA",
    "zip": "98087",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 128,
    "lat": 47.8489888,
    "lng": -122.2716377,
    "formatted_address": "2902 164th St SW, Lynnwood, WA 98087, USA",
    "place_id": "ChIJB4O9u60FkFQRKUMQx4DBVgg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0243",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #691",
    "store_number": "691",
    "address": "5502 Point Fosdick Dr",
    "city": "Gig Harbor",
    "state": "WA",
    "zip": "98335",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 129,
    "lat": 47.3075436,
    "lng": -122.5810844,
    "formatted_address": "5502 Point Fosdick Dr, Gig Harbor, WA 98335, USA",
    "place_id": "ChIJo5p-ay1TkFQRZ8okQdniJy4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0244",
    "chain": "Fred Meyer",
    "name": "Fred Meyer #694",
    "store_number": "694",
    "address": "17005 Se Sunnyside Rd",
    "city": "Happy Valley",
    "state": "OR",
    "zip": "97015",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 130,
    "lat": 45.4285313,
    "lng": -122.4877249,
    "formatted_address": "17005 SE Sunnyside Rd, Clackamas, OR 97086, USA",
    "place_id": "ChIJBTmmcnuelVQRZjTcrhULmzw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0245",
    "chain": "QFC",
    "name": "QFC #105",
    "store_number": "105",
    "address": "11104 Pacific Ave S",
    "city": "Tacoma",
    "state": "WA",
    "zip": "98444",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 134,
    "lat": 47.1563269,
    "lng": -122.4361649,
    "formatted_address": "11104 Pacific Ave S, Tacoma, WA 98444, USA",
    "place_id": "ChIJE8eHEpIBkVQRaZADg6cTnlA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0246",
    "chain": "QFC",
    "name": "QFC #106",
    "store_number": "106",
    "address": "515 Sheridan St",
    "city": "Port Townsend",
    "state": "WA",
    "zip": "98368",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 135,
    "lat": 48.1037271,
    "lng": -122.7917384,
    "formatted_address": "515 Sheridan St, Port Townsend, WA 98368, USA",
    "place_id": "ChIJp6mFoTnsj1QRjkCygsHbVpg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0247",
    "chain": "QFC",
    "name": "QFC #126",
    "store_number": "126",
    "address": "4775 Whitman Ln Se",
    "city": "Lacey",
    "state": "WA",
    "zip": "98513",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 136,
    "lat": 46.9947632,
    "lng": -122.8238645,
    "formatted_address": "4775 Whitman Ln SE, Lacey, WA 98513, USA",
    "place_id": "ChIJLTX3GD5zkVQRDsD6qSHBIKs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0248",
    "chain": "QFC",
    "name": "QFC #212",
    "store_number": "212",
    "address": "3505 Se 192Nd Ave",
    "city": "Vancouver",
    "state": "WA",
    "zip": "98683",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 140,
    "lat": 45.5951708,
    "lng": -122.4763611,
    "formatted_address": "3505 SE 192nd Ave, Vancouver, WA 98683, USA",
    "place_id": "ChIJi550p6uklVQRywvfgqjv_Xc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0249",
    "chain": "QFC",
    "name": "QFC #803",
    "store_number": "803",
    "address": "13310 Se 240Th St, Kent",
    "city": "Kent",
    "state": "WA",
    "zip": "98042",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 141,
    "lat": 47.3871698,
    "lng": -122.1633459,
    "formatted_address": "13310 SE 240th St, Kent, WA 98042, USA",
    "place_id": "ChIJh6Q5zItekFQRlvSTD0PZ3fc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0250",
    "chain": "QFC",
    "name": "QFC #805",
    "store_number": "805",
    "address": "17847 1St Ave S",
    "city": "Seattle",
    "state": "WA",
    "zip": "98148",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 142,
    "lat": 47.4418041,
    "lng": -122.335776,
    "formatted_address": "17847 1st Ave S, Normandy Park, WA 98148, USA",
    "place_id": "ChIJlUrytbVEkFQRCG1OjEnWyAY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0251",
    "chain": "QFC",
    "name": "QFC #807",
    "store_number": "807",
    "address": "2746 Ne 45Th St, Seattle",
    "city": "Seattle",
    "state": "WA",
    "zip": "98105",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 143,
    "lat": 47.66171869999999,
    "lng": -122.2958692,
    "formatted_address": "2746 NE 45th St, Seattle, WA 98105, USA",
    "place_id": "ChIJvWZykIUUkFQRg9KY2kL5MLw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0252",
    "chain": "QFC",
    "name": "QFC #808",
    "store_number": "808",
    "address": "10116 Ne 8Th St Ste 1",
    "city": "Bellevue",
    "state": "WA",
    "zip": "98004",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 144,
    "lat": 47.6185457,
    "lng": -122.2056187,
    "formatted_address": "10116 NE 8th St Ste 1, Bellevue, WA 98004, USA",
    "place_id": "ChIJVVUVeoVskFQRNPOSMZkslVs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0253",
    "chain": "QFC",
    "name": "QFC #811",
    "store_number": "811",
    "address": "1600 W Dravus St",
    "city": "Seattle",
    "state": "WA",
    "zip": "98119",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 145,
    "lat": 47.6496262,
    "lng": -122.3779145,
    "formatted_address": "1600 W Dravus St, Seattle, WA 98119, USA",
    "place_id": "ChIJU1Lnr5gVkFQRo50g5ZYxwUo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0254",
    "chain": "QFC",
    "name": "QFC #816",
    "store_number": "816",
    "address": "600 Nw Richmond Beach Rd",
    "city": "Shoreline",
    "state": "WA",
    "zip": "98177",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 146,
    "lat": 47.765625,
    "lng": -122.3657242,
    "formatted_address": "600 NW Richmond Beach Rd, Shoreline, WA 98177, USA",
    "place_id": "ChIJbWT3IJcQkFQRyIj0wfch6sM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0255",
    "chain": "QFC",
    "name": "QFC #825",
    "store_number": "825",
    "address": "2500 Sw Barton St",
    "city": "Seattle",
    "state": "WA",
    "zip": "98126",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 152,
    "lat": 47.522534,
    "lng": -122.3662913,
    "formatted_address": "2500 SW Barton St, Seattle, WA 98126, USA",
    "place_id": "ChIJqQ4WZ2dBkFQRCLLWyIJjYy4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0256",
    "chain": "QFC",
    "name": "QFC #826",
    "store_number": "826",
    "address": "15600 Ne 8Th St Ste K1",
    "city": "Bellevue",
    "state": "WA",
    "zip": "98008",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 153,
    "lat": 47.6194121,
    "lng": -122.1303444,
    "formatted_address": "15600 NE 8th St STE K-1, Bellevue, WA 98008, USA",
    "place_id": "ChIJCQjQg7BtkFQRXjnoZNH8sCs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0257",
    "chain": "QFC",
    "name": "QFC #827",
    "store_number": "827",
    "address": "6940 Coal Creek Pkwy Se",
    "city": "Newcastle",
    "state": "WA",
    "zip": "98059",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 154,
    "lat": 47.5388036,
    "lng": -122.1647808,
    "formatted_address": "6940 Coal Creek Pkwy SE, Newcastle, WA 98059, USA",
    "place_id": "ChIJz-NuHB9pkFQRhGbjIgwMWlQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0258",
    "chain": "QFC",
    "name": "QFC #828",
    "store_number": "828",
    "address": "11224 Ne 124Th St",
    "city": "Kirkland",
    "state": "WA",
    "zip": "98034",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 155,
    "lat": 47.7123828,
    "lng": -122.191207,
    "formatted_address": "11224 NE 124th St, Kirkland, WA 98034, USA",
    "place_id": "ChIJofkABngSkFQR3eVPPTgciKU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0259",
    "chain": "QFC",
    "name": "QFC #831",
    "store_number": "831",
    "address": "4101 49Th Ave Ne",
    "city": "Tacoma",
    "state": "WA",
    "zip": "98422",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 156,
    "lat": 47.2941205,
    "lng": -122.3805617,
    "formatted_address": "4101 49th Ave NE, Tacoma, WA 98422, USA",
    "place_id": "ChIJ71ZKx4pWkFQR_2vJZxTZkyg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0260",
    "chain": "QFC",
    "name": "QFC #832",
    "store_number": "832",
    "address": "11700 Mukilteo Speedway",
    "city": "Mukilteo",
    "state": "WA",
    "zip": "98275",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 157,
    "lat": 47.8919492,
    "lng": -122.2868942,
    "formatted_address": "11700 Mukilteo Speedway, Mukilteo, WA 98275, USA",
    "place_id": "ChIJb3aW4fcDkFQRvqIMpBbxvAw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0261",
    "chain": "QFC",
    "name": "QFC #835",
    "store_number": "835",
    "address": "7500 196Th St Sw Ste B",
    "city": "Lynnwood",
    "state": "WA",
    "zip": "98036",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 158,
    "lat": 47.8204187,
    "lng": -122.3347154,
    "formatted_address": "7500-A, 7500 196th St SW Ste B, Lynnwood, WA 98036, USA",
    "place_id": "ChIJE_7-v80akFQR4YLEKIm4wzU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0262",
    "chain": "QFC",
    "name": "QFC #837",
    "store_number": "837",
    "address": "22131 Se 237Th St",
    "city": "Maple Valley",
    "state": "WA",
    "zip": "98038",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 159,
    "lat": 47.3880236,
    "lng": -122.0450218,
    "formatted_address": "22131 SE 237th St, Maple Valley, WA 98038, USA",
    "place_id": "ChIJF3ECW11gkFQR7Z5KkoGC2Lo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0263",
    "chain": "QFC",
    "name": "QFC #839",
    "store_number": "839",
    "address": "7823 Se 28Th St,",
    "city": "Mercer Island",
    "state": "WA",
    "zip": "98040",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 160,
    "lat": 47.5848816,
    "lng": -122.2326933,
    "formatted_address": "7823 SE 28th St, Mercer Island, WA 98040, USA",
    "place_id": "ChIJN5FJfrlrkFQR_ERrGHSAIYc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0264",
    "chain": "QFC",
    "name": "QFC #847",
    "store_number": "847",
    "address": "1401 Broadway",
    "city": "Seattle",
    "state": "WA",
    "zip": "98122",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 163,
    "lat": 47.6139196,
    "lng": -122.3210437,
    "formatted_address": "1401 Broadway, Seattle, WA 98122, USA",
    "place_id": "ChIJ1e9Ad8xqkFQRkBIndSad7i8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0265",
    "chain": "QFC",
    "name": "QFC #852",
    "store_number": "852",
    "address": "4919 Evergreen Way",
    "city": "Everett",
    "state": "WA",
    "zip": "98203",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 166,
    "lat": 47.9525026,
    "lng": -122.2120411,
    "formatted_address": "4919 Evergreen Wy, Everett, WA 98203, USA",
    "place_id": "ChIJrS8iF48AkFQRlgQxA4v2Maw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0266",
    "chain": "QFC",
    "name": "QFC #853",
    "store_number": "853",
    "address": "2615 Broadway",
    "city": "Everett",
    "state": "WA",
    "zip": "98201",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 167,
    "lat": 47.9828004,
    "lng": -122.2005671,
    "formatted_address": "2615 Broadway, Everett, WA 98201, USA",
    "place_id": "ChIJsV8OZZaqmlQRejr6QVh7KN4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0267",
    "chain": "QFC",
    "name": "QFC #857",
    "store_number": "857",
    "address": "22803 44Th Ave W",
    "city": "Mt Lake Terrace",
    "state": "WA",
    "zip": "98043",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 168,
    "lat": 47.7905144,
    "lng": -122.2907114,
    "formatted_address": "22803 44th Ave W, Mountlake Terrace, WA 98043, USA",
    "place_id": "ChIJfUlWWx0QkFQRuIsGLoW3y2E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0268",
    "chain": "QFC",
    "name": "QFC #858",
    "store_number": "858",
    "address": "1531 Ne 145Th St Seattle",
    "city": "Seattle",
    "state": "WA",
    "zip": "98155",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 169,
    "lat": 47.7328327,
    "lng": -122.3112113,
    "formatted_address": "Parking lot, 1531 NE 145th St, Seattle, WA 98155, USA",
    "place_id": "ChIJURpvgg0RkFQRSeMWWm0xkaU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0269",
    "chain": "QFC",
    "name": "QFC #863",
    "store_number": "863",
    "address": "1009 Monroe Ave",
    "city": "Enumclaw",
    "state": "WA",
    "zip": "98022",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 172,
    "lat": 47.1996461,
    "lng": -121.9912743,
    "formatted_address": "1009 Monroe Ave, Enumclaw, WA 98022, USA",
    "place_id": "ChIJOUKg_ADykFQRrouyq_5e3yQ",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0270",
    "chain": "QFC",
    "name": "QFC #866",
    "store_number": "866",
    "address": "11100 Roosevelt Way Ne",
    "city": "Seattle",
    "state": "WA",
    "zip": "98125",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 173,
    "lat": 47.709396,
    "lng": -122.3172526,
    "formatted_address": "11100 Roosevelt Way NE, Seattle, WA 98125, USA",
    "place_id": "ChIJX8y8tVkRkFQRdpqtgDJ4jF8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0271",
    "chain": "QFC",
    "name": "QFC #869",
    "store_number": "869",
    "address": "1801 N 45Th St, Seattle",
    "city": "Seattle",
    "state": "WA",
    "zip": "98103",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 174,
    "lat": 47.6617313,
    "lng": -122.3358685,
    "formatted_address": "1801 N 45th St, Seattle, WA 98103, USA",
    "place_id": "ChIJ__VNUVcUkFQRIqG8g8cLskI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0272",
    "chain": "QFC",
    "name": "QFC #874",
    "store_number": "874",
    "address": "1510 145Th Pl Se",
    "city": "Bellevue",
    "state": "WA",
    "zip": "98007",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 177,
    "lat": 47.5969425,
    "lng": -122.1484573,
    "formatted_address": "1510 145th Pl SE, Bellevue, WA 98007, USA",
    "place_id": "ChIJmfkAYztskFQR-GVTjq2Yw1E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0273",
    "chain": "QFC",
    "name": "QFC #878",
    "store_number": "878",
    "address": "23475 Ne Novelty Hill Rd",
    "city": "Redmond",
    "state": "WA",
    "zip": "98053",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 178,
    "lat": 47.6987872,
    "lng": -122.0263063,
    "formatted_address": "23475 NE Novelty Hill Rd, Redmond, WA 98053, USA",
    "place_id": "ChIJC093LFhzkFQRb_gCKAXwtR4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0274",
    "chain": "QFC",
    "name": "QFC #881",
    "store_number": "881",
    "address": "500 Mercer St",
    "city": "Seattle",
    "state": "WA",
    "zip": "98109",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 180,
    "lat": 47.624798,
    "lng": -122.347142,
    "formatted_address": "500 Mercer St, Seattle, WA 98109, USA",
    "place_id": "ChIJP2o5QkcVkFQRhcqCq56D1X4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0275",
    "chain": "QFC",
    "name": "QFC #887",
    "store_number": "887",
    "address": "417 Broadway E # 2",
    "city": "Seattle",
    "state": "WA",
    "zip": "98102",
    "source_sheet": "Kroger Fred Meyer & QFC",
    "source_row": 182,
    "lat": 47.6225306,
    "lng": -122.3214759,
    "formatted_address": "417 Broadway E #2, Seattle, WA 98102, USA",
    "place_id": "ChIJAQBA4S0VkFQRsvT6XefX3Ic",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0276",
    "chain": "Fresh Fill Convenience Store",
    "name": "Fresh Fill Convenience Store",
    "store_number": "",
    "address": "131 Riverwalk Blvd S, Ste 100",
    "city": "Madera",
    "state": "CA",
    "zip": "93636",
    "source_sheet": "Independent Stores",
    "source_row": 3,
    "lat": 36.9222042,
    "lng": -119.798745,
    "formatted_address": "131 Riverwalk Blvd S Ste 100, Madera, CA 93636, USA",
    "place_id": "ChIJl5LZtg9qlIARrsqbCr0CLyA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0277",
    "chain": "ShopRite",
    "name": "Shoprite Of Spotswood",
    "store_number": "106",
    "address": "380 Summerhill Road",
    "city": "Spotswood",
    "state": "NJ",
    "zip": "08884",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 4,
    "lat": 40.4073444,
    "lng": -74.38537769999999,
    "formatted_address": "380 Summerhill Rd, Spotswood, NJ 08884, USA",
    "place_id": "ChIJ4x14qpnPw4kR8WWYr7hee_s",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0278",
    "chain": "ShopRite",
    "name": "Shoprite Of Ramsey",
    "store_number": "107",
    "address": "Rt 17 & Franklin Turnpike",
    "city": "Ramsey",
    "state": "NJ",
    "zip": "07446",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 5,
    "lat": 41.0644086,
    "lng": -74.1289771,
    "formatted_address": "NJ-17, Ramsey, NJ 07446, USA",
    "place_id": "EhxOSi0xNywgUmFtc2V5LCBOSiAwNzQ0NiwgVVNBIi4qLAoUChIJAatmX2b7wokR9XfcL_aV1NYSFAoSCRX_3dJd4cKJERQW978b0Orv",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0279",
    "chain": "ShopRite",
    "name": "Shoprite Of Forest & Richmond",
    "store_number": "109",
    "address": "985 Richmond Ave",
    "city": "Staten Island",
    "state": "NY",
    "zip": "10314",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 6,
    "lat": 40.6231856,
    "lng": -74.148743,
    "formatted_address": "985 Richmond Ave, Staten Island, NY 10314, USA",
    "place_id": "ChIJ923KE21NwokRrUI01Qk7QXE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0280",
    "chain": "ShopRite",
    "name": "Shoprite Of Lyndhurst",
    "store_number": "113",
    "address": "540 New York Ave",
    "city": "Lyndhurst",
    "state": "NJ",
    "zip": "07071",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 7,
    "lat": 40.8121497,
    "lng": -74.11858219999999,
    "formatted_address": "540 New York Ave, Lyndhurst, NJ 07071, USA",
    "place_id": "ChIJsQyWjgFWwokRORPgG9cUDhE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0281",
    "chain": "ShopRite",
    "name": "Shoprite Of Hylan Plaza",
    "store_number": "114",
    "address": "2656 Hylan Boulevard",
    "city": "Staten Island",
    "state": "NY",
    "zip": "10306",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 8,
    "lat": 40.5666288,
    "lng": -74.111981,
    "formatted_address": "Parking lot, 2656 Hylan Blvd, Staten Island, NY 10306, USA",
    "place_id": "ChIJkzOV4E9JwokRDIM4o1-Qunc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0282",
    "chain": "ShopRite",
    "name": "Shoprite Of Maple & Hemlock At Fairlawn",
    "store_number": "116",
    "address": "22-00 Maple Ave",
    "city": "Fair Lawn",
    "state": "NJ",
    "zip": "07410",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 9,
    "lat": 40.9460269,
    "lng": -74.14039199999999,
    "formatted_address": "22-00 Maple Ave, Fair Lawn, NJ 07410, USA",
    "place_id": "ChIJHb_E65H8wokRwptZj6dC0c4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0283",
    "chain": "ShopRite",
    "name": "Shoprite Of Emerson",
    "store_number": "117",
    "address": "425 Old Hook Road",
    "city": "Emerson",
    "state": "NJ",
    "zip": "07630",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 10,
    "lat": 40.9807314,
    "lng": -74.0067845,
    "formatted_address": "425 Old Hook Rd, Emerson, NJ 07630, USA",
    "place_id": "ChIJa3b9A5bvwokRQ0uD3WFgNtc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0284",
    "chain": "ShopRite",
    "name": "Shoprite Of Hoboken",
    "store_number": "118",
    "address": "900 Madison St",
    "city": "Hoboken",
    "state": "NJ",
    "zip": "07030",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 11,
    "lat": 40.7498807,
    "lng": -74.03632759999999,
    "formatted_address": "900 Madison St, Hoboken, NJ 07030, USA",
    "place_id": "ChIJvRDGe2RXwokRnXiXFYELTtI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0285",
    "chain": "ShopRite",
    "name": "Shoprite Of Bayonne-26 Street",
    "store_number": "119",
    "address": "583-9 Avenue C",
    "city": "Bayonne",
    "state": "NJ",
    "zip": "07002",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 12,
    "lat": 40.6673464,
    "lng": -74.11889479999999,
    "formatted_address": "583-9 Avenue C, Bayonne, NJ 07002, USA",
    "place_id": "ChIJEYjhL_dRwokRR0gZ8E6jpUs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0286",
    "chain": "ShopRite",
    "name": "Shoprite Of Lodi",
    "store_number": "122",
    "address": "175 Main Street",
    "city": "Lodi",
    "state": "NJ",
    "zip": "07644",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 13,
    "lat": 40.8794877,
    "lng": -74.084903,
    "formatted_address": "175 Main St, Lodi, NJ 07644, USA",
    "place_id": "ChIJx4EvQnr5wokRJ4x6XnrSY-M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0287",
    "chain": "ShopRite",
    "name": "Shoprite Of Columbia Park",
    "store_number": "130",
    "address": "3147 Kennedy Blvd",
    "city": "North Bergen",
    "state": "NJ",
    "zip": "07047",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 14,
    "lat": 40.774361,
    "lng": -74.03441169999999,
    "formatted_address": "3147 John F. Kennedy Blvd, Jersey City, NJ 07306, USA",
    "place_id": "ChIJtbpfGIlXwokROaBu5Fakr14",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0288",
    "chain": "ShopRite",
    "name": "Shoprite Of Hackensack",
    "store_number": "134",
    "address": "500 South River Street",
    "city": "Hackensack",
    "state": "NJ",
    "zip": "07601",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 15,
    "lat": 40.8641552,
    "lng": -74.03594319999999,
    "formatted_address": "500 S River St, Hackensack, NJ 07601, USA",
    "place_id": "ChIJtzxP0-b5wokRVGqSdp22Xkc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0289",
    "chain": "ShopRite",
    "name": "Shoprite Of Wallington",
    "store_number": "136",
    "address": "375 Paterson Ave",
    "city": "Wallington",
    "state": "NJ",
    "zip": "07057",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 16,
    "lat": 40.8451947,
    "lng": -74.1076454,
    "formatted_address": "375 Paterson Ave, Wallington, NJ 07057, USA",
    "place_id": "ChIJ0SojeNz4wokRrnC-rDlPzhk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0290",
    "chain": "ShopRite",
    "name": "Shop Rite Of Metro Plaza",
    "store_number": "139",
    "address": "Luis Marin Blvd & 6Th St",
    "city": "Jersey City",
    "state": "NJ",
    "zip": "07302",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 17,
    "lat": 40.725129,
    "lng": -74.0404397,
    "formatted_address": "Marin Blvd & 6th St, Jersey City, NJ 07302, USA",
    "place_id": "Ei9NYXJpbiBCbHZkICYgNnRoIFN0LCBKZXJzZXkgQ2l0eSwgTkogMDczMDIsIFVTQSJmImQKFAoSCWGaq5VSV8KJESuwQM5aG-8oEhQKEglhmquVUlfCiRErsEDOWhvvKBoUChIJ3VIXrlJXwokRapI787ShW0EaFAoSCaeTPzxNV8KJEedsJvGf6eVUIgoNWilGGBVTU97T",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0291",
    "chain": "ShopRite",
    "name": "Shoprite Of Wyckoff",
    "store_number": "140",
    "address": "430 Greenwood Ave",
    "city": "Wyckoff",
    "state": "NJ",
    "zip": "07481",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 18,
    "lat": 41.0130448,
    "lng": -74.16902499999999,
    "formatted_address": "430 Greenwood Ave, Wyckoff, NJ 07481, USA",
    "place_id": "ChIJ6TQjjwHjwokRzN7T-r2xxOw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0292",
    "chain": "ShopRite",
    "name": "Shoprite Of New Milford",
    "store_number": "141",
    "address": "250 River Road",
    "city": "Newmilford",
    "state": "NJ",
    "zip": "07646",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 19,
    "lat": 40.9443594,
    "lng": -74.0217325,
    "formatted_address": "250 River Rd, New Milford, NJ 07646, USA",
    "place_id": "ChIJTwXb8g7wwokR7SufSKqt_U4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0293",
    "chain": "ShopRite",
    "name": "Shoprite Of Palisales Park",
    "store_number": "150",
    "address": "Central Blvd & Depot Place",
    "city": "Palisades Park",
    "state": "NJ",
    "zip": "07650",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 20,
    "lat": 40.8516198,
    "lng": -74.0033548,
    "formatted_address": "W Central Blvd & Depot Pl, Palisades Park, NJ 07650, USA",
    "place_id": "EjhXIENlbnRyYWwgQmx2ZCAmIERlcG90IFBsLCBQYWxpc2FkZXMgUGFyaywgTkogMDc2NTAsIFVTQSJmImQKFAoSCXP6_YAT98KJEQ-__XWPiQQCEhQKEglz-v2AE_fCiREPv_11j4kEAhoUChIJ4-Pn3xP3wokR3JGatbP2Eh0aFAoSCSncq4ET98KJES0pW3wp05JyIgoNZnZZGBX0--PT",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0294",
    "chain": "ShopRite",
    "name": "Shoprite Of Hillsdale",
    "store_number": "151",
    "address": "372 Broadway",
    "city": "Hillsdale",
    "state": "NJ",
    "zip": "07642",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 21,
    "lat": 41.0127198,
    "lng": -74.0413586,
    "formatted_address": "372 Broadway, Hillsdale, NJ 07642, USA",
    "place_id": "ChIJBc4wJI7lwokRIl2_m5jQezg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0295",
    "chain": "ShopRite",
    "name": "Shoprite Of Northvale",
    "store_number": "153",
    "address": "246 Livingston Ave",
    "city": "Northvale",
    "state": "NJ",
    "zip": "07647",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 22,
    "lat": 41.0123628,
    "lng": -73.9448568,
    "formatted_address": "246 Livingston St, Northvale, NJ 07647, USA",
    "place_id": "ChIJ4-Z69aTuwokRCt1PL1wpV7A",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0296",
    "chain": "ShopRite",
    "name": "Shoprite Of Broadway & East 53Rd St",
    "store_number": "154",
    "address": "180 Broadway",
    "city": "Elmwood Park",
    "state": "NJ",
    "zip": "07407",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 23,
    "lat": 40.91983889999999,
    "lng": -74.12033679999999,
    "formatted_address": "180 Broadway, Elmwood Park, NJ 07407, USA",
    "place_id": "ChIJc4b3HIn7wokRzWuR8H0S2DY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0297",
    "chain": "ShopRite",
    "name": "Shoprite Of Old Bridge",
    "store_number": "161",
    "address": "600 Schulmeister Road",
    "city": "Old Bridge",
    "state": "NJ",
    "zip": "08857",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 24,
    "lat": 40.4223545,
    "lng": -74.3073843,
    "formatted_address": "600 Schulmeister Rd, Old Bridge, NJ 08857, USA",
    "place_id": "ChIJIVsGliHMw4kRrVCWivTk9_M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0298",
    "chain": "ShopRite",
    "name": "Shoprite Of Stroudsburg",
    "store_number": "165",
    "address": "344 Stroud Mall Road",
    "city": "Stroudsburg",
    "state": "PA",
    "zip": "18360",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 25,
    "lat": 40.9891344,
    "lng": -75.2238544,
    "formatted_address": "344 Stroud Mall Rd, Stroudsburg, PA 18360, USA",
    "place_id": "ChIJEZAo8L2JxIkREspEDDJlz74",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0299",
    "chain": "ShopRite",
    "name": "Shoprite Of Evergreen Plaza",
    "store_number": "172",
    "address": "100 Greaves Ln",
    "city": "Staten Island",
    "state": "NY",
    "zip": "10308",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 26,
    "lat": 40.5547273,
    "lng": -74.1438349,
    "formatted_address": "100 Greaves Ln, Staten Island, NY 10308, USA",
    "place_id": "ChIJaXL80cZLwokRNHZ5NUY4HzM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0300",
    "chain": "ShopRite",
    "name": "Shoprite Of Marlboro",
    "store_number": "193",
    "address": "280 Union Hill Rd & Rt 9",
    "city": "Marlboro",
    "state": "NJ",
    "zip": "07751",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 27,
    "lat": 40.3307824,
    "lng": -74.329194,
    "formatted_address": "280 Union Hill Rd #9, Manalapan Township, NJ 07726, USA",
    "place_id": "EjcyODAgVW5pb24gSGlsbCBSZCAjOSwgTWFuYWxhcGFuIFRvd25zaGlwLCBOSiAwNzcyNiwgVVNBIh0aGwoWChQKEgnrpdomnNHDiRGRncWmi9zZeBIBOQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0301",
    "chain": "ShopRite",
    "name": "Shoprite Of North Bedford Rd",
    "store_number": "198",
    "address": "333 N. Bedford Rd",
    "city": "Mt. Kisco",
    "state": "NY",
    "zip": "10549",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 28,
    "lat": 41.2182037,
    "lng": -73.7200477,
    "formatted_address": "333 N Bedford Rd, Mt Kisco, NY 10549, USA",
    "place_id": "ChIJ-YAzNnK6wokRrgMsz17LcoM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0302",
    "chain": "ShopRite",
    "name": "Shoprite Of Croton",
    "store_number": "202",
    "address": "460 South Riverside Ave",
    "city": "Croton-On-Hudson",
    "state": "NY",
    "zip": "10520",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 29,
    "lat": 41.1921696,
    "lng": -73.879487,
    "formatted_address": "460 S Riverside Ave, Croton-On-Hudson, NY 10520, USA",
    "place_id": "ChIJgx0RCRjHwokRpHh2xBhRQX8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0303",
    "chain": "ShopRite",
    "name": "Shoprite Of Byram",
    "store_number": "203",
    "address": "90-80 Route 206 North",
    "city": "Byram",
    "state": "NJ",
    "zip": "07874",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 30,
    "lat": 40.9346234,
    "lng": -74.7185911,
    "formatted_address": "90-80 US-206, Stanhope, NJ 07874, USA",
    "place_id": "ChIJ50O781h2w4kR4vky9DvK-nU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0304",
    "chain": "ShopRite",
    "name": "Shoprite Little Falls",
    "store_number": "205",
    "address": "Browertown Rd",
    "city": "Little Falls",
    "state": "NJ",
    "zip": "07424",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 31,
    "lat": 40.8804028,
    "lng": -74.2120585,
    "formatted_address": "Browertown Rd, Little Falls Township, NJ 07424, USA",
    "place_id": "EjNCcm93ZXJ0b3duIFJkLCBMaXR0bGUgRmFsbHMgVG93bnNoaXAsIE5KIDA3NDI0LCBVU0EiLiosChQKEglTg1iBIv7CiRFyzj3axHTvqBIUChIJG5Rsv9YBw4kRbSAGfIdVtQ4",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0305",
    "chain": "ShopRite",
    "name": "Shoprite Of Pughkeepsie",
    "store_number": "206",
    "address": "1895 South Rd Suite 3B",
    "city": "Pughkeepsie",
    "state": "NY",
    "zip": "12601",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 32,
    "lat": 41.6193598,
    "lng": -73.9196071,
    "formatted_address": "1895 South Rd Ste 3B, Poughkeepsie, NY 12601, USA",
    "place_id": "ChIJMbAOF2453YkRAeYCQlYhfzk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0306",
    "chain": "ShopRite",
    "name": "Shoprite Of Wallkill",
    "store_number": "211",
    "address": "20 Lloyds Lane",
    "city": "Middletown",
    "state": "NY",
    "zip": "10940",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 33,
    "lat": 41.4534415,
    "lng": -74.3967218,
    "formatted_address": "20 Lloyds Ln, Middletown, NY 10940, USA",
    "place_id": "ChIJzXHGHWUtw4kRDKvczmJ24LY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0307",
    "chain": "ShopRite",
    "name": "Shoprite Of Flanders",
    "store_number": "212",
    "address": "90 Barley Road",
    "city": "Flanders",
    "state": "NJ",
    "zip": "07836",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 34,
    "lat": 40.8501711,
    "lng": -74.70444250000001,
    "formatted_address": "Roxbury Township, NJ 07836, USA",
    "place_id": "ChIJaa1h7jWcw4kRNWLHgBhknT0",
    "geocode_location_type": "APPROXIMATE"
  },
  {
    "id": "pb-0308",
    "chain": "ShopRite",
    "name": "Shoprite Of Newton",
    "store_number": "213",
    "address": "127 Water Street",
    "city": "Newton",
    "state": "NJ",
    "zip": "07860",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 35,
    "lat": 41.0655502,
    "lng": -74.7448489,
    "formatted_address": "127 Water St, Newton, NJ 07860, USA",
    "place_id": "ChIJq_n0fNBvw4kR1FKrvjOajGQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0309",
    "chain": "ShopRite",
    "name": "Shoprite Of Wayne Hills Mall",
    "store_number": "217",
    "address": "30 Wayne Hills Mall",
    "city": "Wayne",
    "state": "NJ",
    "zip": "07470",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 36,
    "lat": 40.9626869,
    "lng": -74.238973,
    "formatted_address": "30 Wayne Hills Mall, Wayne, NJ 07470, USA",
    "place_id": "ChIJzSIQc5MCw4kRvTU8pB6TBlg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0310",
    "chain": "ShopRite",
    "name": "Shoprite Of New City",
    "store_number": "222",
    "address": "Main St",
    "city": "New City",
    "state": "NY",
    "zip": "10956",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 37,
    "lat": 41.1338288,
    "lng": -73.9912175,
    "formatted_address": "S Main St, New City, NY 10956, USA",
    "place_id": "ChIJ27ikyPPCwokR2746SIoohr0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0311",
    "chain": "ShopRite",
    "name": "Shoprite Of Mansfield",
    "store_number": "224",
    "address": "Rt 57 West & Allen St",
    "city": "Hackettstown",
    "state": "NJ",
    "zip": "07840",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 38,
    "lat": 40.8240712,
    "lng": -74.8339263,
    "formatted_address": "NJ-57 & Allen Rd, Mansfield Township, NJ 07840, USA",
    "place_id": "EjNOSi01NyAmIEFsbGVuIFJkLCBNYW5zZmllbGQgVG93bnNoaXAsIE5KIDA3ODQwLCBVU0EiZiJkChQKEgkRc19De4TDiRG8XeBmk1upnRIUChIJEXNfQ3uEw4kRvF3gZpNbqZ0aFAoSCTtVE6WNd8SJETHvz1kcXJ-AGhQKEgmBAVP7doTDiRFfBcxPprMGvCIKDUhCVRgVwT9l0w",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0312",
    "chain": "ShopRite",
    "name": "Shoprite Of White Plains",
    "store_number": "231",
    "address": "13 City Place",
    "city": "White Plains",
    "state": "NY",
    "zip": "10601",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 39,
    "lat": 41.0320498,
    "lng": -73.76562059999999,
    "formatted_address": "13 City Pl, White Plains, NY 10601, USA",
    "place_id": "ChIJI1c4KzGUwokRxDOzoXfSHBA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0313",
    "chain": "ShopRite",
    "name": "Shoprtie Of Carmel",
    "store_number": "235",
    "address": "184 Route 52",
    "city": "Carmel",
    "state": "NY",
    "zip": "10512",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 40,
    "lat": 41.43532030000001,
    "lng": -73.68047709999999,
    "formatted_address": "184 NY-52, Carmel Hamlet, NY 10512, USA",
    "place_id": "ChIJ_Zc1AL9N3YkRDJwDWTZ2wYE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0314",
    "chain": "ShopRite",
    "name": "Shoprite Of Monroe",
    "store_number": "237",
    "address": "785 State Route 17M, Suite 1",
    "city": "Monroe",
    "state": "NY",
    "zip": "10950",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 41,
    "lat": 41.3317172,
    "lng": -74.1939025,
    "formatted_address": "785 NY-17M Ste 1, Monroe, NY 10950, USA",
    "place_id": "ChIJN9k687XXwokRkxRxUYw15i8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0315",
    "chain": "ShopRite",
    "name": "Shoprite Of Mongomery, Ny",
    "store_number": "239",
    "address": "99 Hawkins Dr",
    "city": "Mongomery",
    "state": "NY",
    "zip": "12549",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 42,
    "lat": 41.5113633,
    "lng": -74.21032029999999,
    "formatted_address": "99 Hawkins Dr, Montgomery, NY 12549, USA",
    "place_id": "ChIJ9XhkCnMq3YkRn4ivxZ_R9Rg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0316",
    "chain": "ShopRite",
    "name": "Shoprite Of Kingston",
    "store_number": "241",
    "address": "801 Miron Lane",
    "city": "Kingston",
    "state": "NY",
    "zip": "12401",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 43,
    "lat": 41.9602178,
    "lng": -73.9861444,
    "formatted_address": "801 Miron Ln, Kingston, NY 12401, USA",
    "place_id": "ChIJhzXO_igP3YkRYDS2lbdBxjM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0317",
    "chain": "ShopRite",
    "name": "Shoprite Of West Milford",
    "store_number": "257",
    "address": "23 Marshall Hill Road",
    "city": "West Milford",
    "state": "NJ",
    "zip": "07480",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 44,
    "lat": 41.1326421,
    "lng": -74.3657058,
    "formatted_address": "23 Marshall Hill Rd, West Milford, NJ 07480, USA",
    "place_id": "ChIJXeA0x1AYw4kRk5S3wk71Z7Q",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0318",
    "chain": "ShopRite",
    "name": "Shoprite Of Vailsgate",
    "store_number": "260",
    "address": "384 Windsor Highway",
    "city": "Vails Gate",
    "state": "NY",
    "zip": "12584",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 45,
    "lat": 41.4575462,
    "lng": -74.0573725,
    "formatted_address": "384 Windsor Hwy, New Windsor, NY 12553, USA",
    "place_id": "ChIJayyJcBQt3YkRG8kAZGUw_S8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0319",
    "chain": "ShopRite",
    "name": "Shoprite Liberty",
    "store_number": "263",
    "address": "1955 State Rte 52",
    "city": "Liberty",
    "state": "NY",
    "zip": "12754",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 46,
    "lat": 41.7830619,
    "lng": -74.7206669,
    "formatted_address": "1955 NY-52, Liberty, NY 12754, USA",
    "place_id": "ChIJkcShQ0O83IkRXbLu8FV63Vw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0320",
    "chain": "ShopRite",
    "name": "Shoprite Of Warwick",
    "store_number": "267",
    "address": "153 State Route 945",
    "city": "Warwick",
    "state": "NY",
    "zip": "10990",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 47,
    "lat": 41.256483,
    "lng": -74.3598755,
    "formatted_address": "Warwick, NY 10990, USA",
    "place_id": "ChIJ35JPwlgjw4kRQ1uEvdo61IM",
    "geocode_location_type": "APPROXIMATE"
  },
  {
    "id": "pb-0321",
    "chain": "ShopRite",
    "name": "Shoprite Of Stony Point",
    "store_number": "268",
    "address": "22 Holtdrive",
    "city": "Stiny Point",
    "state": "NY",
    "zip": "10980",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 48,
    "lat": 41.21774629999999,
    "lng": -73.98241860000002,
    "formatted_address": "22 Holt Dr, Stony Point, NY 10980, USA",
    "place_id": "ChIJseoTBVjEwokRdJjw1NA7Tfg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0322",
    "chain": "ShopRite",
    "name": "Shoprite Middletown",
    "store_number": "272",
    "address": "125 Doison Ave",
    "city": "Middletown",
    "state": "NY",
    "zip": "10940",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 49,
    "lat": 41.4309326,
    "lng": -74.4221421,
    "formatted_address": "125 Dolson Ave, Middletown, NY 10940, USA",
    "place_id": "ChIJTUeqoG4yw4kRBPa4biKh_Eo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0323",
    "chain": "ShopRite",
    "name": "Shoprite Of Chester, Nj",
    "store_number": "273",
    "address": "Rt 206 Maple Ave",
    "city": "Chester",
    "state": "NJ",
    "zip": "07930",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 50,
    "lat": 40.7812421,
    "lng": -74.6982122,
    "formatted_address": "Maple Ave & US-206, Chester, NJ 07930, USA",
    "place_id": "EipNYXBsZSBBdmUgJiBVUy0yMDYsIENoZXN0ZXIsIE5KIDA3OTMwLCBVU0EiZiJkChQKEgkLhIjm0ZvDiRFqPSCsGzTWKRIUChIJC4SI5tGbw4kRaj0grBs01ikaFAoSCa_MgVfQm8OJEbg57CH87c2zGhQKEgnXcaHtv-7DiRHD-FntuWCihCIKDUW5ThgVFvV50w",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0324",
    "chain": "ShopRite",
    "name": "Shoprite Of North Poughkeepsie",
    "store_number": "274",
    "address": "10 Winslow Gate Road",
    "city": "Pughkeepsie",
    "state": "NY",
    "zip": "12601",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 51,
    "lat": 41.7291829,
    "lng": -73.92872899999999,
    "formatted_address": "10 Winslow Gate Rd, Poughkeepsie, NY 12601, USA",
    "place_id": "ChIJbdsF5PgV3YkRngdcDlIsLPA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0325",
    "chain": "ShopRite",
    "name": "Shoprite Of Tuckahoe",
    "store_number": "275",
    "address": "278 Tuckahoe Road",
    "city": "Yonkers",
    "state": "NY",
    "zip": "10710",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 52,
    "lat": 40.9533578,
    "lng": -73.8587301,
    "formatted_address": "278 Tuckahoe Rd, Yonkers, NY 10710, USA",
    "place_id": "ChIJ8dRwRkftwokRn-1P9e-qBrk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0326",
    "chain": "ShopRite",
    "name": "Shoprite Of Thornwood",
    "store_number": "276",
    "address": "960 Broadway Rt 141",
    "city": "Thornwood",
    "state": "NY",
    "zip": "10594",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 53,
    "lat": 41.1251335,
    "lng": -73.7792255,
    "formatted_address": "Town Center Shopping Center, 960 Broadway #141, Thornwood, NY 10594, USA",
    "place_id": "EkhUb3duIENlbnRlciBTaG9wcGluZyBDZW50ZXIsIDk2MCBCcm9hZHdheSAjMTQxLCBUaG9ybndvb2QsIE5ZIDEwNTk0LCBVU0EiHxodChYKFAoSCR3Y4jDxvsKJETl2YpP7sqaMEgMxNDE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0327",
    "chain": "ShopRite",
    "name": "Shoprite Of Hudson",
    "store_number": "277",
    "address": "351 Fairview Ave",
    "city": "Hudson",
    "state": "NY",
    "zip": "12534",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 54,
    "lat": 42.2713261,
    "lng": -73.7628627,
    "formatted_address": "351 Fairview Ave, Hudson, NY 12534, USA",
    "place_id": "ChIJc3lKdW-U3YkRT_NOKLr9azo",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0328",
    "chain": "ShopRite",
    "name": "Shoprite Cortlandt",
    "store_number": "278",
    "address": "3140 East Main St, Suite 300",
    "city": "Mohegan Lake",
    "state": "NY",
    "zip": "10547",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 55,
    "lat": 41.3141812,
    "lng": -73.8685994,
    "formatted_address": "3140 E Main St Ste 300, Mohegan Lake, NY 10547, USA",
    "place_id": "ChIJLSl1hJPJwokR-NTvjxqwaHE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0329",
    "chain": "ShopRite",
    "name": "Shoprite Of Succasunna",
    "store_number": "281",
    "address": "State Route 10 East Suite 24",
    "city": "Roxbury Township",
    "state": "NJ",
    "zip": "07876",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 56,
    "lat": 40.8672399,
    "lng": -74.6391663,
    "formatted_address": "NJ-10, Succasunna, NJ 07876, USA",
    "place_id": "EiBOSi0xMCwgU3VjY2FzdW5uYSwgTkogMDc4NzYsIFVTQSIuKiwKFAoSCc9es84Jp8OJEc_fyuzYLOIcEhQKEgkxYeoyWp7DiRGShYGsslhoqA",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0330",
    "chain": "ShopRite",
    "name": "Shoprite Of Sparta",
    "store_number": "283",
    "address": "18 North Village Blvd",
    "city": "Sparta",
    "state": "NJ",
    "zip": "07871",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 57,
    "lat": 41.07651070000001,
    "lng": -74.6564317,
    "formatted_address": "18 N Village Blvd, Sparta, NJ 07871, USA",
    "place_id": "ChIJ24rAvrBtw4kRyqu0MRZyK58",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0331",
    "chain": "ShopRite",
    "name": "Shoprite Of Chatham",
    "store_number": "284",
    "address": "641 Shunpike Road",
    "city": "Chatham",
    "state": "NJ",
    "zip": "07928",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 58,
    "lat": 40.7452523,
    "lng": -74.43122029999999,
    "formatted_address": "641 Shunpike Rd, Chatham Township, NJ 07928, USA",
    "place_id": "ChIJgUB9TqKlw4kRfiFQKVKVYMQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0332",
    "chain": "ShopRite",
    "name": "Shoprite Of Sussex",
    "store_number": "285",
    "address": "1 Wiebel Plaza",
    "city": "Sussex",
    "state": "NJ",
    "zip": "07461",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 59,
    "lat": 41.2038878,
    "lng": -74.60438719999999,
    "formatted_address": "1 Wiebel Plaza, Sussex, NJ 07461, USA",
    "place_id": "ChIJk8VhzBpAw4kRRafaE_H7Qw8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0333",
    "chain": "ShopRite",
    "name": "Shoprite West Nyack",
    "store_number": "288",
    "address": "243 East Route 59",
    "city": "West Nyack",
    "state": "NY",
    "zip": "10994",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 60,
    "lat": 41.0790196,
    "lng": -73.9879385,
    "formatted_address": "243 East St #59, West Nyack, NY 10994, USA",
    "place_id": "ChIJAQCMMFLowokRIbUIHvhf9k0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0334",
    "chain": "ShopRite",
    "name": "Shoprite Scarsdale",
    "store_number": "290",
    "address": "955 Central Ave",
    "city": "Scarsdale",
    "state": "NY",
    "zip": "10583",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 61,
    "lat": 40.99196140000001,
    "lng": -73.8229229,
    "formatted_address": "955 S Central Ave, Scarsdale, NY 10583, USA",
    "place_id": "ChIJ46BvPkGTwokRbBmQqRb8tWA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0335",
    "chain": "ShopRite",
    "name": "Shoprite Of Franklin",
    "store_number": "291",
    "address": "270 Nj-23",
    "city": "Franklin",
    "state": "NJ",
    "zip": "07416",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 62,
    "lat": 41.1164539,
    "lng": -74.57957139999999,
    "formatted_address": "270 NJ-23, Franklin, NJ 07416, USA",
    "place_id": "ChIJy7zrs6cUw4kRa5zxYMnGzKs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0336",
    "chain": "ShopRite",
    "name": "Shoprite Of Lincoln Park",
    "store_number": "297",
    "address": "60 Beaver Brook Rd",
    "city": "Lincoln Park",
    "state": "NJ",
    "zip": "07035",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 63,
    "lat": 40.9253165,
    "lng": -74.3091865,
    "formatted_address": "60 Beaverbrook Rd, Lincoln Park, NJ 07035, USA",
    "place_id": "ChIJu3jK3PgDw4kR3MKqpCIcZcY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0337",
    "chain": "ShopRite",
    "name": "Shoprite Southington",
    "store_number": "315",
    "address": "750 Queen Street",
    "city": "Southington",
    "state": "CT",
    "zip": "06489",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 64,
    "lat": 41.6368048,
    "lng": -72.874994,
    "formatted_address": "750 Queen St, Southington, CT 06489, USA",
    "place_id": "ChIJ_S1aeDi354kRt1w_zgICboo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0338",
    "chain": "ShopRite",
    "name": "Shoprite Clinton Ct",
    "store_number": "318",
    "address": "266 East Main Street",
    "city": "Clinton",
    "state": "CT",
    "zip": "06413",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 65,
    "lat": 41.27023399999999,
    "lng": -72.5004703,
    "formatted_address": "266 E Main St, Clinton, CT 06413, USA",
    "place_id": "ChIJ36X7hQ0m5okREhssLO_XD9o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0339",
    "chain": "ShopRite",
    "name": "Shoprite Of Brookside Plaza",
    "store_number": "319",
    "address": "40 Hazard Ave",
    "city": "Enfield",
    "state": "CT",
    "zip": "06082",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 66,
    "lat": 41.9879404,
    "lng": -72.5788245,
    "formatted_address": "40 Hazard Ave, Enfield, CT 06082, USA",
    "place_id": "ChIJD6JBQy375okRQKVCkZy6UJA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0340",
    "chain": "ShopRite",
    "name": "Shoprite Of East Haven",
    "store_number": "326",
    "address": "745 Foxon Rd",
    "city": "East Haven",
    "state": "CT",
    "zip": "06513",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 67,
    "lat": 41.323491,
    "lng": -72.85488269999999,
    "formatted_address": "745 Foxon Rd, East Haven, CT 06513, USA",
    "place_id": "ChIJy6oBNibX54kRlJbtbBj7i1k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0341",
    "chain": "ShopRite",
    "name": "Shoprite Of Manchester",
    "store_number": "330",
    "address": "214 Spencer St",
    "city": "Manchester",
    "state": "CT",
    "zip": "06040",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 68,
    "lat": 41.7656607,
    "lng": -72.5704842,
    "formatted_address": "214 Spencer St, Manchester, CT 06040, USA",
    "place_id": "ChIJkRcVgddW5okRaNH90QOvz3g",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0342",
    "chain": "ShopRite",
    "name": "Shoprite Of Cromwell",
    "store_number": "331",
    "address": "45 Shunpike Road",
    "city": "Cromwell",
    "state": "CT",
    "zip": "06416",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 69,
    "lat": 41.6041365,
    "lng": -72.67849489999999,
    "formatted_address": "45 Shunpike Rd, Cromwell, CT 06416, USA",
    "place_id": "ChIJ59msmW5L5okRoOInN3cIYY0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0343",
    "chain": "ShopRite",
    "name": "Shoprite Of Norwich",
    "store_number": "336",
    "address": "634 West Main St",
    "city": "Norwich",
    "state": "CT",
    "zip": "06360",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 70,
    "lat": 41.5136395,
    "lng": -72.1012602,
    "formatted_address": "634 W Main St, Norwich, CT 06360, USA",
    "place_id": "ChIJZTVVQTFy5okRaHUwf2Loy9s",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0344",
    "chain": "ShopRite",
    "name": "Shoprite Of East Hartford",
    "store_number": "340",
    "address": "31 Main Street",
    "city": "East Hartford",
    "state": "CT",
    "zip": "06118",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 71,
    "lat": 41.7278723,
    "lng": -72.6191824,
    "formatted_address": "31 Main St, East Hartford, CT 06118, USA",
    "place_id": "ChIJj7cLUNRT5okRu8boi4cyiOA",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0345",
    "chain": "ShopRite",
    "name": "Shoprite Of New London",
    "store_number": "354",
    "address": "351 North Frontage Rd",
    "city": "New London",
    "state": "CT",
    "zip": "06320",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 72,
    "lat": 41.3720799,
    "lng": -72.1182872,
    "formatted_address": "351 N Frontage Rd, New London, CT 06320, USA",
    "place_id": "ChIJD9AbOb8P5okR2Ftkn4LKusY",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0346",
    "chain": "ShopRite",
    "name": "Shoprite Parsippany",
    "store_number": "355",
    "address": "808 Route 46",
    "city": "Parsippany",
    "state": "NJ",
    "zip": "07054",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 73,
    "lat": 40.8647411,
    "lng": -74.3766666,
    "formatted_address": "808 US-46, Parsippany, NJ 07054, USA",
    "place_id": "ChIJ2QXrqpYHw4kRM00Ve9VFr3o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0347",
    "chain": "ShopRite",
    "name": "Shoprite Of Canton",
    "store_number": "367",
    "address": "110 Albany Turnpike, Suite 200",
    "city": "Canton",
    "state": "CT",
    "zip": "06019",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 74,
    "lat": 41.8236226,
    "lng": -72.88459329999999,
    "formatted_address": "SHOPPES AT FARMINGTON VALLEY, 110 Albany Turnpike #200, Canton, CT 06019, USA",
    "place_id": "ChIJz3Lqeb2o54kRr2nESk22zuM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0348",
    "chain": "ShopRite",
    "name": "Shoprite Of Shippan Ave - Stamford, Ct",
    "store_number": "390",
    "address": "200 Shippan Ave",
    "city": "Stamford",
    "state": "CT",
    "zip": "06902",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 75,
    "lat": 41.048027,
    "lng": -73.524193,
    "formatted_address": "200 Shippan Ave, Stamford, CT 06902, USA",
    "place_id": "ChIJ20wPKNihwokRvAHZ5BUmrAw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0349",
    "chain": "ShopRite",
    "name": "Grade A Markets Hope St",
    "store_number": "395",
    "address": "495 Hopest",
    "city": "Stamford",
    "state": "CT",
    "zip": "06906",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 76,
    "lat": 41.0761645,
    "lng": -73.5224171,
    "formatted_address": "495 Hope St, Stamford, CT 06906, USA",
    "place_id": "ChIJkV8aPq-hwokRUk8cPTsOPbY",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0350",
    "chain": "ShopRite",
    "name": "Shoprite Of Commerce St.-Stamford, Ct",
    "store_number": "397",
    "address": "1990 West Main Street",
    "city": "Stamford",
    "state": "CT",
    "zip": "06902",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 77,
    "lat": 41.0474004,
    "lng": -73.5649476,
    "formatted_address": "1990 W Main St, Stamford, CT 06902, USA",
    "place_id": "ChIJi5ftLqqYwokRIT3bQwywwsE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0351",
    "chain": "ShopRite",
    "name": "Shoprite Of Shelton",
    "store_number": "398",
    "address": "875 Bridgeport Ave",
    "city": "Shelton",
    "state": "CT",
    "zip": "06484",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 78,
    "lat": 41.2648503,
    "lng": -73.1346992,
    "formatted_address": "875 Bridgeport Ave, Shelton, CT 06484, USA",
    "place_id": "ChIJ9fSgq_gK6IkRSiLYo6a203A",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0352",
    "chain": "ShopRite",
    "name": "Shoprite Of Yardley",
    "store_number": "407",
    "address": "1603 Big Oak Road",
    "city": "Yardley",
    "state": "PA",
    "zip": "19067",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 79,
    "lat": 40.198262,
    "lng": -74.8629574,
    "formatted_address": "1603 Big Oak Rd, Morrisville, PA 19067, USA",
    "place_id": "ChIJrzichVJRwYkRD-RP-Nt8QjA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0353",
    "chain": "ShopRite",
    "name": "Shoprite Of Fairless Hills",
    "store_number": "427",
    "address": "547 S Oxford Valley Rd",
    "city": "Fairless Hills",
    "state": "PA",
    "zip": "19030",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 80,
    "lat": 40.1693967,
    "lng": -74.8475148,
    "formatted_address": "547 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
    "place_id": "ChIJndijjBJRwYkRkERHuigJsDs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0354",
    "chain": "ShopRite",
    "name": "Shoprite Of Stroudsburg",
    "store_number": "433",
    "address": "344 Stroud Mall Road",
    "city": "Stroudsburg",
    "state": "PA",
    "zip": "18360",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 81,
    "lat": 40.9891344,
    "lng": -75.2238544,
    "formatted_address": "344 Stroud Mall Rd, Stroudsburg, PA 18360, USA",
    "place_id": "ChIJEZAo8L2JxIkREspEDDJlz74",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0355",
    "chain": "ShopRite",
    "name": "Shoprite Of Washington, Nj-Rt 31",
    "store_number": "434",
    "address": "2 Clubhouse Drive Rt 31 South",
    "city": "Washington",
    "state": "NJ",
    "zip": "07882",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 82,
    "lat": 40.738468,
    "lng": -74.97548929999999,
    "formatted_address": "2 Clubhouse Drive, Washington, NJ 07882, USA",
    "place_id": "ChIJiTl6ZdF3xIkREMFXQN-oYII",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0356",
    "chain": "ShopRite",
    "name": "Shoprite Of Greenwich",
    "store_number": "437",
    "address": "1207 Rt 22",
    "city": "Phillipsburg",
    "state": "NJ",
    "zip": "08865",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 83,
    "lat": 40.6811844,
    "lng": -75.1475265,
    "formatted_address": "1207 US-22, Phillipsburg, NJ 08865, USA",
    "place_id": "EicxMjA3IFVTLTIyLCBQaGlsbGlwc2J1cmcsIE5KIDA4ODY1LCBVU0EiMRIvChQKEgk5vRQLfHLEiRHhgcIL9DIvsRC3CSoUChIJg71_qp7MyokR53dbandiqc0",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0357",
    "chain": "ShopRite",
    "name": "Shoprite Of Hissborough",
    "store_number": "447",
    "address": "Rt 206 & Amwell Rd",
    "city": "Hillsborough",
    "state": "NJ",
    "zip": "08844",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 84,
    "lat": 40.5023037,
    "lng": -74.64470829999999,
    "formatted_address": "US-206 & Amwell Rd, Hillsborough Township, NJ 08844, USA",
    "place_id": "EjhVUy0yMDYgJiBBbXdlbGwgUmQsIEhpbGxzYm9yb3VnaCBUb3duc2hpcCwgTkogMDg4NDQsIFVTQSJmImQKFAoSCf9OYc7N68OJEWxgWM4XfQc_EhQKEgn_TmHOzevDiRFsYFjOF30HPxoUChIJ13Gh7b_uw4kRw_hZ7blgooQaFAoSCVtRZAlf6cOJEa5_NJybUXPrIgoNPSkkGBUVH4LT",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0358",
    "chain": "ShopRite",
    "name": "Shoprite Of Bethlehem",
    "store_number": "449",
    "address": "4701 Freemansburg Ave",
    "city": "Bethlehem",
    "state": "PA",
    "zip": "18045",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 85,
    "lat": 40.65128250000001,
    "lng": -75.2931397,
    "formatted_address": "4701 Freemansburg Ave, Easton, PA 18045, USA",
    "place_id": "ChIJixT559UUxIkRF2nBZ_lkPFU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0359",
    "chain": "ShopRite",
    "name": "Shoprite Of Morrell Plaza",
    "store_number": "450",
    "address": "9910 Frankford Ave",
    "city": "Philadelphia",
    "state": "PA",
    "zip": "19114",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 86,
    "lat": 40.0649622,
    "lng": -74.9839082,
    "formatted_address": "9910 Frankford Ave, Philadelphia, PA 19114, USA",
    "place_id": "ChIJ__-_P1uzxokRqs6iKshARZY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0360",
    "chain": "ShopRite",
    "name": "Shoprite Of Somerset",
    "store_number": "451",
    "address": "435 Elizabeth Ave",
    "city": "Somerset",
    "state": "NJ",
    "zip": "08873",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 87,
    "lat": 40.5306498,
    "lng": -74.53772289999999,
    "formatted_address": "435 Elizabeth Ave, Somerset, NJ 08873, USA",
    "place_id": "ChIJN13M0_PAw4kR9E3y1Gqt2KU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0361",
    "chain": "ShopRite",
    "name": "Shoprite Of Brookhaven",
    "store_number": "452",
    "address": "5075 Edgmontave",
    "city": "Brookhaven",
    "state": "PA",
    "zip": "19015",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 88,
    "lat": 39.8798585,
    "lng": -75.3956461,
    "formatted_address": "5075 Edgmont Ave, Brookhaven, PA 19015, USA",
    "place_id": "ChIJgY2VDY_oxokRm28RbUFhBVE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0362",
    "chain": "ShopRite",
    "name": "Shoprite Of Bernardsville",
    "store_number": "453",
    "address": "93 Morristown Road",
    "city": "Bernardsville",
    "state": "NJ",
    "zip": "07924",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 89,
    "lat": 40.7189729,
    "lng": -74.5621645,
    "formatted_address": "93 Morristown Rd, Bernardsville, NJ 07924, USA",
    "place_id": "ChIJV8uW8syiw4kRoQ_GNoo4Q1c",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0363",
    "chain": "ShopRite",
    "name": "Shoprite Of Flemington",
    "store_number": "457",
    "address": "272 Rt 202 & 31",
    "city": "Flemington",
    "state": "NJ",
    "zip": "08822",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 90,
    "lat": 40.4971313,
    "lng": -74.8554178,
    "formatted_address": "272 US-202 #31, Flemington, NJ 08822, USA",
    "place_id": "EikyNzIgVVMtMjAyICMzMSwgRmxlbWluZ3RvbiwgTkogMDg4MjIsIFVTQSIeGhwKFgoUChIJm_zZPj_xw4kRcLGI8oArDrgSAjMx",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0364",
    "chain": "ShopRite",
    "name": "Shoprite Of Bound Rock",
    "store_number": "466",
    "address": "611 West Union Ave",
    "city": "Bound Brook",
    "state": "NJ",
    "zip": "08805",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 91,
    "lat": 40.5703708,
    "lng": -74.5530864,
    "formatted_address": "611 W Union Ave, Bound Brook, NJ 08805, USA",
    "place_id": "ChIJmWShkZu_w4kRUUyLs_n3Gqw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0365",
    "chain": "ShopRite",
    "name": "Shoprite Of Somerville",
    "store_number": "468",
    "address": "1 South Davenport St",
    "city": "Somerville",
    "state": "NJ",
    "zip": "08876",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 92,
    "lat": 40.5678267,
    "lng": -74.6151672,
    "formatted_address": "1 S Davenport St, Somerville, NJ 08876, USA",
    "place_id": "ChIJGQZLi0qVw4kRC5SkD5zQzAo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0366",
    "chain": "ShopRite",
    "name": "Shoprite Of Branchburg",
    "store_number": "470",
    "address": "3166 Route 22",
    "city": "Branchburg",
    "state": "NJ",
    "zip": "08876",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 93,
    "lat": 40.6046723,
    "lng": -74.69193760000002,
    "formatted_address": "3166 US-22, Somerville, NJ 08876, USA",
    "place_id": "ChIJG6EnQ2OTw4kRoMYU0-6q3fA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0367",
    "chain": "ShopRite",
    "name": "Shoprite Of Watchung",
    "store_number": "472",
    "address": "1701 Route 22 West",
    "city": "Watchung",
    "state": "NJ",
    "zip": "07060",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 94,
    "lat": 40.6485783,
    "lng": -74.4083643,
    "formatted_address": "1701 US-22, Watchung, NJ 07069, USA",
    "place_id": "ChIJ9UZrVHi6w4kR7wprAQJ2Hp0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0368",
    "chain": "ShopRite",
    "name": "Shoprite Of Lawrenceville",
    "store_number": "500",
    "address": "3373 Brunswick Pike",
    "city": "Lawrenceville",
    "state": "NJ",
    "zip": "08648",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 95,
    "lat": 40.2985056,
    "lng": -74.6815305,
    "formatted_address": "3373 Brunswick Pike, Lawrenceville, NJ 08648, USA",
    "place_id": "ChIJfcEc137hw4kRQ-aIWJ1ewRQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0369",
    "chain": "ShopRite",
    "name": "Shoprite Of Williamstown",
    "store_number": "504",
    "address": "100 South Blackhorse Pike",
    "city": "Wiliamstown",
    "state": "NJ",
    "zip": "08094",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 96,
    "lat": 39.6884563,
    "lng": -74.9900043,
    "formatted_address": "100 S Black Horse Pike, Williamstown, NJ 08094, USA",
    "place_id": "ChIJTzO3FCLVxokRAw-qp25WNoI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0370",
    "chain": "ShopRite",
    "name": "Shoprite Of Millville",
    "store_number": "505",
    "address": "2102-2130 North 2Nd St",
    "city": "Millville",
    "state": "NJ",
    "zip": "08332",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 97,
    "lat": 39.4206165,
    "lng": -75.0419488,
    "formatted_address": "2102 N 2nd St, Millville, NJ 08332, USA",
    "place_id": "ChIJafQruPUzx4kRTXrdqDCBwSo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0371",
    "chain": "ShopRite",
    "name": "Shoprite Of East Windsor",
    "store_number": "506",
    "address": "319 Route 130",
    "city": "East Windsor",
    "state": "NJ",
    "zip": "08520",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 98,
    "lat": 40.2783954,
    "lng": -74.5310439,
    "formatted_address": "319 US-130, East Windsor, NJ 08520, USA",
    "place_id": "ChIJCwZOsePew4kR30yhxRPzJzc",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0372",
    "chain": "ShopRite",
    "name": "Shoprite Of Chews Landing",
    "store_number": "507",
    "address": "1200 Chewslanding Road",
    "city": "Laurel Springs",
    "state": "NJ",
    "zip": "08021",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 99,
    "lat": 39.8181016,
    "lng": -75.0375677,
    "formatted_address": "1200 Chews Landing Rd, Clementon, NJ 08021, USA",
    "place_id": "ChIJj4vISgvSxokReOk9IZPBAHQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0373",
    "chain": "ShopRite",
    "name": "Shoprite Of Sicklerville",
    "store_number": "508",
    "address": "542 Berlin Cross Keys Road",
    "city": "Sicklerville",
    "state": "NJ",
    "zip": "08081",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 100,
    "lat": 39.7416889,
    "lng": -74.9951111,
    "formatted_address": "542 Berlin - Cross Keys Rd, Sicklerville, NJ 08081, USA",
    "place_id": "ChIJyxqLxmbTxokRCTHV1BlXpH8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0374",
    "chain": "ShopRite",
    "name": "Shoprite Of Delsea",
    "store_number": "512",
    "address": "1255 West Landis Ave",
    "city": "Vineland",
    "state": "NJ",
    "zip": "08360",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 101,
    "lat": 39.484869,
    "lng": -75.0492735,
    "formatted_address": "1255 W Landis Ave, Vineland, NJ 08360, USA",
    "place_id": "ChIJ816qVxcyx4kRiKiQGTtFmD4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0375",
    "chain": "ShopRite",
    "name": "Shoprite Ewing",
    "store_number": "514",
    "address": "1750 N Olden Ave",
    "city": "Ewing Township",
    "state": "NJ",
    "zip": "08638",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 102,
    "lat": 40.24927650000001,
    "lng": -74.769183,
    "formatted_address": "1750 N Olden Ave, Ewing Township, NJ 08638, USA",
    "place_id": "ChIJx8IVPRhYwYkRAqNrWUCBRPE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0376",
    "chain": "ShopRite",
    "name": "Shoprite Of Hainesport",
    "store_number": "516",
    "address": "1520 Route 38 East",
    "city": "Hainesport",
    "state": "NJ",
    "zip": "08036",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 103,
    "lat": 39.9814841,
    "lng": -74.808582,
    "formatted_address": "1520 NJ-38, Lumberton Township, NJ 08048, USA",
    "place_id": "ChIJrQqXQUNIwYkRrMPf1iGbkz0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0377",
    "chain": "ShopRite",
    "name": "Shoprite Delran",
    "store_number": "517",
    "address": "1310 Fairview Blvd",
    "city": "Delran",
    "state": "NJ",
    "zip": "08075",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 104,
    "lat": 40.0188313,
    "lng": -74.94585909999999,
    "formatted_address": "1310 Fairview Blvd, Delran, NJ 080751446, USA",
    "place_id": "ChIJO9d68yJLwYkRcls18erM15E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0378",
    "chain": "ShopRite",
    "name": "Shoprite Of Roxborough",
    "store_number": "519",
    "address": "6901 Ridge Ave",
    "city": "Philadelphia",
    "state": "PA",
    "zip": "19128",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 105,
    "lat": 40.0440334,
    "lng": -75.2272151,
    "formatted_address": "6901 Ridge Ave, Philadelphia, PA 19128, USA",
    "place_id": "ChIJNSbdYN64xokRY7kroRW5IRc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0379",
    "chain": "ShopRite",
    "name": "Shoprite Of Hamilton Market Place",
    "store_number": "521",
    "address": "130 Marketplace Blvd",
    "city": "Hamilton Township",
    "state": "NJ",
    "zip": "08691",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 106,
    "lat": 40.1922083,
    "lng": -74.6435199,
    "formatted_address": "130 Marketplace Blvd, Robbinsville Twp, NJ 08691, USA",
    "place_id": "ChIJQ8GT5_RewYkRjGKnDOQGN2I",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0380",
    "chain": "ShopRite",
    "name": "Shoprite Of Mariton",
    "store_number": "523",
    "address": "307 West Route 70",
    "city": "Mariton",
    "state": "NJ",
    "zip": "08053",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 107,
    "lat": 39.8959055,
    "lng": -74.9325965,
    "formatted_address": "307 NJ-70, Marlton, NJ 08053, USA",
    "place_id": "ChIJHTAUGSs1wYkRiGTcvSoXZQ4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0381",
    "chain": "ShopRite",
    "name": "Shoprite Of New Brunswick",
    "store_number": "524",
    "address": "400Renaissance Blvd",
    "city": "North Brunswick",
    "state": "NJ",
    "zip": "08902",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 108,
    "lat": 40.433648,
    "lng": -74.48922379999999,
    "formatted_address": "400 Renaissance Blvd, North Brunswick Township, NJ 08902, USA",
    "place_id": "ChIJHZ-bmHzEw4kR36-QmOS7ckk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0382",
    "chain": "ShopRite",
    "name": "Shoprite Of Union Mill Rd",
    "store_number": "525",
    "address": "892 Union Mill Road",
    "city": "Mount Laurel",
    "state": "NJ",
    "zip": "08054",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 109,
    "lat": 39.9380316,
    "lng": -74.91521399999999,
    "formatted_address": "892 Union Mill Rd, Mt Laurel Township, NJ 08054, USA",
    "place_id": "ChIJxaDQdKY1wYkRsrg8QxFF5xU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0383",
    "chain": "ShopRite",
    "name": "Shoprite Of Evesham Road",
    "store_number": "529",
    "address": "400 East Evesham Road",
    "city": "Cherry Hill",
    "state": "NJ",
    "zip": "08003",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 110,
    "lat": 39.8619687,
    "lng": -74.9735658,
    "formatted_address": "400 E Evesham Rd, Cherry Hill Township, NJ 08003, USA",
    "place_id": "ChIJmS4PL9LMxokRDSIgDHygItw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0384",
    "chain": "ShopRite",
    "name": "Shoprite Of Berlin",
    "store_number": "531",
    "address": "Rt 73 & Minck Ave",
    "city": "West Berlin",
    "state": "NJ",
    "zip": "08091",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 111,
    "lat": 39.80772779999999,
    "lng": -74.9312612,
    "formatted_address": "NJ-73 & Minck Ave, Berlin Township, NJ 08091, USA",
    "place_id": "EjFOSi03MyAmIE1pbmNrIEF2ZSwgQmVybGluIFRvd25zaGlwLCBOSiAwODA5MSwgVVNBImYiZAoUChIJdYXmXX0twYkRq-dwNTt2EicSFAoSCXWF5l19LcGJEavncDU7dhInGhQKEgmxU5r6bS3BiRHaCse0tOG9kBoUChIJK8omZWItwYkRJIOJjEdg3d4iCg1eLboXFZxlVtM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0385",
    "chain": "ShopRite",
    "name": "Shoprite Roosevelt Blvd",
    "store_number": "532",
    "address": "11000 Roosevelt Blvd",
    "city": "Philadelphia",
    "state": "PA",
    "zip": "19116",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 112,
    "lat": 40.1027573,
    "lng": -75.0129901,
    "formatted_address": "11000 Roosevelt Blvd, Philadelphia, PA 19116, USA",
    "place_id": "ChIJfUCICU6zxokRo_v8LcKcOE8",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0386",
    "chain": "ShopRite",
    "name": "Shoprite Of Pennington",
    "store_number": "533",
    "address": "2555 Pennington Road",
    "city": "Pennington",
    "state": "NJ",
    "zip": "08534",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 113,
    "lat": 40.3062172,
    "lng": -74.7870981,
    "formatted_address": "2555 Pennington Rd, Ewing Township, NJ 08638, USA",
    "place_id": "ChIJdWLLQin9w4kRq-ypD6FTDOU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0387",
    "chain": "ShopRite",
    "name": "Shoprite Of 1St State Plaza",
    "store_number": "538",
    "address": "1600 W Newport Pike",
    "city": "Wilmington",
    "state": "DE",
    "zip": "19804",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 114,
    "lat": 39.7148676,
    "lng": -75.6302649,
    "formatted_address": "1600 W Newport Pike, Wilmington, DE 19804, USA",
    "place_id": "ChIJgfsb_YwBx4kR-yeJ8xeGJw0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0388",
    "chain": "ShopRite",
    "name": "Shoprite Of Medford",
    "store_number": "540",
    "address": "208 Rt 70 East",
    "city": "Medford",
    "state": "NJ",
    "zip": "08055",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 115,
    "lat": 39.9036278,
    "lng": -74.82079519999999,
    "formatted_address": "208 NJ-70, Medford, NJ 08055, USA",
    "place_id": "ChIJGSPyURs3wYkRMEEkvTOGYr0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0389",
    "chain": "ShopRite",
    "name": "Shoprite Of Foreset Hill",
    "store_number": "545",
    "address": "2101 Rock Spring Road",
    "city": "Forest Hill",
    "state": "MD",
    "zip": "21050",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 116,
    "lat": 39.5750623,
    "lng": -76.3849403,
    "formatted_address": "2101 Rock Spring Rd, Forest Hill, MD 21050, USA",
    "place_id": "ChIJD3PZO7jex4kRDl60FzLaqYs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0390",
    "chain": "ShopRite",
    "name": "Shoprite Of Main Street",
    "store_number": "547",
    "address": "223 N Main St",
    "city": "Bel Air",
    "state": "MD",
    "zip": "21014",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 117,
    "lat": 39.5395231,
    "lng": -76.3532585,
    "formatted_address": "223 N Main St, Bel Air, MD 21014, USA",
    "place_id": "ChIJOSB4itLdx4kR2uoSWam3TIY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0391",
    "chain": "ShopRite",
    "name": "Shoprite Of Aberdeen, Md",
    "store_number": "548",
    "address": "949 Beards Hill Road",
    "city": "Aberdeen",
    "state": "MD",
    "zip": "21001",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 118,
    "lat": 39.5255876,
    "lng": -76.1816343,
    "formatted_address": "949 Beards Hill Rd, Aberdeen, MD 21001, USA",
    "place_id": "ChIJIU9tUtTDx4kRluhvrQc9w5w",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0392",
    "chain": "ShopRite",
    "name": "Shoprite Of Festival",
    "store_number": "549",
    "address": "5 Bel Air South Parkway",
    "city": "Bel Air",
    "state": "MD",
    "zip": "21015",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 119,
    "lat": 39.4951044,
    "lng": -76.3268229,
    "formatted_address": "5 Bel Air S Pkwy, Bel Air, MD 21015, USA",
    "place_id": "ChIJwQf6-Hznx4kRct_MfL2JPsc",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0393",
    "chain": "ShopRite",
    "name": "Shoprite Of Landis",
    "store_number": "550",
    "address": "3600 E Landis Ave",
    "city": "Vindeland",
    "state": "NJ",
    "zip": "08360",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 120,
    "lat": 39.4843417,
    "lng": -74.9592569,
    "formatted_address": "3600 E Landis Ave, Vineland, NJ 08361, USA",
    "place_id": "ChIJu-TD0FbNwIkRyudFyvOKX-w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0394",
    "chain": "ShopRite",
    "name": "Shoprite Of Riverside",
    "store_number": "551",
    "address": "1321 Riverside Parkway",
    "city": "Belcamp",
    "state": "MD",
    "zip": "21017",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 121,
    "lat": 39.4798655,
    "lng": -76.2473629,
    "formatted_address": "1321 Riverside Pkwy, Belcamp, MD 21017, USA",
    "place_id": "ChIJn4humSLox4kRLNtMf-qO8Pk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0395",
    "chain": "ShopRite",
    "name": "Shoprite Of Ernston Road",
    "store_number": "553",
    "address": "290 Washington Road",
    "city": "Parlin",
    "state": "NJ",
    "zip": "08859",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 122,
    "lat": 40.4587251,
    "lng": -74.3497721,
    "formatted_address": "290 Washington Rd, Sayreville, NJ 08872, USA",
    "place_id": "ChIJ5SjTnS_Jw4kRLatm8QHbBYM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0396",
    "chain": "ShopRite",
    "name": "Shoprite Of Glassboro",
    "store_number": "554",
    "address": "201 Dalton Drive",
    "city": "Glassboro",
    "state": "NJ",
    "zip": "08028",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 123,
    "lat": 39.7191479,
    "lng": -75.1103878,
    "formatted_address": "201 William Dalton Dr, Glassboro, NJ 08028, USA",
    "place_id": "ChIJB0yetgLXxokRLxSiq4g7DjY",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0397",
    "chain": "ShopRite",
    "name": "Shoprite Cardiff",
    "store_number": "555",
    "address": "1606 Dooley Road",
    "city": "Cardiff",
    "state": "MD",
    "zip": "21160",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 124,
    "lat": 39.7203296,
    "lng": -76.3426538,
    "formatted_address": "1606 Dooley Rd, Cardiff, MD 21160, USA",
    "place_id": "ChIJa5JiTj7Rx4kR2WWitt4522U",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0398",
    "chain": "ShopRite",
    "name": "Shoprite Of Brandyvine Commons",
    "store_number": "558",
    "address": "1300 Rocky Run Parkway",
    "city": "Wilmington",
    "state": "DE",
    "zip": "19803",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 125,
    "lat": 39.8249261,
    "lng": -75.5483924,
    "formatted_address": "1300 Rocky Run Pkwy, Wilmington, DE 19803, USA",
    "place_id": "ChIJ21OU-0D7xokRIuajcXemsiw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0399",
    "chain": "ShopRite",
    "name": "Shoprite Jacksonville",
    "store_number": "563",
    "address": "14330Jarrettsville Pike",
    "city": "Phoenix",
    "state": "MD",
    "zip": "21131",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 126,
    "lat": 39.5201165,
    "lng": -76.5602925,
    "formatted_address": "14330 Jarrettsville Pike, Jacksonville, MD 21131, USA",
    "place_id": "ChIJVzoyHa4MyIkRk2GkaHkOD4c",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0400",
    "chain": "ShopRite",
    "name": "Shoprite Of Hamilton Square",
    "store_number": "566",
    "address": "1225 Rt 33 Manilton Plaza",
    "city": "Hamilton Township",
    "state": "NJ",
    "zip": "08690",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 127,
    "lat": 40.2262449,
    "lng": -74.6647055,
    "formatted_address": "1225 NJ-33, Hamilton Township, NJ 08690, USA",
    "place_id": "ChIJ8TZPnj1fwYkR4GZPnUM4v08",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0401",
    "chain": "ShopRite",
    "name": "Shoprite Farden St Pavilion",
    "store_number": "570",
    "address": "2240 West Mariton Pike",
    "city": "Cherry Hill",
    "state": "NJ",
    "zip": "08002",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 128,
    "lat": 39.9288043,
    "lng": -75.0426789,
    "formatted_address": "2240 W Marlton Pike, Cherry Hill Township, NJ 08002, USA",
    "place_id": "ChIJk6SuB8LLxokRMdZJf0vYGvo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0402",
    "chain": "ShopRite",
    "name": "Shoprite Bordentown",
    "store_number": "572",
    "address": "622 Us-206",
    "city": "Bordentown",
    "state": "NJ",
    "zip": "08505",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 129,
    "lat": 40.1735347,
    "lng": -74.7040482,
    "formatted_address": "622 US-206, Bordentown, NJ 08505, USA",
    "place_id": "ChIJnXt6AeRbwYkRKAR5rYclgRk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0403",
    "chain": "ShopRite",
    "name": "Shoprite Of Edison",
    "store_number": "573",
    "address": "775 Us-1",
    "city": "Edison",
    "state": "NJ",
    "zip": "08817",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 130,
    "lat": 40.5125406,
    "lng": -74.38384549999999,
    "formatted_address": "775 US-1, Edison, NJ 08817, USA",
    "place_id": "ChIJK5KI62rIw4kRGvXC0FgYo9o",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0404",
    "chain": "ShopRite",
    "name": "Shoprite South Plainfield",
    "store_number": "578",
    "address": "3600 Park Ave",
    "city": "South Plainfield",
    "state": "NJ",
    "zip": "07080",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 131,
    "lat": 40.5753755,
    "lng": -74.3912242,
    "formatted_address": "3600 Park Ave, South Plainfield, NJ 07080, USA",
    "place_id": "ChIJ7a70y3e3w4kRaBR34jx6Muc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0405",
    "chain": "ShopRite",
    "name": "Shoprite Of S. Brunswick Hertiage Plaza",
    "store_number": "584",
    "address": "4154 Us Rt 1",
    "city": "Mammoth Junction",
    "state": "NJ",
    "zip": "08852",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 132,
    "lat": 40.385317,
    "lng": -74.5711975,
    "formatted_address": "4154 US-1, Monmouth Junction, NJ 08852, USA",
    "place_id": "ChIJCZVkMlrdw4kRH26637Igo2k",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0406",
    "chain": "ShopRite",
    "name": "Shoprite Of Brunswick",
    "store_number": "585",
    "address": "13=22 West Prospect Street",
    "city": "East Brunswick",
    "state": "NJ",
    "zip": "08816",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 133,
    "lat": 40.4569193,
    "lng": -74.39651669999999,
    "formatted_address": "22 W Prospect St #13, East Brunswick, NJ 08816, USA",
    "place_id": "EjMyMiBXIFByb3NwZWN0IFN0ICMxMywgRWFzdCBCcnVuc3dpY2ssIE5KIDA4ODE2LCBVU0EiHhocChYKFAoSCffBgCatyMOJEStTPKSpzY5EEgIxMw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0407",
    "chain": "ShopRite",
    "name": "Shoprite Governors Square",
    "store_number": "588",
    "address": "1101 Governors Place",
    "city": "Bear",
    "state": "DE",
    "zip": "19701",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 134,
    "lat": 39.6319852,
    "lng": -75.6648806,
    "formatted_address": "1101 Governors Pl, Bear, DE 19701, USA",
    "place_id": "ChIJl7q55OIGx4kRu6_Rc8gMvgo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0408",
    "chain": "ShopRite",
    "name": "Shoprite Of Four Seasons",
    "store_number": "590",
    "address": "700 Plaza Drive",
    "city": "Newark",
    "state": "DE",
    "zip": "19702",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 135,
    "lat": 39.6264727,
    "lng": -75.7462001,
    "formatted_address": "700 Plaza Dr, Newark, DE 19702, USA",
    "place_id": "ChIJK1bctU2ox4kRg77FtED7CEI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0409",
    "chain": "ShopRite",
    "name": "Shoprite Center Square Plaza",
    "store_number": "591",
    "address": "65 Center Square Rd",
    "city": "Woolwich",
    "state": "NJ",
    "zip": "08085",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 136,
    "lat": 39.7371189,
    "lng": -75.3221209,
    "formatted_address": "65 Center Square Rd, Woolwich Township, NJ 08085, USA",
    "place_id": "ChIJDaGZEDnfxokRud5-InuU2HA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0410",
    "chain": "ShopRite",
    "name": "Shoprite Of Hadlety Commons",
    "store_number": "592",
    "address": "5781 Hadley Rd",
    "city": "South Plainfield",
    "state": "NJ",
    "zip": "07080",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 137,
    "lat": 40.5544215,
    "lng": -74.42790339999999,
    "formatted_address": "5781 Hadley Rd, South Plainfield, NJ 07080, USA",
    "place_id": "Ei81NzgxIEhhZGxleSBSZCwgU291dGggUGxhaW5maWVsZCwgTkogMDcwODAsIFVTQSIxEi8KFAoSCVuvcl8TuMOJEVMA_Yem2CldEJUtKhQKEglhVrNlEbjDiRFHT7MvluwaqQ",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0411",
    "chain": "ShopRite",
    "name": "Shoprite Of Mt. Laurel",
    "store_number": "594",
    "address": "1000 Nixon Drive",
    "city": "Mount Laurel",
    "state": "NJ",
    "zip": "08054",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 138,
    "lat": 39.937916,
    "lng": -74.9659016,
    "formatted_address": "1000 Nixon Dr, Mt Laurel Township, NJ 08054, USA",
    "place_id": "ChIJtZJKYSs1wYkRL8hlFwYgHEU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0412",
    "chain": "ShopRite",
    "name": "Shoprite Galloway",
    "store_number": "600",
    "address": "401 South Pitney Road",
    "city": "Galloway",
    "state": "NJ",
    "zip": "08205",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 139,
    "lat": 39.4624539,
    "lng": -74.49560579999999,
    "formatted_address": "401 S Pitney Rd, Galloway, NJ 08205, USA",
    "place_id": "ChIJNRXoJNTlwIkRLT-_RcOQLtw",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0413",
    "chain": "ShopRite",
    "name": "Shoprite Of English Creek",
    "store_number": "601",
    "address": "3003 English Creek Ave",
    "city": "Egg Harbor Township",
    "state": "NJ",
    "zip": "08234",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 140,
    "lat": 39.4331627,
    "lng": -74.6130476,
    "formatted_address": "3003 English Creek Ave, Egg Harbor Township, NJ 08234, USA",
    "place_id": "ChIJTbIyu7fCwIkRc9Qr9MWfOhc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0414",
    "chain": "ShopRite",
    "name": "Shoprite Of Route 37",
    "store_number": "604",
    "address": "2 Route 37 West",
    "city": "Toms River",
    "state": "NJ",
    "zip": "08753",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 141,
    "lat": 39.965664,
    "lng": -74.2038006,
    "formatted_address": "2 NJ-37, Toms River, NJ 08753, USA",
    "place_id": "ChIJEVFU0O2dwYkR6LeIVcchTCI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0415",
    "chain": "ShopRite",
    "name": "Shoprite Freehold",
    "store_number": "607",
    "address": "South St & Rt 9",
    "city": "Freehold",
    "state": "NJ",
    "zip": "07728",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 142,
    "lat": 40.2401261,
    "lng": -74.276043,
    "formatted_address": "US-9 & South St, Freehold Township, NJ 07728, USA",
    "place_id": "EjFVUy05ICYgU291dGggU3QsIEZyZWVob2xkIFRvd25zaGlwLCBOSiAwNzcyOCwgVVNBImYiZAoUChIJN4AjUq3Vw4kRn_e0YNzZuRQSFAoSCTeAI1Kt1cOJEZ_3tGDc2bkUGhQKEgntSFJXIsLciRFsaWIh0k9OWBoUChIJL0D1c1DUw4kRdbqfcepXJeMiCg3tJ_wXFRJgutM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0416",
    "chain": "ShopRite",
    "name": "Shoprite Of Lacey Township",
    "store_number": "609",
    "address": "Rt 9 & First Street",
    "city": "Lanoka Harbor",
    "state": "NJ",
    "zip": "08734",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 143,
    "lat": 39.852562,
    "lng": -74.18187,
    "formatted_address": "US-9 & 1st St, Lacey Township, NJ 08734, USA",
    "place_id": "EixVUy05ICYgMXN0IFN0LCBMYWNleSBUb3duc2hpcCwgTkogMDg3MzQsIFVTQSJmImQKFAoSCVsLoLowoMGJEbNUl8e4TKmPEhQKEglbC6C6MKDBiRGzVJfHuEypjxoUChIJ7UhSVyLC3IkRbGliIdJPTlgaFAoSCa1kkskwoMGJEQVU7rpCuXD5IgoNtATBFxW0vsjT",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0417",
    "chain": "ShopRite",
    "name": "Shoprite Of Fischer Bay",
    "store_number": "610",
    "address": "860 Fischer Blvd",
    "city": "Toms River",
    "state": "NJ",
    "zip": "08753",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 144,
    "lat": 39.9714857,
    "lng": -74.13656639999999,
    "formatted_address": "860 Fischer Blvd, Toms River, NJ 08753, USA",
    "place_id": "ChIJDbBRRWWcwYkRfZ26kTR4wDY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0418",
    "chain": "ShopRite",
    "name": "Shoprite Of Aberdeen",
    "store_number": "613",
    "address": "318 Lloyd Road",
    "city": "Aberdeen",
    "state": "NJ",
    "zip": "07747",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 145,
    "lat": 40.3952515,
    "lng": -74.22161779999999,
    "formatted_address": "318 Lloyd Rd, Aberdeen Township, NJ 07747, USA",
    "place_id": "ChIJ8StURdTMw4kRUzAjOEjnZGI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0419",
    "chain": "ShopRite",
    "name": "Shoprite Of Manchester",
    "store_number": "614",
    "address": "1001 Rt 70 West",
    "city": "Manchester",
    "state": "NJ",
    "zip": "08759",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 146,
    "lat": 40.0150937,
    "lng": -74.2964209,
    "formatted_address": "1001 NJ-70, Manchester Township, NJ 08759, USA",
    "place_id": "ChIJAXrM5jp3wYkRjlFuy8Kkr5w",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0420",
    "chain": "ShopRite",
    "name": "Shoprite Of Sewell",
    "store_number": "615",
    "address": "382 Egg Harbor Road",
    "city": "Sewell",
    "state": "NJ",
    "zip": "08080",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 147,
    "lat": 39.752474,
    "lng": -75.07608069999999,
    "formatted_address": "382 Egg Harbor Rd, Sewell, NJ 08080, USA",
    "place_id": "ChIJG_kwQU7RxokRSujKuftJaA4",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0421",
    "chain": "ShopRite",
    "name": "Shoprite Of Jackson",
    "store_number": "616",
    "address": "260 N County Line Rd",
    "city": "Jackson",
    "state": "NJ",
    "zip": "08527",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 148,
    "lat": 40.1388444,
    "lng": -74.29385409999999,
    "formatted_address": "260 N County Line Rd, Jackson Township, NJ 08527, USA",
    "place_id": "ChIJVV3mH7x-wYkRyeQ14G857KQ",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0422",
    "chain": "ShopRite",
    "name": "Shoprite Of Montgomery",
    "store_number": "617",
    "address": "Rt 206 And Rt 518",
    "city": "Montgomery Township",
    "state": "NJ",
    "zip": "08558",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 149,
    "lat": 40.5743692,
    "lng": -74.628618,
    "formatted_address": "518 US-206, Raritan, NJ 08869, USA",
    "place_id": "EiI1MTggVVMtMjA2LCBSYXJpdGFuLCBOSiAwODg2OSwgVVNBIjESLwoUChIJ-9mWKC6Vw4kRhOgPPV5HveAQhgQqFAoSCddxoe2_7sOJEcP4We25YKKE",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0423",
    "chain": "ShopRite",
    "name": "Shoprite Bayville",
    "store_number": "618",
    "address": "431 Atlantic City Blvd",
    "city": "Bayville",
    "state": "NJ",
    "zip": "08721",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 150,
    "lat": 39.9138691,
    "lng": -74.15313309999999,
    "formatted_address": "431 Atlantic City Blvd, Bayville, NJ 08721, USA",
    "place_id": "ChIJj5dasuiewYkR2OOYhzcivXI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0424",
    "chain": "ShopRite",
    "name": "Shoprite Of Waretown",
    "store_number": "619",
    "address": "501 Rt 9 Suite 100",
    "city": "Waretown",
    "state": "NJ",
    "zip": "08758",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 151,
    "lat": 39.7960319,
    "lng": -74.19909659999999,
    "formatted_address": "501 US-9 Ste 100, Waretown, NJ 08758, USA",
    "place_id": "ChIJR1XC3LagwYkRbkYSasgfpBM",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0425",
    "chain": "ShopRite",
    "name": "Shoprite Of Shrewsbury",
    "store_number": "620",
    "address": "1151 Shrewsbury",
    "city": "Shrewsbury",
    "state": "NJ",
    "zip": "07702",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 152,
    "lat": 40.3155863,
    "lng": -74.06817699999999,
    "formatted_address": "1151 Shrewsbury Ave, Shrewsbury, NJ 07702, USA",
    "place_id": "ChIJR2Ma1cgvwokRcXtL26NASxI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0426",
    "chain": "ShopRite",
    "name": "Shoprite Of West Long Beach",
    "store_number": "623",
    "address": "Rt 36 And 71",
    "city": "West Long Beach",
    "state": "NJ",
    "zip": "07764",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 153,
    "lat": 40.2946786,
    "lng": -74.0282287,
    "formatted_address": "NJ-71 & NJ-36, West Long Branch, NJ 07764, USA",
    "place_id": "Ei5OSi03MSAmIE5KLTM2LCBXZXN0IExvbmcgQnJhbmNoLCBOSiAwNzc2NCwgVVNBImYiZAoUChIJoZ2gN30lwokRymzkZ-60BhUSFAoSCaGdoDd9JcKJEcps5GfutAYVGhQKEgnfRZiDKibCiRFS7sLc03D23hoUChIJZ65aAWIlwokRyTO0E52tCbYiCg3iegQYFVEw4NM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0427",
    "chain": "ShopRite",
    "name": "Shoprite Hazlzet",
    "store_number": "626",
    "address": "3120 State Highway 36",
    "city": "Hazlet",
    "state": "NJ",
    "zip": "07730",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 154,
    "lat": 40.4386857,
    "lng": -74.1505791,
    "formatted_address": "3120 NJ-36, Hazlet, NJ 07730, USA",
    "place_id": "EiEzMTIwIE5KLTM2LCBIYXpsZXQsIE5KIDA3NzMwLCBVU0EiMRIvChQKEgl53aSlazTCiRGyt1Um8HPzTRCwGCoUChIJo4MbQaUxwokR9wDUJ4wyl7Q",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0428",
    "chain": "ShopRite",
    "name": "Shoprite Of Wall Township",
    "store_number": "630",
    "address": "2433 Hieghway 34",
    "city": "Manasquan",
    "state": "NJ",
    "zip": "08735",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 155,
    "lat": 40.1214001,
    "lng": -74.0804976,
    "formatted_address": "Shoprite Wall, 2433 NJ-34, Manasquan, NJ 08736, USA",
    "place_id": "ChIJaamPDveGwYkRWVaoIKMT9o0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0429",
    "chain": "ShopRite",
    "name": "Shoprite Of Howell",
    "store_number": "631",
    "address": "4594 Route 9 S",
    "city": "Howell",
    "state": "NJ",
    "zip": "07731",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 156,
    "lat": 40.1403317,
    "lng": -74.22756199999999,
    "formatted_address": "4594 US-9, Howell Township, NJ 07731, USA",
    "place_id": "ChIJx6xCumV_wYkRTrF47ih8LOg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0430",
    "chain": "ShopRite",
    "name": "Shoprite Of Middletown Nj- Kings Commons",
    "store_number": "634",
    "address": "1500 State Highway 35 South",
    "city": "Middletown",
    "state": "NJ",
    "zip": "07748",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 157,
    "lat": 40.4040918,
    "lng": -74.1272484,
    "formatted_address": "1500 NJ-35, Middletown Township, NJ 07748, USA",
    "place_id": "ChIJeb_x0-MzwokRsaQUevEbtEU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0431",
    "chain": "ShopRite",
    "name": "Shoprite Of Belmar = Rt 35 & 18Th Ave",
    "store_number": "638",
    "address": "1732 Nj-35",
    "city": "Belmar",
    "state": "NJ",
    "zip": "07719",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 158,
    "lat": 40.1695362,
    "lng": -74.0456183,
    "formatted_address": "1732 NJ-35, Belmar, NJ 07719, USA",
    "place_id": "ChIJyc-gvB0owokRcdDmhvC-hbY",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0432",
    "chain": "ShopRite",
    "name": "Shoprite Of Bricktown",
    "store_number": "641",
    "address": "668 Rte 70",
    "city": "Brick",
    "state": "NJ",
    "zip": "08723",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 159,
    "lat": 40.0624892,
    "lng": -74.1434458,
    "formatted_address": "668 NJ-70, Brick Township, NJ 08723, USA",
    "place_id": "ChIJTaRiI56DwYkR0MeS8uc-SZk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0433",
    "chain": "ShopRite",
    "name": "Shoprite Of Hammonton",
    "store_number": "642",
    "address": "80 South Whitehorse Pike",
    "city": "Hammonton",
    "state": "NJ",
    "zip": "08037",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 160,
    "lat": 39.6462978,
    "lng": -74.78747059999999,
    "formatted_address": "80 S White Horse Pike, Hammonton, NJ 08037, USA",
    "place_id": "ChIJX3QglAwowYkRyn8raxa-6zs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0434",
    "chain": "ShopRite",
    "name": "Shoprite Of Bay Shore",
    "store_number": "801",
    "address": "1905 Sunrise Hwy",
    "city": "Bay Shore",
    "state": "NY",
    "zip": "11706",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 161,
    "lat": 40.7410132,
    "lng": -73.2332851,
    "formatted_address": "1905 Sunrise Hwy, Bay Shore, NY 11706, USA",
    "place_id": "ChIJUfMVlksy6IkR1amsu7btdYk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0435",
    "chain": "ShopRite",
    "name": "Shoprite Of Uniondale",
    "store_number": "804",
    "address": "1121 Jerusalem Ave",
    "city": "Uniondale",
    "state": "NY",
    "zip": "11553",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 162,
    "lat": 40.69567989999999,
    "lng": -73.5789404,
    "formatted_address": "1121 Jerusalem Ave, Uniondale, NY 11553, USA",
    "place_id": "ChIJEzExwjR8wokRgsSGCdPIy50",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0436",
    "chain": "ShopRite",
    "name": "Shoprite Of Selden",
    "store_number": "808",
    "address": "71 College Plaza Seldon",
    "city": "Seldon",
    "state": "NY",
    "zip": "11784",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 163,
    "lat": 40.8662074,
    "lng": -73.0473533,
    "formatted_address": "College Plaza, Selden, NY 11784, USA",
    "place_id": "ChIJHfl2bBtH6IkR7WpkurEX2g4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0437",
    "chain": "ShopRite",
    "name": "Shoprite Of Patchogue",
    "store_number": "811",
    "address": "95 Sunrise Highway",
    "city": "Patchogue",
    "state": "NY",
    "zip": "11772",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 164,
    "lat": 40.7810912,
    "lng": -73.006309,
    "formatted_address": "95 Sunrise Hwy, Patchogue, NY 11772, USA",
    "place_id": "ChIJKdmUa8VI6IkRE9h93a4CeM8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0438",
    "chain": "ShopRite",
    "name": "Shoprite Ofnew Hyde Park",
    "store_number": "812",
    "address": "2335 New Hyde Park Road",
    "city": "New Hyde Park",
    "state": "NY",
    "zip": "11042",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 165,
    "lat": 40.757826,
    "lng": -73.69014299999999,
    "formatted_address": "2335 New Hyde Park Rd, New Hyde Park, NY 11042, USA",
    "place_id": "ChIJk9vCSy-IwokRIUqYCEj2_nI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0439",
    "chain": "ShopRite",
    "name": "Shoprite Of Deer Park",
    "store_number": "814",
    "address": "1960 Deer Park Ave",
    "city": "Deer Park",
    "state": "NY",
    "zip": "11729",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 166,
    "lat": 40.7631937,
    "lng": -73.3307001,
    "formatted_address": "1960 Deer Pk Rd, Deer Park, NY 11729, USA",
    "place_id": "ChIJhT8SiTYs6IkRh4I8D4IT3RU",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0440",
    "chain": "ShopRite",
    "name": "Shoprite Of Massapequa",
    "store_number": "815",
    "address": "5508 Sunrise Highway",
    "city": "Massapequa",
    "state": "NY",
    "zip": "11758",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 167,
    "lat": 40.6757406,
    "lng": -73.43696779999999,
    "formatted_address": "5508 Sunrise Hwy, Massapequa, NY 11758, USA",
    "place_id": "ChIJCavnoqDV6YkRZe_dQct2mvQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0441",
    "chain": "ShopRite",
    "name": "Shoprite Of Lake Ronkonkoma",
    "store_number": "816",
    "address": "601 Portion Rd",
    "city": "Lake Ronkonkoma",
    "state": "NY",
    "zip": "11779",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 168,
    "lat": 40.8311185,
    "lng": -73.0905655,
    "formatted_address": "601 Portion Rd, Ronkonkoma, NY 11779, USA",
    "place_id": "ChIJvV-a0gc46IkRFwRe4l3BSGY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0442",
    "chain": "ShopRite",
    "name": "Shoprtie Of Portjefferson",
    "store_number": "817",
    "address": "5145 Nesconset Highway",
    "city": "Port Jefferson Station",
    "state": "NY",
    "zip": "11776",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 169,
    "lat": 40.9257771,
    "lng": -73.04329489999999,
    "formatted_address": "5145 Nesconset Hwy, Port Jefferson Station, NY 11776, USA",
    "place_id": "ChIJW7PArf1A6IkRygaZ137UGDY",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0443",
    "chain": "ShopRite",
    "name": "Shoprite Of Riverhead",
    "store_number": "819",
    "address": "1510 Old Country Road",
    "city": "Riverhead",
    "state": "NY",
    "zip": "11901",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 170,
    "lat": 40.9287019,
    "lng": -72.6953807,
    "formatted_address": "1510 Old Country Rd, Riverhead, NY 11901, USA",
    "place_id": "ChIJSdpygrqK6IkRcem6BZqRg7g",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0444",
    "chain": "ShopRite",
    "name": "Shoprite Of Hauppauge",
    "store_number": "831",
    "address": "335 Nesconset Hwy, Rt 347",
    "city": "Hauppauge",
    "state": "NY",
    "zip": "11788",
    "source_sheet": "Wakefern ShopRite",
    "source_row": 171,
    "lat": 40.8268887,
    "lng": -73.20278929999999,
    "formatted_address": "Located within ShopRite, 335 Nesconset Hwy #347, Hauppauge, NY 11788, USA",
    "place_id": "EklMb2NhdGVkIHdpdGhpbiBTaG9wUml0ZSwgMzM1IE5lc2NvbnNldCBId3kgIzM0NywgSGF1cHBhdWdlLCBOWSAxMTc4OCwgVVNBIh8aHQoWChQKEglHSGH9vDDoiRGYpI3eXp1yyBIDMzQ3",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0445",
    "chain": "Raley's",
    "name": "Raley's #102",
    "store_number": "102",
    "address": "2895 North Mccarran Boulevard",
    "city": "Sparks",
    "state": "NV",
    "zip": "89431",
    "source_sheet": "Raley's",
    "source_row": 4,
    "lat": 39.5551633,
    "lng": -119.7543666,
    "formatted_address": "2895 N McCarran Blvd, Sparks, NV 89431, USA",
    "place_id": "ChIJq8KqKts4mYARU1thrSIZZ3Q",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0446",
    "chain": "Raley's",
    "name": "Raley's #103",
    "store_number": "103",
    "address": "1441 Mayberry Drive",
    "city": "Reno",
    "state": "NV",
    "zip": "89509",
    "source_sheet": "Raley's",
    "source_row": 5,
    "lat": 39.5104273,
    "lng": -119.8365638,
    "formatted_address": "1441 Mayberry Dr, Reno, NV 89509, USA",
    "place_id": "ChIJl_TC4CdBmYAR-dbT8vfyVNU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0447",
    "chain": "Raley's",
    "name": "Raley's #114",
    "store_number": "114",
    "address": "3701 South Carson Street",
    "city": "Carson City",
    "state": "NV",
    "zip": "89701",
    "source_sheet": "Raley's",
    "source_row": 6,
    "lat": 39.1323551,
    "lng": -119.7679376,
    "formatted_address": "3701 S Carson St, Carson City, NV 89701, USA",
    "place_id": "ChIJ2VyfNDigmYARMskN0i8Cpe0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0448",
    "chain": "Raley's",
    "name": "Raley's #124",
    "store_number": "124",
    "address": "4788 Caughlin Parkway",
    "city": "Reno",
    "state": "NV",
    "zip": "89519",
    "source_sheet": "Raley's",
    "source_row": 7,
    "lat": 39.4828887,
    "lng": -119.8538567,
    "formatted_address": "4788 Caughlin Pkwy, Reno, NV 89519, USA",
    "place_id": "ChIJJV_wEQxBmYARc58eg7sHB2w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0449",
    "chain": "Raley's",
    "name": "Raley's #127",
    "store_number": "127",
    "address": "1040 Emerald Bay Road",
    "city": "South Lake Tahoe",
    "state": "CA",
    "zip": "96150",
    "source_sheet": "Raley's",
    "source_row": 8,
    "lat": 38.9119399,
    "lng": -120.0058923,
    "formatted_address": "1040 Emerald Bay Rd, South Lake Tahoe, CA 96150, USA",
    "place_id": "ChIJi-K7YrCPmYAR8k_01aaUyhk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0450",
    "chain": "Raley's",
    "name": "Raley's #206",
    "store_number": "206",
    "address": "367 West Main Street",
    "city": "Woodland",
    "state": "CA",
    "zip": "95695",
    "source_sheet": "Raley's",
    "source_row": 9,
    "lat": 38.6764695,
    "lng": -121.8009187,
    "formatted_address": "367 W Main St, Woodland, CA 95695, USA",
    "place_id": "ChIJaanVxIXQhIAR1apJZIi0LUg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0451",
    "chain": "Raley's",
    "name": "Raley's #233",
    "store_number": "233",
    "address": "725 South Main Street",
    "city": "Red Bluff",
    "state": "CA",
    "zip": "96080",
    "source_sheet": "Raley's",
    "source_row": 10,
    "lat": 40.16312,
    "lng": -122.2294036,
    "formatted_address": "725 S Main St, Red Bluff, CA 96080, USA",
    "place_id": "ChIJp0Y9R4WDgoARMvaZRrhGs4E",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0452",
    "chain": "Raley's",
    "name": "Raley's #247",
    "store_number": "247",
    "address": "1842 Fort Jones Road",
    "city": "Yreka",
    "state": "CA",
    "zip": "96097",
    "source_sheet": "Raley's",
    "source_row": 11,
    "lat": 41.7004631,
    "lng": -122.6440695,
    "formatted_address": "1842 Fort Jones Rd, Yreka, CA 96097, USA",
    "place_id": "ChIJN2COe5NGzlQRrfHmWutOMmg",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0453",
    "chain": "Raley's",
    "name": "Raley's #329",
    "store_number": "329",
    "address": "157 North Mcdowell Boulevard",
    "city": "Petaluma",
    "state": "CA",
    "zip": "94954",
    "source_sheet": "Raley's",
    "source_row": 12,
    "lat": 38.2481735,
    "lng": -122.6285403,
    "formatted_address": "157 N McDowell Blvd, Petaluma, CA 94954, USA",
    "place_id": "ChIJJylW4ge0hYARJybF7o2U-Ro",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0454",
    "chain": "Raley's",
    "name": "Raley's #332",
    "store_number": "332",
    "address": "3001 Travis Boulevard",
    "city": "Fairfield",
    "state": "CA",
    "zip": "94534",
    "source_sheet": "Raley's",
    "source_row": 13,
    "lat": 38.257708,
    "lng": -122.0658358,
    "formatted_address": "3001 Travis Blvd, Fairfield, CA 94534, USA",
    "place_id": "ChIJTV9qgx4UhYARMMD-NYvi68w",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0455",
    "chain": "Raley's",
    "name": "Raley's #333",
    "store_number": "333",
    "address": "3632 Lone Tree Way",
    "city": "Antioch",
    "state": "CA",
    "zip": "94509",
    "source_sheet": "Raley's",
    "source_row": 14,
    "lat": 37.98584590000001,
    "lng": -121.8073263,
    "formatted_address": "3632 Lone Tree Wy, Antioch, CA 94509, USA",
    "place_id": "ChIJX4H7jIhXhYARhxUXiwLB0NU",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0456",
    "chain": "Raley's",
    "name": "Raley's #343",
    "store_number": "343",
    "address": "890 Southampton Road",
    "city": "Benicia",
    "state": "CA",
    "zip": "94510",
    "source_sheet": "Raley's",
    "source_row": 15,
    "lat": 38.0665223,
    "lng": -122.1679394,
    "formatted_address": "890 Southampton Rd, Benicia, CA 94510, USA",
    "place_id": "ChIJj4eVbhtuhYARaHl6ZWiJEZc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0457",
    "chain": "Raley's",
    "name": "Raley's #409",
    "store_number": "409",
    "address": "715 East Bidwell Street",
    "city": "Folsom",
    "state": "CA",
    "zip": "95630",
    "source_sheet": "Raley's",
    "source_row": 16,
    "lat": 38.6699518,
    "lng": -121.1602158,
    "formatted_address": "715 E Bidwell St, Folsom, CA 95630, USA",
    "place_id": "ChIJB6WA_xnkmoARnj8gtfoEU9g",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0458",
    "chain": "Raley's",
    "name": "Raley's #410",
    "store_number": "410",
    "address": "25025 Blue Ravine Road",
    "city": "Folsom",
    "state": "CA",
    "zip": "95630",
    "source_sheet": "Raley's",
    "source_row": 17,
    "lat": 38.689117,
    "lng": -121.122632,
    "formatted_address": "25025 Blue Ravine Rd, Folsom, CA 95630, USA",
    "place_id": "ChIJIe9cH4fkmoARpAWLpnN4px0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0459",
    "chain": "Raley's",
    "name": "Raley's #431",
    "store_number": "431",
    "address": "5159 Fair Oaks Boulevard",
    "city": "Carmichael",
    "state": "CA",
    "zip": "95608",
    "source_sheet": "Raley's",
    "source_row": 18,
    "lat": 38.59742749999999,
    "lng": -121.3453842,
    "formatted_address": "5159 Fair Oaks Blvd, Carmichael, CA 95608, USA",
    "place_id": "ChIJK4jOCHvcmoARAdMNmA2fnPk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0460",
    "chain": "Raley's",
    "name": "Raley's #510",
    "store_number": "510",
    "address": "1540 West El Camino Avenue",
    "city": "Sacramento",
    "state": "CA",
    "zip": "95833",
    "source_sheet": "Raley's",
    "source_row": 19,
    "lat": 38.61181759999999,
    "lng": -121.4964048,
    "formatted_address": "1540 W El Camino Ave, Sacramento, CA 95833, USA",
    "place_id": "ChIJO29xW-PWmoARfOE69Ep0Tn8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0461",
    "chain": "Raley's",
    "name": "Raley's #512",
    "store_number": "512",
    "address": "4008 Foothills Boulevard",
    "city": "Roseville",
    "state": "CA",
    "zip": "95747",
    "source_sheet": "Raley's",
    "source_row": 20,
    "lat": 38.7533633,
    "lng": -121.3110582,
    "formatted_address": "Bel Air, 4008 Foothills Blvd, Roseville, CA 95747, USA",
    "place_id": "ChIJDTaEKwAhm4ARpEd7RQ05EuQ",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0462",
    "chain": "Raley's",
    "name": "Raley's #521",
    "store_number": "521",
    "address": "1286 Stabler Lane",
    "city": "Yuba City",
    "state": "CA",
    "zip": "95993",
    "source_sheet": "Raley's",
    "source_row": 21,
    "lat": 39.1477124,
    "lng": -121.6459841,
    "formatted_address": "1286 Stabler Ln, Yuba City, CA 95993, USA",
    "place_id": "ChIJ11nNp16rhIAR8YFzkNURmt4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0463",
    "chain": "Raley's",
    "name": "Raley's #530",
    "store_number": "530",
    "address": "7315 Murieta Drive",
    "city": "Rancho Murieta",
    "state": "CA",
    "zip": "95683",
    "source_sheet": "Raley's",
    "source_row": 22,
    "lat": 38.494188,
    "lng": -121.0982751,
    "formatted_address": "7315 Murieta Dr, Rancho Murieta, CA 95683, USA",
    "place_id": "ChIJTezNa2rtmoARyarbXyNT078",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0464",
    "chain": "Nob Hill Foods",
    "name": "Nob Hill Foods #604",
    "store_number": "604",
    "address": "15710 Los Gatos Boulevard",
    "city": "Los Gatos",
    "state": "CA",
    "zip": "95030",
    "source_sheet": "Raley's",
    "source_row": 23,
    "lat": 37.2402767,
    "lng": -121.9595757,
    "formatted_address": "15710 Los Gatos Blvd, Los Gatos, CA 95030, USA",
    "place_id": "ChIJfZkQ68c1joARs7Z_4FB_mZs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0465",
    "chain": "Nob Hill Foods",
    "name": "Nob Hill Foods #607",
    "store_number": "607",
    "address": "1320 South Main Street",
    "city": "Salinas",
    "state": "CA",
    "zip": "93901",
    "source_sheet": "Raley's",
    "source_row": 24,
    "lat": 36.655563,
    "lng": -121.6616506,
    "formatted_address": "1320 S Main St, Salinas, CA 93901, USA",
    "place_id": "ChIJf0nicPf4jYARzX2NtDfX6x4",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0466",
    "chain": "Nob Hill Foods",
    "name": "Nob Hill Foods #631",
    "store_number": "631",
    "address": "919 East Stanley Boulevard",
    "city": "Livermore",
    "state": "CA",
    "zip": "94550",
    "source_sheet": "Raley's",
    "source_row": 25,
    "lat": 37.677248,
    "lng": -121.7848091,
    "formatted_address": "919 E Stanley Blvd, Livermore, CA 94550, USA",
    "place_id": "ChIJ39cVnJXnj4AR0prBX5rvz70",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0467",
    "chain": "Dierbergs",
    "name": "Dierbergs #1",
    "store_number": "1",
    "address": "12420 Tesson Ferry Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63128",
    "source_sheet": "Dierberg's",
    "source_row": 4,
    "lat": 38.508868,
    "lng": -90.3740998,
    "formatted_address": "12420 Tesson Ferry Rd, St. Louis, MO 63128, USA",
    "place_id": "ChIJZ_91O8vI2IcRGveGZlpTPbs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0468",
    "chain": "Dierbergs",
    "name": "Dierbergs #2",
    "store_number": "2",
    "address": "8 Four Seasons Shopping Center",
    "city": "Chesterfield",
    "state": "MO",
    "zip": "63017",
    "source_sheet": "Dierberg's",
    "source_row": 5,
    "lat": 38.6788806,
    "lng": -90.5001083,
    "formatted_address": "8 Four Seasons Shopping Center, Chesterfield, MO 63017, USA",
    "place_id": "ChIJ7Wgh2u4s34cR0VG6483C7qs",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0469",
    "chain": "Dierbergs",
    "name": "Dierbergs #3",
    "store_number": "3",
    "address": "9901 Manchester Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63122",
    "source_sheet": "Dierberg's",
    "source_row": 6,
    "lat": 38.6051107,
    "lng": -90.3806443,
    "formatted_address": "9901 Manchester Rd, St. Louis, MO 63122, USA",
    "place_id": "ChIJn3lg9XvM2IcRlZcb3-AIcCk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0470",
    "chain": "Dierbergs",
    "name": "Dierbergs #4",
    "store_number": "4",
    "address": "421 Lafayette Center Drive",
    "city": "Manchester",
    "state": "MO",
    "zip": "63011",
    "source_sheet": "Dierberg's",
    "source_row": 7,
    "lat": 38.5958524,
    "lng": -90.52118,
    "formatted_address": "421 Lafayette Ctr Dr, Manchester, MO 63011, USA",
    "place_id": "ChIJrz2KtY7T2IcRufhpP4gJhpE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0471",
    "chain": "Dierbergs",
    "name": "Dierbergs #5",
    "store_number": "5",
    "address": "11481 Olive Boulevard",
    "city": "Creve Coeur",
    "state": "MO",
    "zip": "63141",
    "source_sheet": "Dierberg's",
    "source_row": 8,
    "lat": 38.6729025,
    "lng": -90.4353328,
    "formatted_address": "11481 Olive Blvd, Creve Coeur, MO 63141, USA",
    "place_id": "ChIJYf1dHL4y34cR2zelfTUBpmA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0472",
    "chain": "Dierbergs",
    "name": "Dierbergs #6",
    "store_number": "6",
    "address": "1322 Clarkson Clayton Center",
    "city": "Ellisville",
    "state": "MO",
    "zip": "63011",
    "source_sheet": "Dierberg's",
    "source_row": 9,
    "lat": 38.60275499999999,
    "lng": -90.587195,
    "formatted_address": "1322 Clarkson Clayton Center, Ellisville, MO 63011, USA",
    "place_id": "ChIJlbG0YZnV2IcRCrf3D4OXsEc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0473",
    "chain": "Dierbergs",
    "name": "Dierbergs #7",
    "store_number": "7",
    "address": "860 Arnold Commons Drive",
    "city": "Arnold",
    "state": "MO",
    "zip": "63010",
    "source_sheet": "Dierberg's",
    "source_row": 10,
    "lat": 38.4372506,
    "lng": -90.38267069999999,
    "formatted_address": "860 Arnold Commons Dr, Arnold, MO 63010, USA",
    "place_id": "ChIJSYob2S3E2IcRhpNVPdL104M",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0474",
    "chain": "Dierbergs",
    "name": "Dierbergs #8",
    "store_number": "8",
    "address": "2516 Lemay Ferry Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63125",
    "source_sheet": "Dierberg's",
    "source_row": 11,
    "lat": 38.5190858,
    "lng": -90.3039841,
    "formatted_address": "2516 Lemay Ferry Rd, St. Louis, MO 63125, USA",
    "place_id": "ChIJrZg4zS7I2IcRlAdL635T0Ro",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0475",
    "chain": "Dierbergs",
    "name": "Dierbergs #9",
    "store_number": "9",
    "address": "2021 Zumbehl Road",
    "city": "Saint Charles",
    "state": "MO",
    "zip": "63303",
    "source_sheet": "Dierberg's",
    "source_row": 12,
    "lat": 38.7825192,
    "lng": -90.5344507,
    "formatted_address": "2021 Zumbehl Rd, St Charles, MO 633032723, USA",
    "place_id": "ChIJN61bTNco34cR3JBUObGHyE0",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0476",
    "chain": "Dierbergs",
    "name": "Dierbergs #10",
    "store_number": "10",
    "address": "10222 North Highway 67",
    "city": "Florissant",
    "state": "MO",
    "zip": "63034",
    "source_sheet": "Dierberg's",
    "source_row": 13,
    "lat": 38.8185227,
    "lng": -90.232796,
    "formatted_address": "10222 N Hwy 67, Florissant, MO 63034, USA",
    "place_id": "EikxMDIyMiBOIEh3eSA2NywgRmxvcmlzc2FudCwgTU8gNjMwMzQsIFVTQSIxEi8KFAoSCbuFPWmoSN-HEVxOTfdr66x5EO5PKhQKEgl95TSSeEjfhxHtCndtO8BNdQ",
    "geocode_location_type": "RANGE_INTERPOLATED"
  },
  {
    "id": "pb-0477",
    "chain": "Dierbergs",
    "name": "Dierbergs #11",
    "store_number": "11",
    "address": "1080 Lindemann Road",
    "city": "Des Peres",
    "state": "MO",
    "zip": "63131",
    "source_sheet": "Dierberg's",
    "source_row": 14,
    "lat": 38.6008011,
    "lng": -90.43292,
    "formatted_address": "1080 Lindemann Rd, Des Peres, MO 63131, USA",
    "place_id": "ChIJedWpPpjN2IcR-011A8ljoKA",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0478",
    "chain": "Dierbergs",
    "name": "Dierbergs #12",
    "store_number": "12",
    "address": "1730 Clarkson Road",
    "city": "Chesterfield",
    "state": "MO",
    "zip": "63017",
    "source_sheet": "Dierberg's",
    "source_row": 15,
    "lat": 38.6414601,
    "lng": -90.5662701,
    "formatted_address": "1730 Clarkson Rd, Chesterfield, MO 63017, USA",
    "place_id": "ChIJFxHlfCjV2IcRnhEv9J_Z13M",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0479",
    "chain": "Dierbergs",
    "name": "Dierbergs #13",
    "store_number": "13",
    "address": "7233 Watson Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63119",
    "source_sheet": "Dierberg's",
    "source_row": 16,
    "lat": 38.584559,
    "lng": -90.3194741,
    "formatted_address": "7233 Watson Rd, St. Louis, MO 63119, USA",
    "place_id": "ChIJJbovCz7K2IcRpW2glQX4ZOI",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0480",
    "chain": "Dierbergs",
    "name": "Dierbergs #14",
    "store_number": "14",
    "address": "5640 Telegraph Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63129",
    "source_sheet": "Dierberg's",
    "source_row": 17,
    "lat": 38.4668574,
    "lng": -90.3036904,
    "formatted_address": "5640 Telegraph Rd, St. Louis, MO 63129, USA",
    "place_id": "ChIJJTB7cvTH2IcRArJL5ks3DFM",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0481",
    "chain": "Dierbergs",
    "name": "Dierbergs #15",
    "store_number": "15",
    "address": "12595 Olive Boulevard",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63141",
    "source_sheet": "Dierberg's",
    "source_row": 18,
    "lat": 38.67745300000001,
    "lng": -90.4636403,
    "formatted_address": "12595 Olive Blvd, St. Louis, MO 63141, USA",
    "place_id": "ChIJWfFIRGkt34cRRtHiBpZO9Z8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0482",
    "chain": "Dierbergs",
    "name": "Dierbergs #16",
    "store_number": "16",
    "address": "6211 Mid Rivers Mall Drive",
    "city": "St. Peters",
    "state": "MO",
    "zip": "63304",
    "source_sheet": "Dierberg's",
    "source_row": 19,
    "lat": 38.740735,
    "lng": -90.63707459999999,
    "formatted_address": "6211 Mid Rivers Mall Dr, St Peters, MO 63304, USA",
    "place_id": "ChIJTRhV033W3ocRVE41qk4ZSeE",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0483",
    "chain": "Dierbergs",
    "name": "Dierbergs #17",
    "store_number": "17",
    "address": "2979 State Highway K",
    "city": "O'Fallon",
    "state": "MO",
    "zip": "63368",
    "source_sheet": "Dierberg's",
    "source_row": 20,
    "lat": 38.7589277,
    "lng": -90.702812,
    "formatted_address": "2979 State Hwy K, O'Fallon, MO 63368, USA",
    "place_id": "ChIJTVxJJxfR3ocRzCwqGAwi1e0",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0484",
    "chain": "Dierbergs",
    "name": "Dierbergs #18",
    "store_number": "18",
    "address": "450 Old Smizer Mill Road",
    "city": "Bonhomme Township",
    "state": "MO",
    "zip": "63026",
    "source_sheet": "Dierberg's",
    "source_row": 21,
    "lat": 38.5135265,
    "lng": -90.45038420000002,
    "formatted_address": "450 Old Smizer Mill Rd, Fenton, MO 63026, USA",
    "place_id": "ChIJVyNFftjP2IcRBZXoh32Q-_8",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0485",
    "chain": "Dierbergs",
    "name": "Dierbergs #19",
    "store_number": "19",
    "address": "8450 Eager Road",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63144",
    "source_sheet": "Dierberg's",
    "source_row": 22,
    "lat": 38.62823820000001,
    "lng": -90.3401287,
    "formatted_address": "8450 Eager Rd, St. Louis, MO 63144, USA",
    "place_id": "ChIJyaqgWB7L2IcR4xVOvrqu1AE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0486",
    "chain": "Dierbergs",
    "name": "Dierbergs #20",
    "store_number": "20",
    "address": "4000 Green Mount Crossing Drive",
    "city": "Shiloh",
    "state": "IL",
    "zip": "62269",
    "source_sheet": "Dierberg's",
    "source_row": 23,
    "lat": 38.5711371,
    "lng": -89.9271821,
    "formatted_address": "4000 Green Mt Crossing Dr, Shiloh, IL 62269, USA",
    "place_id": "ChIJy2IuGlUBdogRSqvi3iszA5Q",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0487",
    "chain": "Dierbergs",
    "name": "Dierbergs #21",
    "store_number": "21",
    "address": "2460 Taylor Road",
    "city": "Wildwood",
    "state": "MO",
    "zip": "63040",
    "source_sheet": "Dierberg's",
    "source_row": 24,
    "lat": 38.5804231,
    "lng": -90.6256566,
    "formatted_address": "2460 Taylor Rd, Grover, MO 63040, USA",
    "place_id": "ChIJCT1qeDsq2YcRjV3gaDM6HOo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0488",
    "chain": "Dierbergs",
    "name": "Dierbergs #22",
    "store_number": "22",
    "address": "217 Salt Lick Road",
    "city": "O'Fallon Township",
    "state": "MO",
    "zip": "63376",
    "source_sheet": "Dierberg's",
    "source_row": 25,
    "lat": 38.8001987,
    "lng": -90.6564437,
    "formatted_address": "217 Salt Lick Rd, St Peters, MO 63376, USA",
    "place_id": "ChIJURC2-WrX3ocRc0RNfWnK9-Q",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0489",
    "chain": "Dierbergs",
    "name": "Dierbergs #23",
    "store_number": "23",
    "address": "1820 Wentzville Parkway",
    "city": "Wentzville",
    "state": "MO",
    "zip": "63385",
    "source_sheet": "Dierberg's",
    "source_row": 26,
    "lat": 38.8194079,
    "lng": -90.8748126,
    "formatted_address": "1820 Wentzville Pkwy, Wentzville, MO 63385, USA",
    "place_id": "ChIJaWYKrNfH3ocR9QQrJnA5XIc",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0490",
    "chain": "Dierbergs",
    "name": "Dierbergs #24",
    "store_number": "24",
    "address": "6671 Edwardsville Crossing Drive",
    "city": "Edwardsville",
    "state": "IL",
    "zip": "62025",
    "source_sheet": "Dierberg's",
    "source_row": 27,
    "lat": 38.7898055,
    "lng": -89.9539277,
    "formatted_address": "6671 Edwardsville Crossing Dr, Edwardsville, IL 62025, USA",
    "place_id": "ChIJRe4FGrD5dYgRlQdHre2fyPE",
    "geocode_location_type": "GEOMETRIC_CENTER"
  },
  {
    "id": "pb-0491",
    "chain": "Dierbergs",
    "name": "Dierbergs #25",
    "store_number": "25",
    "address": "4655 Osage Beach Parkway",
    "city": "Osage Beach",
    "state": "MO",
    "zip": "65065",
    "source_sheet": "Dierberg's",
    "source_row": 28,
    "lat": 38.1305014,
    "lng": -92.6360234,
    "formatted_address": "4655 Osage Beach Pkwy, Osage Beach, MO 65065, USA",
    "place_id": "ChIJO-4FTEbFxIcRC2hUfAc_PWo",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0492",
    "chain": "Dierbergs",
    "name": "Dierbergs #26",
    "store_number": "26",
    "address": "6450 Ronald Reagan Drive",
    "city": "Lake Saint Louis",
    "state": "MO",
    "zip": "63367",
    "source_sheet": "Dierberg's",
    "source_row": 29,
    "lat": 38.7653656,
    "lng": -90.78719319999999,
    "formatted_address": "6450 Ronald Reagan Dr, Lake St Louis, MO 63367, USA",
    "place_id": "ChIJV7Yw41nO3ocRxlHRt3eQpyk",
    "geocode_location_type": "ROOFTOP"
  },
  {
    "id": "pb-0493",
    "chain": "Dierbergs",
    "name": "Dierbergs #27",
    "store_number": "27",
    "address": "9555 Watson Road",
    "city": "Sappington",
    "state": "MO",
    "zip": "63126",
    "source_sheet": "Dierberg's",
    "source_row": 30,
    "lat": 38.5587393,
    "lng": -90.38058579999999,
    "formatted_address": "9555 Watson Rd, Sappington, MO 63126, USA",
    "place_id": "ChIJVbkiFq7O2IcRSgzRTMZbfsM",
    "geocode_location_type": "ROOFTOP"
  }
];
